/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ApiScopeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param httpMethod (optional) 接口方法类型
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param menuId (optional) 菜单主键
     * @param remark (optional) 接口权限备注
     * @param resourceCode (optional) 资源编号
     * @param scopeName (optional) 接口权限名称
     * @param scopePath (optional) 接口权限字段
     * @param scopeType (optional) 接口权限类型
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    detail(createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, httpMethod: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, menuId: string | null | undefined, remark: string | null | undefined, resourceCode: string | null | undefined, scopeName: string | null | undefined, scopePath: string | null | undefined, scopeType: number | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfApiScope> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/api-scope/detail?";
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (httpMethod !== undefined)
            url_ += "httpMethod=" + encodeURIComponent("" + httpMethod) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (menuId !== undefined)
            url_ += "menuId=" + encodeURIComponent("" + menuId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (resourceCode !== undefined)
            url_ += "resourceCode=" + encodeURIComponent("" + resourceCode) + "&"; 
        if (scopeName !== undefined)
            url_ += "scopeName=" + encodeURIComponent("" + scopeName) + "&"; 
        if (scopePath !== undefined)
            url_ += "scopePath=" + encodeURIComponent("" + scopePath) + "&"; 
        if (scopeType !== undefined)
            url_ += "scopeType=" + encodeURIComponent("" + scopeType) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfApiScope> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfApiScope.fromJS(resultData200) : new ROfApiScope();
            return result200;
        }
        return Promise.resolve<ROfApiScope>(<any>null);
    }

    /**
     * 分页
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param httpMethod (optional) 接口方法类型
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param menuId (optional) 菜单主键
     * @param remark (optional) 接口权限备注
     * @param resourceCode (optional) 资源编号
     * @param scopeName (optional) 接口权限名称
     * @param scopePath (optional) 接口权限字段
     * @param scopeType (optional) 接口权限类型
     * @param size (optional) 每页的数量
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    list(createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, httpMethod: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, menuId: string | null | undefined, remark: string | null | undefined, resourceCode: string | null | undefined, scopeName: string | null | undefined, scopePath: string | null | undefined, scopeType: number | null | undefined, size: number | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfApiScopeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/api-scope/list?";
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (httpMethod !== undefined)
            url_ += "httpMethod=" + encodeURIComponent("" + httpMethod) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (menuId !== undefined)
            url_ += "menuId=" + encodeURIComponent("" + menuId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (resourceCode !== undefined)
            url_ += "resourceCode=" + encodeURIComponent("" + resourceCode) + "&"; 
        if (scopeName !== undefined)
            url_ += "scopeName=" + encodeURIComponent("" + scopeName) + "&"; 
        if (scopePath !== undefined)
            url_ += "scopePath=" + encodeURIComponent("" + scopePath) + "&"; 
        if (scopeType !== undefined)
            url_ += "scopeType=" + encodeURIComponent("" + scopeType) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfIPageOfApiScopeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfApiScopeVO.fromJS(resultData200) : new ROfIPageOfApiScopeVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfApiScopeVO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/api-scope/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增
     * @param dataScope dataScope
     * @return OK
     */
    save(dataScope: ApiScope): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/api-scope/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataScope);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param dataScope dataScope
     * @return OK
     */
    submit(dataScope: ApiScope): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/api-scope/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataScope);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param dataScope dataScope
     * @return OK
     */
    update(dataScope: ApiScope): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/api-scope/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataScope);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class MasterlinkApiScopeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 逻辑删除
     * @param id 主键
     * @return OK
     */
    deleteMenuApi(id: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apis/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMenuApi(_response);
        });
    }

    protected processDeleteMenuApi(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class AppExtendServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增APP扩展信息
     * @param appExtend appExtend
     * @return OK
     */
    insertAppExtend(appExtend: AppExtend): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/appextend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appExtend);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsertAppExtend(_response);
        });
    }

    protected processInsertAppExtend(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 修改APP扩展信息
     * @param appExtend appExtend
     * @return OK
     */
    updateAppExtend(appExtend: AppExtend): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/appextend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appExtend);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAppExtend(_response);
        });
    }

    protected processUpdateAppExtend(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询APP扩展信息
     * @param id id
     * @return OK
     */
    appId(id: string): Promise<AppExtend> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/appextend/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAppId(_response);
        });
    }

    protected processAppId(response: AxiosResponse): Promise<AppExtend> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AppExtend.fromJS(resultData200) : new AppExtend();
            return result200;
        }
        return Promise.resolve<AppExtend>(<any>null);
    }

    /**
     * 删除APP扩展信息
     * @param id id
     * @return OK
     */
    deleteAppExtend(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/appextend/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteAppExtend(_response);
        });
    }

    protected processDeleteAppExtend(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class AppMenuServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * App绑定菜单
     * @param inputDto inputDto
     * @return OK
     */
    bindMenuId(inputDto: AppMenuInputDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/appmenus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBindMenuId(_response);
        });
    }

    protected processBindMenuId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取已授权给我的APP下的菜单
     * @param appCode appCode
     * @param subAccountRoleId (optional) subAccountRoleId
     * @return OK
     */
    getAppAuthorizedMenus(appCode: string, subAccountRoleId: string | null | undefined): Promise<AppMenusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/appmenus/{appCode}/authorized-menus?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined.");
        url_ = url_.replace("{appCode}", encodeURIComponent("" + appCode)); 
        if (subAccountRoleId !== undefined)
            url_ += "subAccountRoleId=" + encodeURIComponent("" + subAccountRoleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAppAuthorizedMenus(_response);
        });
    }

    protected processGetAppAuthorizedMenus(response: AxiosResponse): Promise<AppMenusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AppMenusVO.fromJS(resultData200) : new AppMenusVO();
            return result200;
        }
        return Promise.resolve<AppMenusVO>(<any>null);
    }

    /**
     * 获取App下的页面菜单和页面元素信息
     * @param appCode appCode
     * @param roleId roleId
     * @return OK
     */
    getAppMenus(appCode: string, roleId: string): Promise<AppMenusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/appmenus/{appCode}/menus?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined.");
        url_ = url_.replace("{appCode}", encodeURIComponent("" + appCode)); 
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined and cannot be null.");
        else
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAppMenus(_response);
        });
    }

    protected processGetAppMenus(response: AxiosResponse): Promise<AppMenusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AppMenusVO.fromJS(resultData200) : new AppMenusVO();
            return result200;
        }
        return Promise.resolve<AppMenusVO>(<any>null);
    }

    /**
     * 查询APP菜单信息
     * @param appId id
     * @return OK
     */
    appId(appId: string): Promise<MasterlinkMenuTreeNode[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/appmenus/{appId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAppId(_response);
        });
    }

    protected processAppId(response: AxiosResponse): Promise<MasterlinkMenuTreeNode[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterlinkMenuTreeNode.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MasterlinkMenuTreeNode[]>(<any>null);
    }
}

export class AppServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增APP
     * @param app app
     * @return OK
     */
    insertApp(app: App): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(app);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsertApp(_response);
        });
    }

    protected processInsertApp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑APP
     * @param app app
     * @return OK
     */
    updateApp(app: App): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(app);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateApp(_response);
        });
    }

    protected processUpdateApp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 发布APP
     * @param appStatusInputDTO appStatusInputDTO
     * @return OK
     */
    deployApp(appStatusInputDTO: AppStatusInputDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apps/deployApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appStatusInputDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeployApp(_response);
        });
    }

    protected processDeployApp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据关键字模糊查询
     * @param current (optional) 当前页
     * @param keyWords (optional) 关键字
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageForCode(current: number | null | undefined, keyWords: string | null | undefined, size: number | null | undefined): Promise<IPageOfApp> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apps/list?";
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageForCode(_response);
        });
    }

    protected processPageForCode(response: AxiosResponse): Promise<IPageOfApp> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfApp.fromJS(resultData200) : new IPageOfApp();
            return result200;
        }
        return Promise.resolve<IPageOfApp>(<any>null);
    }

    /**
     * 自定义分页查询
     * @param audience (optional) app受众
     * @param code (optional) app编号
     * @param current (optional) 当前页
     * @param displayName (optional) app名称
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(audience: string | null | undefined, code: string | null | undefined, current: number | null | undefined, displayName: string | null | undefined, size: number | null | undefined): Promise<IPageOfApp> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apps/page?";
        if (audience !== undefined)
            url_ += "audience=" + encodeURIComponent("" + audience) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (displayName !== undefined)
            url_ += "displayName=" + encodeURIComponent("" + displayName) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfApp> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfApp.fromJS(resultData200) : new IPageOfApp();
            return result200;
        }
        return Promise.resolve<IPageOfApp>(<any>null);
    }

    /**
     * upgradeApp
     * @param app app
     * @return OK
     */
    upgradeApp(app: App): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apps/upgradeApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(app);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpgradeApp(_response);
        });
    }

    protected processUpgradeApp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询APP
     * @param id id
     * @return OK
     */
    appId(id: string): Promise<App> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAppId(_response);
        });
    }

    protected processAppId(response: AxiosResponse): Promise<App> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? App.fromJS(resultData200) : new App();
            return result200;
        }
        return Promise.resolve<App>(<any>null);
    }

    /**
     * 删除APP
     * @param id id
     * @return OK
     */
    deleteApp(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/apps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteApp(_response);
        });
    }

    protected processDeleteApp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class AppCardServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获得当前租户下的APP卡片
     * @return OK
     */
    getCurrentTenantAPPCard(): Promise<AppCardDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentTenantAPPCard(_response);
        });
    }

    protected processGetCurrentTenantAPPCard(response: AxiosResponse): Promise<AppCardDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppCardDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AppCardDTO[]>(<any>null);
    }

    /**
     * 新增APP卡片
     * @param appCard appCard
     * @return OK
     */
    insertAppCard(appCard: AppCard): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appCard);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsertAppCard(_response);
        });
    }

    protected processInsertAppCard(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新APP卡片
     * @param appCard appCard
     * @return OK
     */
    updateAppCard(appCard: AppCard): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appCard);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAppCard(_response);
        });
    }

    protected processUpdateAppCard(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取所有卡片记录
     * @return OK
     */
    list(): Promise<AppCard[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<AppCard[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppCard.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AppCard[]>(<any>null);
    }

    /**
     * 自定义分页查询
     * @param appId (optional) appId
     * @param current (optional) 当前页
     * @param edition (optional) 版本
     * @param keyWords (optional) 关键词
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(appId: string | null | undefined, current: number | null | undefined, edition: any | null | undefined, keyWords: string | null | undefined, size: number | null | undefined): Promise<IPageOfAppCard> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card/page?";
        if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&"; 
        if (edition !== undefined)
            url_ += "edition=" + encodeURIComponent("" + edition) + "&"; 
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfAppCard> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfAppCard.fromJS(resultData200) : new IPageOfAppCard();
            return result200;
        }
        return Promise.resolve<IPageOfAppCard>(<any>null);
    }

    /**
     * 批量删除卡片
     * @param cardIds cardIds
     * @return OK
     */
    deleteCards(cardIds: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteCards(_response);
        });
    }

    protected processDeleteCards(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除APP卡片
     * @param id id
     * @return OK
     */
    deleteAppCard(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteAppCard(_response);
        });
    }

    protected processDeleteAppCard(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获得指定租户下的APP卡片
     * @param tenantId tenantId
     * @return OK
     */
    getCardForTenant(tenantId: string): Promise<AppCardDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCardForTenant(_response);
        });
    }

    protected processGetCardForTenant(response: AxiosResponse): Promise<AppCardDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppCardDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AppCardDTO[]>(<any>null);
    }
}

export class AppCardScopeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增关联权限
     * @param appCardScope appCardScope
     * @return OK
     */
    relatePermission(appCardScope: AppCardScope): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appCardScope);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRelatePermission(_response);
        });
    }

    protected processRelatePermission(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询api权限列表
     * @param cardId (optional) 卡片名称
     * @param resourceCode (optional) 权限编号
     * @param scopeName (optional) 权限名称
     * @return OK
     */
    getScopeList(cardId: string | null | undefined, resourceCode: string | null | undefined, scopeName: string | null | undefined): Promise<AppCardScopeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card-api/list?";
        if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&"; 
        if (resourceCode !== undefined)
            url_ += "resourceCode=" + encodeURIComponent("" + resourceCode) + "&"; 
        if (scopeName !== undefined)
            url_ += "scopeName=" + encodeURIComponent("" + scopeName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetScopeList(_response);
        });
    }

    protected processGetScopeList(response: AxiosResponse): Promise<AppCardScopeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppCardScopeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AppCardScopeVO[]>(<any>null);
    }

    /**
     * 取消关联权限
     * @param id id
     * @return OK
     */
    removePermission(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/card-api/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemovePermission(_response);
        });
    }

    protected processRemovePermission(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class AuthClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param accessTokenValidity (optional) 令牌过期秒数
     * @param additionalInformation (optional) 附加说明
     * @param authorities (optional) 权限
     * @param authorizedGrantTypes (optional) 授权类型
     * @param autoapprove (optional) 自动授权
     * @param clientId (optional) 客户端id
     * @param clientSecret (optional) 客户端密钥
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param refreshTokenValidity (optional) 刷新令牌过期秒数
     * @param resourceIds (optional) 资源集合
     * @param scope (optional) 授权范围
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @param webServerRedirectUri (optional) 回调地址
     * @return OK
     */
    detail(accessTokenValidity: number | null | undefined, additionalInformation: string | null | undefined, authorities: string | null | undefined, authorizedGrantTypes: string | null | undefined, autoapprove: string | null | undefined, clientId: string | null | undefined, clientSecret: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, refreshTokenValidity: number | null | undefined, resourceIds: string | null | undefined, scope: string | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined, webServerRedirectUri: string | null | undefined): Promise<ROfAuthClient> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/client/detail?";
        if (accessTokenValidity !== undefined)
            url_ += "accessTokenValidity=" + encodeURIComponent("" + accessTokenValidity) + "&"; 
        if (additionalInformation !== undefined)
            url_ += "additionalInformation=" + encodeURIComponent("" + additionalInformation) + "&"; 
        if (authorities !== undefined)
            url_ += "authorities=" + encodeURIComponent("" + authorities) + "&"; 
        if (authorizedGrantTypes !== undefined)
            url_ += "authorizedGrantTypes=" + encodeURIComponent("" + authorizedGrantTypes) + "&"; 
        if (autoapprove !== undefined)
            url_ += "autoapprove=" + encodeURIComponent("" + autoapprove) + "&"; 
        if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&"; 
        if (clientSecret !== undefined)
            url_ += "clientSecret=" + encodeURIComponent("" + clientSecret) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (refreshTokenValidity !== undefined)
            url_ += "refreshTokenValidity=" + encodeURIComponent("" + refreshTokenValidity) + "&"; 
        if (resourceIds !== undefined)
            url_ += "resourceIds=" + encodeURIComponent("" + resourceIds) + "&"; 
        if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        if (webServerRedirectUri !== undefined)
            url_ += "webServerRedirectUri=" + encodeURIComponent("" + webServerRedirectUri) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfAuthClient> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAuthClient.fromJS(resultData200) : new ROfAuthClient();
            return result200;
        }
        return Promise.resolve<ROfAuthClient>(<any>null);
    }

    /**
     * 分页
     * @param accessTokenValidity (optional) 令牌过期秒数
     * @param additionalInformation (optional) 附加说明
     * @param authorities (optional) 权限
     * @param authorizedGrantTypes (optional) 授权类型
     * @param autoapprove (optional) 自动授权
     * @param clientId (optional) 客户端id
     * @param clientSecret (optional) 客户端密钥
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param refreshTokenValidity (optional) 刷新令牌过期秒数
     * @param resourceIds (optional) 资源集合
     * @param scope (optional) 授权范围
     * @param size (optional) 每页的数量
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @param webServerRedirectUri (optional) 回调地址
     * @return OK
     */
    list(accessTokenValidity: number | null | undefined, additionalInformation: string | null | undefined, authorities: string | null | undefined, authorizedGrantTypes: string | null | undefined, autoapprove: string | null | undefined, clientId: string | null | undefined, clientSecret: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, refreshTokenValidity: number | null | undefined, resourceIds: string | null | undefined, scope: string | null | undefined, size: number | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined, webServerRedirectUri: string | null | undefined): Promise<ROfIPageOfAuthClient> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/client/list?";
        if (accessTokenValidity !== undefined)
            url_ += "accessTokenValidity=" + encodeURIComponent("" + accessTokenValidity) + "&"; 
        if (additionalInformation !== undefined)
            url_ += "additionalInformation=" + encodeURIComponent("" + additionalInformation) + "&"; 
        if (authorities !== undefined)
            url_ += "authorities=" + encodeURIComponent("" + authorities) + "&"; 
        if (authorizedGrantTypes !== undefined)
            url_ += "authorizedGrantTypes=" + encodeURIComponent("" + authorizedGrantTypes) + "&"; 
        if (autoapprove !== undefined)
            url_ += "autoapprove=" + encodeURIComponent("" + autoapprove) + "&"; 
        if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&"; 
        if (clientSecret !== undefined)
            url_ += "clientSecret=" + encodeURIComponent("" + clientSecret) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (refreshTokenValidity !== undefined)
            url_ += "refreshTokenValidity=" + encodeURIComponent("" + refreshTokenValidity) + "&"; 
        if (resourceIds !== undefined)
            url_ += "resourceIds=" + encodeURIComponent("" + resourceIds) + "&"; 
        if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        if (webServerRedirectUri !== undefined)
            url_ += "webServerRedirectUri=" + encodeURIComponent("" + webServerRedirectUri) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfIPageOfAuthClient> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfAuthClient.fromJS(resultData200) : new ROfIPageOfAuthClient();
            return result200;
        }
        return Promise.resolve<ROfIPageOfAuthClient>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/client/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增
     * @param authClient authClient
     * @return OK
     */
    save(authClient: AuthClient): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/client/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authClient);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param authClient authClient
     * @return OK
     */
    submit(authClient: AuthClient): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/client/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authClient);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param authClient authClient
     * @return OK
     */
    update(authClient: AuthClient): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/client/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authClient);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class DataScopeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param menuId (optional) 菜单主键
     * @param remark (optional) 数据权限备注
     * @param resourceCode (optional) 资源编号
     * @param scopeClass (optional) 数据权限类名
     * @param scopeColumn (optional) 数据权限字段
     * @param scopeField (optional) 数据权限可见字段
     * @param scopeName (optional) 数据权限名称
     * @param scopeType (optional) 数据权限类型
     * @param scopeValue (optional) 数据权限值域
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    detail(createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, menuId: string | null | undefined, remark: string | null | undefined, resourceCode: string | null | undefined, scopeClass: string | null | undefined, scopeColumn: string | null | undefined, scopeField: string | null | undefined, scopeName: string | null | undefined, scopeType: number | null | undefined, scopeValue: string | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfDataScope> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/data-scope/detail?";
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (menuId !== undefined)
            url_ += "menuId=" + encodeURIComponent("" + menuId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (resourceCode !== undefined)
            url_ += "resourceCode=" + encodeURIComponent("" + resourceCode) + "&"; 
        if (scopeClass !== undefined)
            url_ += "scopeClass=" + encodeURIComponent("" + scopeClass) + "&"; 
        if (scopeColumn !== undefined)
            url_ += "scopeColumn=" + encodeURIComponent("" + scopeColumn) + "&"; 
        if (scopeField !== undefined)
            url_ += "scopeField=" + encodeURIComponent("" + scopeField) + "&"; 
        if (scopeName !== undefined)
            url_ += "scopeName=" + encodeURIComponent("" + scopeName) + "&"; 
        if (scopeType !== undefined)
            url_ += "scopeType=" + encodeURIComponent("" + scopeType) + "&"; 
        if (scopeValue !== undefined)
            url_ += "scopeValue=" + encodeURIComponent("" + scopeValue) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfDataScope> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDataScope.fromJS(resultData200) : new ROfDataScope();
            return result200;
        }
        return Promise.resolve<ROfDataScope>(<any>null);
    }

    /**
     * 分页
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param menuId (optional) 菜单主键
     * @param remark (optional) 数据权限备注
     * @param resourceCode (optional) 资源编号
     * @param scopeClass (optional) 数据权限类名
     * @param scopeColumn (optional) 数据权限字段
     * @param scopeField (optional) 数据权限可见字段
     * @param scopeName (optional) 数据权限名称
     * @param scopeType (optional) 数据权限类型
     * @param scopeValue (optional) 数据权限值域
     * @param size (optional) 每页的数量
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    list(createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, menuId: string | null | undefined, remark: string | null | undefined, resourceCode: string | null | undefined, scopeClass: string | null | undefined, scopeColumn: string | null | undefined, scopeField: string | null | undefined, scopeName: string | null | undefined, scopeType: number | null | undefined, scopeValue: string | null | undefined, size: number | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfDataScopeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/data-scope/list?";
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (menuId !== undefined)
            url_ += "menuId=" + encodeURIComponent("" + menuId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (resourceCode !== undefined)
            url_ += "resourceCode=" + encodeURIComponent("" + resourceCode) + "&"; 
        if (scopeClass !== undefined)
            url_ += "scopeClass=" + encodeURIComponent("" + scopeClass) + "&"; 
        if (scopeColumn !== undefined)
            url_ += "scopeColumn=" + encodeURIComponent("" + scopeColumn) + "&"; 
        if (scopeField !== undefined)
            url_ += "scopeField=" + encodeURIComponent("" + scopeField) + "&"; 
        if (scopeName !== undefined)
            url_ += "scopeName=" + encodeURIComponent("" + scopeName) + "&"; 
        if (scopeType !== undefined)
            url_ += "scopeType=" + encodeURIComponent("" + scopeType) + "&"; 
        if (scopeValue !== undefined)
            url_ += "scopeValue=" + encodeURIComponent("" + scopeValue) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfIPageOfDataScopeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfDataScopeVO.fromJS(resultData200) : new ROfIPageOfDataScopeVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfDataScopeVO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/data-scope/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增
     * @param dataScope dataScope
     * @return OK
     */
    save(dataScope: DataScope): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/data-scope/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataScope);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param dataScope dataScope
     * @return OK
     */
    submit(dataScope: DataScope): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/data-scope/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataScope);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param dataScope dataScope
     * @return OK
     */
    update(dataScope: DataScope): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/data-scope/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataScope);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class DeptServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param ancestors (optional) 祖级机构主键
     * @param deptCategory (optional) 机构类型
     * @param deptName (optional) 机构名
     * @param fullName (optional) 机构全称
     * @param id (optional) 主键
     * @param isDeleted (optional) 是否已删除
     * @param isEnable (optional) 是否已启用
     * @param parentId (optional) 父主键
     * @param remark (optional) 备注
     * @param sort (optional) 排序
     * @param tenantId (optional) 租户ID
     * @return OK
     */
    detail(ancestors: string | null | undefined, deptCategory: number | null | undefined, deptName: string | null | undefined, fullName: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, isEnable: number | null | undefined, parentId: string | null | undefined, remark: string | null | undefined, sort: number | null | undefined, tenantId: string | null | undefined): Promise<ROfDeptVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dept/detail?";
        if (ancestors !== undefined)
            url_ += "ancestors=" + encodeURIComponent("" + ancestors) + "&"; 
        if (deptCategory !== undefined)
            url_ += "deptCategory=" + encodeURIComponent("" + deptCategory) + "&"; 
        if (deptName !== undefined)
            url_ += "deptName=" + encodeURIComponent("" + deptName) + "&"; 
        if (fullName !== undefined)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (isEnable !== undefined)
            url_ += "isEnable=" + encodeURIComponent("" + isEnable) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfDeptVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDeptVO.fromJS(resultData200) : new ROfDeptVO();
            return result200;
        }
        return Promise.resolve<ROfDeptVO>(<any>null);
    }

    /**
     * 懒加载列表
     * @param deptName (optional) 部门名称
     * @param fullName (optional) 部门全称
     * @param parentId (optional) parentId
     * @return OK
     */
    lazyList(deptName: string | null | undefined, fullName: string | null | undefined, parentId: string | null | undefined): Promise<ROfListOfDeptVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dept/lazy-list?";
        if (deptName !== undefined)
            url_ += "deptName=" + encodeURIComponent("" + deptName) + "&"; 
        if (fullName !== undefined)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyList(_response);
        });
    }

    protected processLazyList(response: AxiosResponse): Promise<ROfListOfDeptVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeptVO.fromJS(resultData200) : new ROfListOfDeptVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeptVO>(<any>null);
    }

    /**
     * 懒加载树形结构
     * @param parentId (optional) parentId
     * @param tenantId (optional) tenantId
     * @return OK
     */
    lazyTree(parentId: string | null | undefined, tenantId: string | null | undefined): Promise<ROfListOfDeptVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dept/lazy-tree?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyTree(_response);
        });
    }

    protected processLazyTree(response: AxiosResponse): Promise<ROfListOfDeptVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeptVO.fromJS(resultData200) : new ROfListOfDeptVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeptVO>(<any>null);
    }

    /**
     * 列表
     * @param deptName (optional) 部门名称
     * @param fullName (optional) 部门全称
     * @return OK
     */
    list(deptName: string | null | undefined, fullName: string | null | undefined): Promise<ROfListOfDeptVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dept/list?";
        if (deptName !== undefined)
            url_ += "deptName=" + encodeURIComponent("" + deptName) + "&"; 
        if (fullName !== undefined)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfListOfDeptVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeptVO.fromJS(resultData200) : new ROfListOfDeptVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeptVO>(<any>null);
    }

    /**
     * 删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dept/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param dept dept
     * @return OK
     */
    submit(dept: Dept): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dept/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dept);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 树形结构
     * @param tenantId (optional) tenantId
     * @return OK
     */
    tree(tenantId: string | null | undefined): Promise<ROfListOfDeptVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dept/tree?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<ROfListOfDeptVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeptVO.fromJS(resultData200) : new ROfListOfDeptVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeptVO>(<any>null);
    }
}

export class MasterlinkDeptServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 懒加载树形结构
     * @param parentId (optional) parentId
     * @param tenantId (optional) tenantId
     * @return OK
     */
    lazyTree(parentId: string | null | undefined, tenantId: string | null | undefined): Promise<ROfListOfMTreeNode> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/depts/lazy-tree?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyTree(_response);
        });
    }

    protected processLazyTree(response: AxiosResponse): Promise<ROfListOfMTreeNode> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMTreeNode.fromJS(resultData200) : new ROfListOfMTreeNode();
            return result200;
        }
        return Promise.resolve<ROfListOfMTreeNode>(<any>null);
    }

    /**
     * 树形结构
     * @param tenantId (optional) tenantId
     * @return OK
     */
    tree(tenantId: string | null | undefined): Promise<ROfListOfMTreeNode> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/depts/tree?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<ROfListOfMTreeNode> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMTreeNode.fromJS(resultData200) : new ROfListOfMTreeNode();
            return result200;
        }
        return Promise.resolve<ROfListOfMTreeNode>(<any>null);
    }
}

export class DictBizServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 列表
     * @param code (optional) 字典编号
     * @param dictValue (optional) 字典名称
     * @param parentId (optional) 字典名称
     * @return OK
     */
    childList(code: string | null | undefined, dictValue: string | null | undefined, parentId: string | null | undefined): Promise<ROfListOfDictBizVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/child-list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (dictValue !== undefined)
            url_ += "dictValue=" + encodeURIComponent("" + dictValue) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChildList(_response);
        });
    }

    protected processChildList(response: AxiosResponse): Promise<ROfListOfDictBizVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictBizVO.fromJS(resultData200) : new ROfListOfDictBizVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictBizVO>(<any>null);
    }

    /**
     * 详情
     * @param code (optional) 字典码
     * @param dictKey (optional) 字典值
     * @param dictValue (optional) 字典名称
     * @param id (optional) 主键
     * @param isDeleted (optional) 是否已删除
     * @param isSealed (optional) 是否已封存
     * @param parentId (optional) 父主键
     * @param remark (optional) 字典备注
     * @param sort (optional) 排序
     * @param tenantId (optional) 租户ID
     * @return OK
     */
    detail(code: string | null | undefined, dictKey: string | null | undefined, dictValue: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, isSealed: number | null | undefined, parentId: string | null | undefined, remark: string | null | undefined, sort: number | null | undefined, tenantId: string | null | undefined): Promise<ROfDictBizVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/detail?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (dictKey !== undefined)
            url_ += "dictKey=" + encodeURIComponent("" + dictKey) + "&"; 
        if (dictValue !== undefined)
            url_ += "dictValue=" + encodeURIComponent("" + dictValue) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (isSealed !== undefined)
            url_ += "isSealed=" + encodeURIComponent("" + isSealed) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfDictBizVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDictBizVO.fromJS(resultData200) : new ROfDictBizVO();
            return result200;
        }
        return Promise.resolve<ROfDictBizVO>(<any>null);
    }

    /**
     * 获取字典
     * @param code (optional) code
     * @return OK
     */
    dictionary(code: string | null | undefined): Promise<ROfListOfDictBiz> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/dictionary?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDictionary(_response);
        });
    }

    protected processDictionary(response: AxiosResponse): Promise<ROfListOfDictBiz> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictBiz.fromJS(resultData200) : new ROfListOfDictBiz();
            return result200;
        }
        return Promise.resolve<ROfListOfDictBiz>(<any>null);
    }

    /**
     * 获取字典
     * @param code (optional) code
     * @param remark (optional) remark
     * @return OK
     */
    dictionaryExtend(code: string | null | undefined, remark: string | null | undefined): Promise<ROfListOfDictBiz> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/dictionary-extend?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDictionaryExtend(_response);
        });
    }

    protected processDictionaryExtend(response: AxiosResponse): Promise<ROfListOfDictBiz> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictBiz.fromJS(resultData200) : new ROfListOfDictBiz();
            return result200;
        }
        return Promise.resolve<ROfListOfDictBiz>(<any>null);
    }

    /**
     * 获取字典树
     * @param code (optional) code
     * @return OK
     */
    dictionaryTree(code: string | null | undefined): Promise<ROfListOfDictBizVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/dictionary-tree?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDictionaryTree(_response);
        });
    }

    protected processDictionaryTree(response: AxiosResponse): Promise<ROfListOfDictBizVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictBizVO.fromJS(resultData200) : new ROfListOfDictBizVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictBizVO>(<any>null);
    }

    /**
     * 列表
     * @param code (optional) 字典编号
     * @param dictValue (optional) 字典名称
     * @return OK
     */
    list(code: string | null | undefined, dictValue: string | null | undefined): Promise<ROfListOfDictBizVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (dictValue !== undefined)
            url_ += "dictValue=" + encodeURIComponent("" + dictValue) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfListOfDictBizVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictBizVO.fromJS(resultData200) : new ROfListOfDictBizVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictBizVO>(<any>null);
    }

    /**
     * 列表
     * @param code (optional) 字典编号
     * @param current (optional) 当前页
     * @param dictValue (optional) 字典名称
     * @param size (optional) 每页的数量
     * @return OK
     */
    parentList(code: string | null | undefined, current: number | null | undefined, dictValue: string | null | undefined, size: number | null | undefined): Promise<ROfIPageOfDictBizVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/parent-list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (dictValue !== undefined)
            url_ += "dictValue=" + encodeURIComponent("" + dictValue) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processParentList(_response);
        });
    }

    protected processParentList(response: AxiosResponse): Promise<ROfIPageOfDictBizVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfDictBizVO.fromJS(resultData200) : new ROfIPageOfDictBizVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfDictBizVO>(<any>null);
    }

    /**
     * 树形结构
     * @return OK
     */
    parentTree(): Promise<ROfListOfDictBizVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/parent-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processParentTree(_response);
        });
    }

    protected processParentTree(response: AxiosResponse): Promise<ROfListOfDictBizVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictBizVO.fromJS(resultData200) : new ROfListOfDictBizVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictBizVO>(<any>null);
    }

    /**
     * 新增字典项
     * @param createDTO createDTO
     * @return OK
     */
    putDictItem(createDTO: DictBizCreateDTO): Promise<ROfstring> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/put_dict_item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPutDictItem(_response);
        });
    }

    protected processPutDictItem(response: AxiosResponse): Promise<ROfstring> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfstring.fromJS(resultData200) : new ROfstring();
            return result200;
        }
        return Promise.resolve<ROfstring>(<any>null);
    }

    /**
     * 删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 封存字典项目
     * @param id 主键
     * @return OK
     */
    sealedBizDict(id: string): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/sealed?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSealedBizDict(_response);
        });
    }

    protected processSealedBizDict(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 新增或修改
     * @param dict dict
     * @return OK
     */
    submit(dict: DictBiz): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dict);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 树形结构
     * @return OK
     */
    tree(): Promise<ROfListOfDictBizVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict-biz/tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<ROfListOfDictBizVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictBizVO.fromJS(resultData200) : new ROfListOfDictBizVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictBizVO>(<any>null);
    }
}

export class DictServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 列表
     * @param code (optional) 字典编号
     * @param dictValue (optional) 字典名称
     * @param parentId (optional) 字典名称
     * @return OK
     */
    childList(code: string | null | undefined, dictValue: string | null | undefined, parentId: string | null | undefined): Promise<ROfListOfDictVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/child-list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (dictValue !== undefined)
            url_ += "dictValue=" + encodeURIComponent("" + dictValue) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChildList(_response);
        });
    }

    protected processChildList(response: AxiosResponse): Promise<ROfListOfDictVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictVO.fromJS(resultData200) : new ROfListOfDictVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictVO>(<any>null);
    }

    /**
     * 详情
     * @param code (optional) 字典码
     * @param dictKey (optional) 字典值
     * @param dictValue (optional) 字典名称
     * @param id (optional) 主键
     * @param isDeleted (optional) 是否已删除
     * @param isSealed (optional) 是否已封存
     * @param parentId (optional) 父主键
     * @param remark (optional) 字典备注
     * @param sort (optional) 排序
     * @return OK
     */
    detail(code: string | null | undefined, dictKey: string | null | undefined, dictValue: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, isSealed: number | null | undefined, parentId: string | null | undefined, remark: string | null | undefined, sort: number | null | undefined): Promise<ROfDictVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/detail?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (dictKey !== undefined)
            url_ += "dictKey=" + encodeURIComponent("" + dictKey) + "&"; 
        if (dictValue !== undefined)
            url_ += "dictValue=" + encodeURIComponent("" + dictValue) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (isSealed !== undefined)
            url_ += "isSealed=" + encodeURIComponent("" + isSealed) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfDictVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDictVO.fromJS(resultData200) : new ROfDictVO();
            return result200;
        }
        return Promise.resolve<ROfDictVO>(<any>null);
    }

    /**
     * 获取字典
     * @param code (optional) code
     * @return OK
     */
    dictionary(code: string | null | undefined): Promise<ROfListOfDict> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/dictionary?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDictionary(_response);
        });
    }

    protected processDictionary(response: AxiosResponse): Promise<ROfListOfDict> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDict.fromJS(resultData200) : new ROfListOfDict();
            return result200;
        }
        return Promise.resolve<ROfListOfDict>(<any>null);
    }

    /**
     * 获取字典树
     * @param code (optional) code
     * @return OK
     */
    dictionaryTree(code: string | null | undefined): Promise<ROfListOfDictVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/dictionary-tree?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDictionaryTree(_response);
        });
    }

    protected processDictionaryTree(response: AxiosResponse): Promise<ROfListOfDictVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictVO.fromJS(resultData200) : new ROfListOfDictVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictVO>(<any>null);
    }

    /**
     * 列表
     * @param code (optional) 字典编号
     * @param dictValue (optional) 字典名称
     * @return OK
     */
    list(code: string | null | undefined, dictValue: string | null | undefined): Promise<ROfListOfDictVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (dictValue !== undefined)
            url_ += "dictValue=" + encodeURIComponent("" + dictValue) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfListOfDictVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictVO.fromJS(resultData200) : new ROfListOfDictVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictVO>(<any>null);
    }

    /**
     * 列表
     * @param code (optional) 字典编号
     * @param current (optional) 当前页
     * @param dictValue (optional) 字典名称
     * @param size (optional) 每页的数量
     * @return OK
     */
    parentList(code: string | null | undefined, current: number | null | undefined, dictValue: string | null | undefined, size: number | null | undefined): Promise<ROfIPageOfDictVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/parent-list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (dictValue !== undefined)
            url_ += "dictValue=" + encodeURIComponent("" + dictValue) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processParentList(_response);
        });
    }

    protected processParentList(response: AxiosResponse): Promise<ROfIPageOfDictVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfDictVO.fromJS(resultData200) : new ROfIPageOfDictVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfDictVO>(<any>null);
    }

    /**
     * 树形结构
     * @return OK
     */
    parentTree(): Promise<ROfListOfDictVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/parent-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processParentTree(_response);
        });
    }

    protected processParentTree(response: AxiosResponse): Promise<ROfListOfDictVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictVO.fromJS(resultData200) : new ROfListOfDictVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictVO>(<any>null);
    }

    /**
     * 删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param dict dict
     * @return OK
     */
    submit(dict: Dict): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dict);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 树形结构
     * @return OK
     */
    tree(): Promise<ROfListOfDictVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/dict/tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<ROfListOfDictVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDictVO.fromJS(resultData200) : new ROfListOfDictVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDictVO>(<any>null);
    }
}

export class FieldSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 保存或修改字段设置
     * @param fieldSettingDTOList fieldSettingDTOList
     * @return OK
     */
    saveOrUpdateFieldSetting(fieldSettingDTOList: FieldSettingDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/field-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fieldSettingDTOList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveOrUpdateFieldSetting(_response);
        });
    }

    protected processSaveOrUpdateFieldSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询所有字段
     * @param bizType bizType
     * @return OK
     */
    listFieldSettings(bizType: string): Promise<FieldSettingVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/field-setting/list?";
        if (bizType === undefined || bizType === null)
            throw new Error("The parameter 'bizType' must be defined and cannot be null.");
        else
            url_ += "bizType=" + encodeURIComponent("" + bizType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListFieldSettings(_response);
        });
    }

    protected processListFieldSettings(response: AxiosResponse): Promise<FieldSettingVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldSettingVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FieldSettingVO[]>(<any>null);
    }
}

export class GalleryFileServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 文件更换图库
     * @param galleryChangeDto galleryChangeDto
     * @return OK
     */
    changeGallery(galleryChangeDto: GalleryChangeDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery-file/change-gallery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(galleryChangeDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangeGallery(_response);
        });
    }

    protected processChangeGallery(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 分页
     * @param contentType (optional) 文件mini类型
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param fileName (optional) 文件名称
     * @param galleryId 图库id
     * @param id (optional) 主键
     * @param isDeleted (optional) 是否已删除
     * @param objectKey (optional) 文件key
     * @param size (optional) 每页的数量
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    page(contentType: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, fileName: string | null | undefined, galleryId: string, id: string | null | undefined, isDeleted: number | null | undefined, objectKey: string | null | undefined, size: number | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfGalleryFileVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery-file/page?";
        if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        if (galleryId === undefined || galleryId === null)
            throw new Error("The parameter 'galleryId' must be defined and cannot be null.");
        else
            url_ += "galleryId=" + encodeURIComponent("" + galleryId) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (objectKey !== undefined)
            url_ += "objectKey=" + encodeURIComponent("" + objectKey) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ROfIPageOfGalleryFileVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfGalleryFileVO.fromJS(resultData200) : new ROfIPageOfGalleryFileVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfGalleryFileVO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery-file/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param galleryFile galleryFile
     * @return OK
     */
    rename(galleryFile: GalleryFileRenameDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery-file/rename";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(galleryFile);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRename(_response);
        });
    }

    protected processRename(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 上传图片至图库
     * @param galleryFileUploadDTO galleryFileUploadDTO
     * @return OK
     */
    upload(galleryFileUploadDTO: GalleryFileUploadDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery-file/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(galleryFileUploadDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class GalleryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 列表（不分页）
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param galleryName (optional) 图库名称
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    listAll(createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, galleryName: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfListOfGalleryVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery/list-all?";
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (galleryName !== undefined)
            url_ += "galleryName=" + encodeURIComponent("" + galleryName) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListAll(_response);
        });
    }

    protected processListAll(response: AxiosResponse): Promise<ROfListOfGalleryVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfGalleryVO.fromJS(resultData200) : new ROfListOfGalleryVO();
            return result200;
        }
        return Promise.resolve<ROfListOfGalleryVO>(<any>null);
    }

    /**
     * 列表（根据ids排除）
     * @param ids 主键集合
     * @return OK
     */
    listNeIds(ids: string): Promise<ROfListOfGalleryVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery/list-ne-ids?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListNeIds(_response);
        });
    }

    protected processListNeIds(response: AxiosResponse): Promise<ROfListOfGalleryVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfGalleryVO.fromJS(resultData200) : new ROfListOfGalleryVO();
            return result200;
        }
        return Promise.resolve<ROfListOfGalleryVO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids (optional) 主键集合
     * @return OK
     */
    remove(ids: string | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery/remove?";
        if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增
     * @param gallery gallery
     * @return OK
     */
    save(gallery: GallerySaveDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gallery);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param gallery gallery
     * @return OK
     */
    update(gallery: GallerySaveDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/gallery/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gallery);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class HuaWeiCloudServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 参数列表
     * @return OK
     */
    abuttingSaasAccessBiz(): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/huawei";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAbuttingSaasAccessBiz(_response);
        });
    }

    protected processAbuttingSaasAccessBiz(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 华为云数据同步
     * @param imcDTO imcDTO
     * @return OK
     */
    handlerDataSync(imcDTO: ImcDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/huawei/dataSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imcDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHandlerDataSync(_response);
        });
    }

    protected processHandlerDataSync(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class InterfaceConfigServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加接口配置
     * @param interfaceConfigDTO interfaceConfigDTO
     * @return OK
     */
    save(interfaceConfigDTO: InterfaceConfigDTO): Promise<ROflong> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interfaceConfigDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ROflong> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROflong.fromJS(resultData200) : new ROflong();
            return result200;
        }
        return Promise.resolve<ROflong>(<any>null);
    }

    /**
     * 修改接口配置
     * @param interfaceConfigUpdateDTO interfaceConfigUpdateDTO
     * @return OK
     */
    update(interfaceConfigUpdateDTO: InterfaceConfigUpdateDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interfaceConfigUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 删除接口配置
     * @param ids ids
     * @return OK
     */
    delete(ids: string[]): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 分页查询接口
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPage(current: number | null | undefined, size: number | null | undefined): Promise<ROfIPageOfInterfaceConfigVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<ROfIPageOfInterfaceConfigVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfInterfaceConfigVO.fromJS(resultData200) : new ROfIPageOfInterfaceConfigVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfInterfaceConfigVO>(<any>null);
    }
}

export class InterfaceConfigFieldServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加字段
     * @param interfaceConfigFieldDTO interfaceConfigFieldDTO
     * @return OK
     */
    save(interfaceConfigFieldDTO: InterfaceConfigFieldDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config-field";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interfaceConfigFieldDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 修改字段
     * @param interfaceConfigFieldUpdateDTO interfaceConfigFieldUpdateDTO
     * @return OK
     */
    update(interfaceConfigFieldUpdateDTO: InterfaceConfigFieldUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config-field";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interfaceConfigFieldUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除字段
     * @param ids ids
     * @return OK
     */
    delete(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config-field?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询字段
     * @param configId (optional) configId
     * @return OK
     */
    getList(configId: string | null | undefined): Promise<InterfaceConfigFieldVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config-field/list?";
        if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<InterfaceConfigFieldVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterfaceConfigFieldVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<InterfaceConfigFieldVO[]>(<any>null);
    }
}

export class InterfaceConfigVisualServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 根据图表查询接口
     * @param owningChart (optional) owningChart
     * @return OK
     */
    getByOwningChart(owningChart: string | null | undefined): Promise<InterfaceConfigInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/interface-config/visual/owningChart?";
        if (owningChart !== undefined)
            url_ += "owningChart=" + encodeURIComponent("" + owningChart) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetByOwningChart(_response);
        });
    }

    protected processGetByOwningChart(response: AxiosResponse): Promise<InterfaceConfigInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterfaceConfigInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<InterfaceConfigInfoVO[]>(<any>null);
    }
}

export class AuthorityDomainServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取已分配给我的职权域的树
     * @return OK
     */
    getAssignedTreeList(): Promise<ROfListOfAuthorityDomainTreeDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/m-authority/assigned/tree-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAssignedTreeList(_response);
        });
    }

    protected processGetAssignedTreeList(response: AxiosResponse): Promise<ROfListOfAuthorityDomainTreeDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfAuthorityDomainTreeDto.fromJS(resultData200) : new ROfListOfAuthorityDomainTreeDto();
            return result200;
        }
        return Promise.resolve<ROfListOfAuthorityDomainTreeDto>(<any>null);
    }

    /**
     * 逻辑删除
     * @param idList id集合
     * @return OK
     */
    remove(idList: string[]): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/m-authority/delete?";
        if (idList === undefined || idList === null)
            throw new Error("The parameter 'idList' must be defined and cannot be null.");
        else
            idList && idList.forEach(item => { url_ += "idList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 获取已启用职权域的树
     * @return OK
     */
    getEnableTreeList(): Promise<ROfListOfAuthorityDomainTreeDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/m-authority/enable/treeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEnableTreeList(_response);
        });
    }

    protected processGetEnableTreeList(response: AxiosResponse): Promise<ROfListOfAuthorityDomainTreeDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfAuthorityDomainTreeDto.fromJS(resultData200) : new ROfListOfAuthorityDomainTreeDto();
            return result200;
        }
        return Promise.resolve<ROfListOfAuthorityDomainTreeDto>(<any>null);
    }

    /**
     * findNameValueById
     * @param id id
     * @return OK
     */
    findNameValueById(id: string): Promise<NameValueOfstring> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/m-authority/name-value/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindNameValueById(_response);
        });
    }

    protected processFindNameValueById(response: AxiosResponse): Promise<NameValueOfstring> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? NameValueOfstring.fromJS(resultData200) : new NameValueOfstring();
            return result200;
        }
        return Promise.resolve<NameValueOfstring>(<any>null);
    }

    /**
     * 新增或修改职权域
     * @param authorityDomainDto authorityDomainDto
     * @return OK
     */
    submit(authorityDomainDto: AuthorityDomainDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/m-authority/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authorityDomainDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取职权域树形结构列表
     * @return OK
     */
    treeList(): Promise<ROfListOfAuthorityDomainTreeDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/m-authority/treeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTreeList(_response);
        });
    }

    protected processTreeList(response: AxiosResponse): Promise<ROfListOfAuthorityDomainTreeDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfAuthorityDomainTreeDto.fromJS(resultData200) : new ROfListOfAuthorityDomainTreeDto();
            return result200;
        }
        return Promise.resolve<ROfListOfAuthorityDomainTreeDto>(<any>null);
    }
}

export class MasterlinkMenuCustomizationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取租户自定义菜单
     * @param appId (optional) appId
     * @param kind kind
     * @param searchKey (optional) searchKey
     * @return OK
     */
    getMenus(appId: string | null | undefined, kind: number, searchKey: string | null | undefined): Promise<ROfMenusWithElementsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu-customization?";
        if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&"; 
        if (kind === undefined || kind === null)
            throw new Error("The parameter 'kind' must be defined and cannot be null.");
        else
            url_ += "kind=" + encodeURIComponent("" + kind) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMenus(_response);
        });
    }

    protected processGetMenus(response: AxiosResponse): Promise<ROfMenusWithElementsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenusWithElementsVO.fromJS(resultData200) : new ROfMenusWithElementsVO();
            return result200;
        }
        return Promise.resolve<ROfMenusWithElementsVO>(<any>null);
    }

    /**
     * 创建租户自定义菜单
     * @param menuCustomization menuCustomization
     * @return OK
     */
    createMenuCustomization(menuCustomization: MasterlinkMenuCustomization): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu-customization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(menuCustomization);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateMenuCustomization(_response);
        });
    }

    protected processCreateMenuCustomization(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 更新租户自定义菜单
     * @param menuCustomizationSettingDTO menuCustomizationSettingDTO
     * @return OK
     */
    updateMenuCustomization(menuCustomizationSettingDTO: MenuCustomizationSettingDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu-customization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(menuCustomizationSettingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateMenuCustomization(_response);
        });
    }

    protected processUpdateMenuCustomization(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 删除租户自定义菜单
     * @param ids ids
     * @return OK
     */
    deleteMenuCustomization(ids: string[]): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu-customization?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMenuCustomization(_response);
        });
    }

    protected processDeleteMenuCustomization(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 获取单条
     * @param id id
     * @return OK
     */
    getMenuCustomization(id: string): Promise<ROfMenuCustomizationDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu-customization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMenuCustomization(_response);
        });
    }

    protected processGetMenuCustomization(response: AxiosResponse): Promise<ROfMenuCustomizationDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenuCustomizationDTO.fromJS(resultData200) : new ROfMenuCustomizationDTO();
            return result200;
        }
        return Promise.resolve<ROfMenuCustomizationDTO>(<any>null);
    }
}

export class MenuServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 菜单的角色权限
     * @return OK
     */
    authRoutes(): Promise<ROfListOfKv> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/auth-routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthRoutes(_response);
        });
    }

    protected processAuthRoutes(response: AxiosResponse): Promise<ROfListOfKv> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfKv.fromJS(resultData200) : new ROfListOfKv();
            return result200;
        }
        return Promise.resolve<ROfListOfKv>(<any>null);
    }

    /**
     * 前端按钮数据
     * @return OK
     */
    buttons(): Promise<ROfListOfMenuVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/buttons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processButtons(_response);
        });
    }

    protected processButtons(response: AxiosResponse): Promise<ROfListOfMenuVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMenuVO.fromJS(resultData200) : new ROfListOfMenuVO();
            return result200;
        }
        return Promise.resolve<ROfListOfMenuVO>(<any>null);
    }

    /**
     * 详情
     * @param action (optional) 操作按钮类型
     * @param alias (optional) 菜单别名
     * @param audience (optional) 租户类型
     * @param category (optional) 菜单类型
     * @param code (optional) 菜单编号
     * @param edition (optional) 版本：PC 1，移动 2，HMI 3
     * @param id (optional) 主键
     * @param isDeleted (optional) 是否已删除
     * @param isOpen (optional) 是否打开新页面
     * @param kind (optional) 菜单类型：常规1，动态2，设定4
     * @param name (optional) 菜单名称
     * @param parentId (optional) 菜单父主键
     * @param path (optional) 请求地址
     * @param remark (optional) 备注
     * @param sort (optional) 排序
     * @param source (optional) 菜单资源
     * @return OK
     */
    detail(action: number | null | undefined, alias: string | null | undefined, audience: number | null | undefined, category: number | null | undefined, code: string | null | undefined, edition: number | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, isOpen: number | null | undefined, kind: number | null | undefined, name: string | null | undefined, parentId: string | null | undefined, path: string | null | undefined, remark: string | null | undefined, sort: number | null | undefined, source: string | null | undefined): Promise<ROfMenuVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/detail?";
        if (action !== undefined)
            url_ += "action=" + encodeURIComponent("" + action) + "&"; 
        if (alias !== undefined)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&"; 
        if (audience !== undefined)
            url_ += "audience=" + encodeURIComponent("" + audience) + "&"; 
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (edition !== undefined)
            url_ += "edition=" + encodeURIComponent("" + edition) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (isOpen !== undefined)
            url_ += "isOpen=" + encodeURIComponent("" + isOpen) + "&"; 
        if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfMenuVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenuVO.fromJS(resultData200) : new ROfMenuVO();
            return result200;
        }
        return Promise.resolve<ROfMenuVO>(<any>null);
    }

    /**
     * 顶部菜单树形结构
     * @return OK
     */
    grantTopTree(): Promise<ROfGrantTreeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/grant-top-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGrantTopTree(_response);
        });
    }

    protected processGrantTopTree(response: AxiosResponse): Promise<ROfGrantTreeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfGrantTreeVO.fromJS(resultData200) : new ROfGrantTreeVO();
            return result200;
        }
        return Promise.resolve<ROfGrantTreeVO>(<any>null);
    }

    /**
     * 权限分配树形结构
     * @return OK
     */
    grantTree(): Promise<ROfGrantTreeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/grant-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGrantTree(_response);
        });
    }

    protected processGrantTree(response: AxiosResponse): Promise<ROfGrantTreeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfGrantTreeVO.fromJS(resultData200) : new ROfGrantTreeVO();
            return result200;
        }
        return Promise.resolve<ROfGrantTreeVO>(<any>null);
    }

    /**
     * 懒加载列表
     * @param audience (optional) 租户类型
     * @param kind (optional) 菜单类型
     * @param name (optional) 菜单名称
     * @param parentId (optional) parentId
     * @return OK
     */
    lazyList(audience: string | null | undefined, kind: string | null | undefined, name: string | null | undefined, parentId: string | null | undefined): Promise<ROfListOfMenuVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/lazy-list?";
        if (audience !== undefined)
            url_ += "audience=" + encodeURIComponent("" + audience) + "&"; 
        if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyList(_response);
        });
    }

    protected processLazyList(response: AxiosResponse): Promise<ROfListOfMenuVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMenuVO.fromJS(resultData200) : new ROfListOfMenuVO();
            return result200;
        }
        return Promise.resolve<ROfListOfMenuVO>(<any>null);
    }

    /**
     * 懒加载菜单列表
     * @param code (optional) 菜单编号
     * @param name (optional) 菜单名称
     * @param parentId (optional) parentId
     * @return OK
     */
    lazyMenuList(code: string | null | undefined, name: string | null | undefined, parentId: string | null | undefined): Promise<ROfListOfMenuVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/lazy-menu-list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyMenuList(_response);
        });
    }

    protected processLazyMenuList(response: AxiosResponse): Promise<ROfListOfMenuVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMenuVO.fromJS(resultData200) : new ROfListOfMenuVO();
            return result200;
        }
        return Promise.resolve<ROfListOfMenuVO>(<any>null);
    }

    /**
     * 列表
     * @param code (optional) 菜单编号
     * @param name (optional) 菜单名称
     * @return OK
     */
    list(code: string | null | undefined, name: string | null | undefined): Promise<ROfListOfMenuVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfListOfMenuVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMenuVO.fromJS(resultData200) : new ROfListOfMenuVO();
            return result200;
        }
        return Promise.resolve<ROfListOfMenuVO>(<any>null);
    }

    /**
     * 菜单列表
     * @param code (optional) 菜单编号
     * @param name (optional) 菜单名称
     * @return OK
     */
    menuList(code: string | null | undefined, name: string | null | undefined): Promise<ROfListOfMenuVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/menu-list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMenuList(_response);
        });
    }

    protected processMenuList(response: AxiosResponse): Promise<ROfListOfMenuVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMenuVO.fromJS(resultData200) : new ROfListOfMenuVO();
            return result200;
        }
        return Promise.resolve<ROfListOfMenuVO>(<any>null);
    }

    /**
     * 删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 角色所分配的树
     * @param roleIds (optional) roleIds
     * @return OK
     */
    roleTreeKeys(roleIds: string | null | undefined): Promise<ROfCheckedTreeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/role-tree-keys?";
        if (roleIds !== undefined)
            url_ += "roleIds=" + encodeURIComponent("" + roleIds) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRoleTreeKeys(_response);
        });
    }

    protected processRoleTreeKeys(response: AxiosResponse): Promise<ROfCheckedTreeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfCheckedTreeVO.fromJS(resultData200) : new ROfCheckedTreeVO();
            return result200;
        }
        return Promise.resolve<ROfCheckedTreeVO>(<any>null);
    }

    /**
     * 前端菜单数据
     * @param topMenuId (optional) topMenuId
     * @return OK
     */
    routes(topMenuId: string | null | undefined): Promise<ROfListOfMenuVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/routes?";
        if (topMenuId !== undefined)
            url_ += "topMenuId=" + encodeURIComponent("" + topMenuId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRoutes(_response);
        });
    }

    protected processRoutes(response: AxiosResponse): Promise<ROfListOfMenuVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMenuVO.fromJS(resultData200) : new ROfListOfMenuVO();
            return result200;
        }
        return Promise.resolve<ROfListOfMenuVO>(<any>null);
    }

    /**
     * 新增或修改
     * @param menu menu
     * @return OK
     */
    submit(menu: Menu): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(menu);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 顶部菜单数据
     * @return OK
     */
    topMenu(): Promise<ROfListOfTopMenu> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/top-menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTopMenu(_response);
        });
    }

    protected processTopMenu(response: AxiosResponse): Promise<ROfListOfTopMenu> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfTopMenu.fromJS(resultData200) : new ROfListOfTopMenu();
            return result200;
        }
        return Promise.resolve<ROfListOfTopMenu>(<any>null);
    }

    /**
     * 顶部菜单所分配的树
     * @param topMenuIds (optional) topMenuIds
     * @return OK
     */
    topTreeKeys(topMenuIds: string | null | undefined): Promise<ROfCheckedTreeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/top-tree-keys?";
        if (topMenuIds !== undefined)
            url_ += "topMenuIds=" + encodeURIComponent("" + topMenuIds) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTopTreeKeys(_response);
        });
    }

    protected processTopTreeKeys(response: AxiosResponse): Promise<ROfCheckedTreeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfCheckedTreeVO.fromJS(resultData200) : new ROfCheckedTreeVO();
            return result200;
        }
        return Promise.resolve<ROfCheckedTreeVO>(<any>null);
    }

    /**
     * 树形结构
     * @return OK
     */
    tree(): Promise<ROfListOfMenuVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menu/tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<ROfListOfMenuVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMenuVO.fromJS(resultData200) : new ROfListOfMenuVO();
            return result200;
        }
        return Promise.resolve<ROfListOfMenuVO>(<any>null);
    }
}

export class MasterlinkMenuServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getMenus
     * @param appId (optional) appId
     * @param edition (optional) edition
     * @param kind kind
     * @param searchKey (optional) searchKey
     * @return OK
     */
    getMenus(appId: string | null | undefined, edition: string | null | undefined, kind: number, searchKey: string | null | undefined): Promise<ROfMenusWithElementsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menus?";
        if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&"; 
        if (edition !== undefined)
            url_ += "edition=" + encodeURIComponent("" + edition) + "&"; 
        if (kind === undefined || kind === null)
            throw new Error("The parameter 'kind' must be defined and cannot be null.");
        else
            url_ += "kind=" + encodeURIComponent("" + kind) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMenus(_response);
        });
    }

    protected processGetMenus(response: AxiosResponse): Promise<ROfMenusWithElementsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenusWithElementsVO.fromJS(resultData200) : new ROfMenusWithElementsVO();
            return result200;
        }
        return Promise.resolve<ROfMenusWithElementsVO>(<any>null);
    }

    /**
     * 菜单绑定api
     * @param menuScopeApiItemDto (optional) api入参
     * @return OK
     */
    updateApisInMenu(menuScopeApiItemDto: MenuScopeApiItemDto | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menus/apis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(menuScopeApiItemDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateApisInMenu(_response);
        });
    }

    protected processUpdateApisInMenu(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 菜单下所有api
     * @param menuId (optional) 菜单Id
     * @return OK
     */
    getApisInMenu(menuId: string | null | undefined): Promise<ROfMenuApisVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menus/apis/{menuId}";
        if (menuId !== null && menuId !== undefined)
        url_ = url_.replace("{menuId}", encodeURIComponent("" + menuId)); 
        else
            url_ = url_.replace("/{menuId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetApisInMenu(_response);
        });
    }

    protected processGetApisInMenu(response: AxiosResponse): Promise<ROfMenuApisVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenuApisVO.fromJS(resultData200) : new ROfMenuApisVO();
            return result200;
        }
        return Promise.resolve<ROfMenuApisVO>(<any>null);
    }

    /**
     * getFirstClassMenus
     * @return OK
     */
    getFirstClassMenus(): Promise<ROfMenusWithElementsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/menus/first-class-menus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFirstClassMenus(_response);
        });
    }

    protected processGetFirstClassMenus(response: AxiosResponse): Promise<ROfMenusWithElementsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenusWithElementsVO.fromJS(resultData200) : new ROfMenusWithElementsVO();
            return result200;
        }
        return Promise.resolve<ROfMenusWithElementsVO>(<any>null);
    }
}

export class OrganizationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param ancestors (optional) 
     * @param category (optional) 
     * @param fullName (optional) 
     * @param id (optional) 
     * @param isDeleted (optional) 
     * @param name (optional) 
     * @param parentId (optional) 
     * @param remark (optional) 
     * @param sort (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    detail(ancestors: string | null | undefined, category: number | null | undefined, fullName: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, name: string | null | undefined, parentId: string | null | undefined, remark: string | null | undefined, sort: number | null | undefined, tenantId: string | null | undefined): Promise<ROfOrganizationVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/detail?";
        if (ancestors !== undefined)
            url_ += "ancestors=" + encodeURIComponent("" + ancestors) + "&"; 
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (fullName !== undefined)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfOrganizationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfOrganizationVO.fromJS(resultData200) : new ROfOrganizationVO();
            return result200;
        }
        return Promise.resolve<ROfOrganizationVO>(<any>null);
    }

    /**
     * 懒加载列表
     * @param fullName (optional) 组织机构全称
     * @param name (optional) 组织机构名称
     * @param parentId (optional) parentId
     * @return OK
     */
    lazyList(fullName: string | null | undefined, name: string | null | undefined, parentId: string | null | undefined): Promise<ROfListOfOrganizationVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/lazy-list?";
        if (fullName !== undefined)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyList(_response);
        });
    }

    protected processLazyList(response: AxiosResponse): Promise<ROfListOfOrganizationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfOrganizationVO.fromJS(resultData200) : new ROfListOfOrganizationVO();
            return result200;
        }
        return Promise.resolve<ROfListOfOrganizationVO>(<any>null);
    }

    /**
     * 懒加载树形结构
     * @param parentId (optional) parentId
     * @param tenantId (optional) tenantId
     * @return OK
     */
    lazyTree(parentId: string | null | undefined, tenantId: string | null | undefined): Promise<ROfListOfTreeNode> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/lazy-tree?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyTree(_response);
        });
    }

    protected processLazyTree(response: AxiosResponse): Promise<ROfListOfTreeNode> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfTreeNode.fromJS(resultData200) : new ROfListOfTreeNode();
            return result200;
        }
        return Promise.resolve<ROfListOfTreeNode>(<any>null);
    }

    /**
     * 列表
     * @param fullName (optional) 组织机构全称
     * @param name (optional) 组织机构名称
     * @return OK
     */
    list(fullName: string | null | undefined, name: string | null | undefined): Promise<ROfListOfOrganizationVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/list?";
        if (fullName !== undefined)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfListOfOrganizationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfOrganizationVO.fromJS(resultData200) : new ROfListOfOrganizationVO();
            return result200;
        }
        return Promise.resolve<ROfListOfOrganizationVO>(<any>null);
    }

    /**
     * 删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param organization organization
     * @return OK
     */
    submit(organization: Organization): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 树形结构
     * @param tenantId (optional) tenantId
     * @return OK
     */
    tree(tenantId: string | null | undefined): Promise<ROfListOfTreeNode> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/tree?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<ROfListOfTreeNode> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfTreeNode.fromJS(resultData200) : new ROfListOfTreeNode();
            return result200;
        }
        return Promise.resolve<ROfListOfTreeNode>(<any>null);
    }

    /**
     * 组织机构用户树形结构
     * @return OK
     */
    userTree(): Promise<ROfListOfOrganizationUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/user-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUserTree(_response);
        });
    }

    protected processUserTree(response: AxiosResponse): Promise<ROfListOfOrganizationUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfOrganizationUserVO.fromJS(resultData200) : new ROfListOfOrganizationUserVO();
            return result200;
        }
        return Promise.resolve<ROfListOfOrganizationUserVO>(<any>null);
    }

    /**
     * 岗位下的用户列表
     * @param id 岗位主键
     * @return OK
     */
    listUsers(id: string): Promise<ROfListOfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/organization/users?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListUsers(_response);
        });
    }

    protected processListUsers(response: AxiosResponse): Promise<ROfListOfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfUserVO.fromJS(resultData200) : new ROfListOfUserVO();
            return result200;
        }
        return Promise.resolve<ROfListOfUserVO>(<any>null);
    }
}

export class ParamServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param paramKey (optional) 参数键
     * @param paramName (optional) 参数名
     * @param paramValue (optional) 参数值
     * @param remark (optional) 备注
     * @param status (optional) 业务状态
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    detail(createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, paramKey: string | null | undefined, paramName: string | null | undefined, paramValue: string | null | undefined, remark: string | null | undefined, status: number | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfParam> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/param/detail?";
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (paramKey !== undefined)
            url_ += "paramKey=" + encodeURIComponent("" + paramKey) + "&"; 
        if (paramName !== undefined)
            url_ += "paramName=" + encodeURIComponent("" + paramName) + "&"; 
        if (paramValue !== undefined)
            url_ += "paramValue=" + encodeURIComponent("" + paramValue) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfParam> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfParam.fromJS(resultData200) : new ROfParam();
            return result200;
        }
        return Promise.resolve<ROfParam>(<any>null);
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param paramKey (optional) 参数键名
     * @param paramName (optional) 参数名称
     * @param paramValue (optional) 参数键值
     * @param size (optional) 每页的数量
     * @return OK
     */
    list(current: number | null | undefined, paramKey: string | null | undefined, paramName: string | null | undefined, paramValue: string | null | undefined, size: number | null | undefined): Promise<ROfIPageOfParam> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/param/list?";
        if (paramKey !== undefined)
            url_ += "paramKey=" + encodeURIComponent("" + paramKey) + "&"; 
        if (paramName !== undefined)
            url_ += "paramName=" + encodeURIComponent("" + paramName) + "&"; 
        if (paramValue !== undefined)
            url_ += "paramValue=" + encodeURIComponent("" + paramValue) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfIPageOfParam> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfParam.fromJS(resultData200) : new ROfIPageOfParam();
            return result200;
        }
        return Promise.resolve<ROfIPageOfParam>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/param/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param param param
     * @return OK
     */
    submit(param: Param): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/param/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class TenantExtendServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取个性化设置
     * @return OK
     */
    detail(): Promise<TenantExtend> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/personalized-setting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<TenantExtend> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TenantExtend.fromJS(resultData200) : new TenantExtend();
            return result200;
        }
        return Promise.resolve<TenantExtend>(<any>null);
    }

    /**
     * 新增个性化配置
     * @param tenantExtend tenantExtend
     * @return OK
     */
    save(tenantExtend: TenantExtend): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/personalized-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantExtend);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑个性化
     * @param tenantExtend tenantExtend
     * @return OK
     */
    update(tenantExtend: TenantExtend): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/personalized-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantExtend);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据域名获取个性化设置
     * @param domain domain
     * @return OK
     */
    getSettingByDomain(domain: string): Promise<TenantExtendVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/personalized-setting/domain/{domain}";
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSettingByDomain(_response);
        });
    }

    protected processGetSettingByDomain(response: AxiosResponse): Promise<TenantExtendVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TenantExtendVO.fromJS(resultData200) : new TenantExtendVO();
            return result200;
        }
        return Promise.resolve<TenantExtendVO>(<any>null);
    }

    /**
     * 根据租户Code获取租户ID
     * @param tenantCode tenantCode
     * @return OK
     */
    getTenantIdByTenantCode(tenantCode: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/personalized-setting/tenant/{tenantCode}";
        if (tenantCode === undefined || tenantCode === null)
            throw new Error("The parameter 'tenantCode' must be defined.");
        url_ = url_.replace("{tenantCode}", encodeURIComponent("" + tenantCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTenantIdByTenantCode(_response);
        });
    }

    protected processGetTenantIdByTenantCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class PostServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param category (optional) 类型
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param postCode (optional) 岗位编号
     * @param postName (optional) 岗位名称
     * @param remark (optional) 岗位描述
     * @param sort (optional) 岗位排序
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    detail(category: number | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, postCode: string | null | undefined, postName: string | null | undefined, remark: string | null | undefined, sort: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfPostVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/post/detail?";
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&"; 
        if (postName !== undefined)
            url_ += "postName=" + encodeURIComponent("" + postName) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfPostVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfPostVO.fromJS(resultData200) : new ROfPostVO();
            return result200;
        }
        return Promise.resolve<ROfPostVO>(<any>null);
    }

    /**
     * 分页
     * @param category (optional) 类型
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param postCode (optional) 岗位编号
     * @param postName (optional) 岗位名称
     * @param remark (optional) 岗位描述
     * @param size (optional) 每页的数量
     * @param sort (optional) 岗位排序
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    list(category: number | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, postCode: string | null | undefined, postName: string | null | undefined, remark: string | null | undefined, size: number | null | undefined, sort: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfPostVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/post/list?";
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&"; 
        if (postName !== undefined)
            url_ += "postName=" + encodeURIComponent("" + postName) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfIPageOfPostVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfPostVO.fromJS(resultData200) : new ROfIPageOfPostVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfPostVO>(<any>null);
    }

    /**
     * 分页
     * @param category (optional) 类型
     * @param categoryName (optional) 
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param postCode (optional) 岗位编号
     * @param postName (optional) 岗位名称
     * @param remark (optional) 岗位描述
     * @param size (optional) 每页的数量
     * @param sort (optional) 岗位排序
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    page(category: number | null | undefined, categoryName: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, postCode: string | null | undefined, postName: string | null | undefined, remark: string | null | undefined, size: number | null | undefined, sort: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfPostVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/post/page?";
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (categoryName !== undefined)
            url_ += "categoryName=" + encodeURIComponent("" + categoryName) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&"; 
        if (postName !== undefined)
            url_ += "postName=" + encodeURIComponent("" + postName) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ROfIPageOfPostVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfPostVO.fromJS(resultData200) : new ROfIPageOfPostVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfPostVO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/post/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增
     * @param post post
     * @return OK
     */
    save(post: Post): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/post/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(post);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 下拉数据源
     * @param tenantId (optional) tenantId
     * @return OK
     */
    select(tenantId: string | null | undefined): Promise<ROfListOfPost> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/post/select?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSelect(_response);
        });
    }

    protected processSelect(response: AxiosResponse): Promise<ROfListOfPost> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfPost.fromJS(resultData200) : new ROfListOfPost();
            return result200;
        }
        return Promise.resolve<ROfListOfPost>(<any>null);
    }

    /**
     * 新增或修改
     * @param post post
     * @return OK
     */
    submit(post: Post): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/post/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(post);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param post post
     * @return OK
     */
    update(post: Post): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/post/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(post);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class PublishRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param id id
     * @return OK
     */
    detail(id: string): Promise<PublishRecordDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/publish-record/detail?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<PublishRecordDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PublishRecordDTO.fromJS(resultData200) : new PublishRecordDTO();
            return result200;
        }
        return Promise.resolve<PublishRecordDTO>(<any>null);
    }

    /**
     * 版本发布历史
     * @return OK
     */
    history(): Promise<PublishRecordDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/publish-record/history";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHistory(_response);
        });
    }

    protected processHistory(response: AxiosResponse): Promise<PublishRecordDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublishRecordDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<PublishRecordDTO[]>(<any>null);
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    list(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfPublishRecordDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/publish-record/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<IPageOfPublishRecordDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfPublishRecordDTO.fromJS(resultData200) : new IPageOfPublishRecordDTO();
            return result200;
        }
        return Promise.resolve<IPageOfPublishRecordDTO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/publish-record/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新增版本发布记录
     * @param publishRecordAddDTO publishRecordAddDTO
     * @return OK
     */
    submit(publishRecordAddDTO: PublishRecordAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/publish-record/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publishRecordAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 修改版本发布记录
     * @param publishRecordDTO publishRecordDTO
     * @return OK
     */
    updateRecord(publishRecordDTO: PublishRecordDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/publish-record/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publishRecordDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateRecord(_response);
        });
    }

    protected processUpdateRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查询该用户最新发布记录
     * @return OK
     */
    latestRecordByUser(): Promise<UserPublishRecordDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/publish-record/user/detail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLatestRecordByUser(_response);
        });
    }

    protected processLatestRecordByUser(response: AxiosResponse): Promise<UserPublishRecordDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? UserPublishRecordDTO.fromJS(resultData200) : new UserPublishRecordDTO();
            return result200;
        }
        return Promise.resolve<UserPublishRecordDTO>(<any>null);
    }
}

export class RegionServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param ancestors (optional) 祖区划编号
     * @param areaCode (optional) 地理大区编号
     * @param areaName (optional) 地理大区名称
     * @param cityCode (optional) 市级区划编号
     * @param cityName (optional) 市级名称
     * @param code (optional) 区划编号
     * @param districtCode (optional) 区级区划编号
     * @param districtName (optional) 区级名称
     * @param level (optional) 层级
     * @param name (optional) 区划名称
     * @param parentCode (optional) 父区划编号
     * @param provinceCode (optional) 省级区划编号
     * @param provinceName (optional) 省级名称
     * @param remark (optional) 备注
     * @param sort (optional) 排序
     * @param townCode (optional) 镇级区划编号
     * @param townName (optional) 镇级名称
     * @param villageCode (optional) 村级区划编号
     * @param villageName (optional) 村级名称
     * @return OK
     */
    detail(ancestors: string | null | undefined, areaCode: string | null | undefined, areaName: string | null | undefined, cityCode: string | null | undefined, cityName: string | null | undefined, code: string | null | undefined, districtCode: string | null | undefined, districtName: string | null | undefined, level: number | null | undefined, name: string | null | undefined, parentCode: string | null | undefined, provinceCode: string | null | undefined, provinceName: string | null | undefined, remark: string | null | undefined, sort: number | null | undefined, townCode: string | null | undefined, townName: string | null | undefined, villageCode: string | null | undefined, villageName: string | null | undefined): Promise<ROfRegionVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/detail?";
        if (ancestors !== undefined)
            url_ += "ancestors=" + encodeURIComponent("" + ancestors) + "&"; 
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&"; 
        if (areaName !== undefined)
            url_ += "areaName=" + encodeURIComponent("" + areaName) + "&"; 
        if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&"; 
        if (cityName !== undefined)
            url_ += "cityName=" + encodeURIComponent("" + cityName) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&"; 
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentCode !== undefined)
            url_ += "parentCode=" + encodeURIComponent("" + parentCode) + "&"; 
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&"; 
        if (provinceName !== undefined)
            url_ += "provinceName=" + encodeURIComponent("" + provinceName) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (townCode !== undefined)
            url_ += "townCode=" + encodeURIComponent("" + townCode) + "&"; 
        if (townName !== undefined)
            url_ += "townName=" + encodeURIComponent("" + townName) + "&"; 
        if (villageCode !== undefined)
            url_ += "villageCode=" + encodeURIComponent("" + villageCode) + "&"; 
        if (villageName !== undefined)
            url_ += "villageName=" + encodeURIComponent("" + villageName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfRegionVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfRegionVO.fromJS(resultData200) : new ROfRegionVO();
            return result200;
        }
        return Promise.resolve<ROfRegionVO>(<any>null);
    }

    /**
     * 导出行政区划
     * @return OK
     */
    exportRegion(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/export-region";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportRegion(_response);
        });
    }

    protected processExportRegion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出模板
     * @return OK
     */
    exportUser(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/export-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportUser(_response);
        });
    }

    protected processExportUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入行政区划
     * @param file (optional) file
     * @param isCovered (optional) isCovered
     * @return OK
     */
    importRegion(file: FileParameter | null | undefined, isCovered: number | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/import-region?";
        if (isCovered !== undefined)
            url_ += "isCovered=" + encodeURIComponent("" + isCovered) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportRegion(_response);
        });
    }

    protected processImportRegion(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 懒加载列表
     * @param code (optional) 区划编号
     * @param name (optional) 区划名称
     * @param parentCode (optional) parentCode
     * @return OK
     */
    lazyList(code: string | null | undefined, name: string | null | undefined, parentCode: string | null | undefined): Promise<ROfListOfRegionVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/lazy-list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentCode !== undefined)
            url_ += "parentCode=" + encodeURIComponent("" + parentCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyList(_response);
        });
    }

    protected processLazyList(response: AxiosResponse): Promise<ROfListOfRegionVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfRegionVO.fromJS(resultData200) : new ROfListOfRegionVO();
            return result200;
        }
        return Promise.resolve<ROfListOfRegionVO>(<any>null);
    }

    /**
     * 懒加载列表
     * @param code (optional) 区划编号
     * @param name (optional) 区划名称
     * @param parentCode (optional) parentCode
     * @return OK
     */
    lazyTree(code: string | null | undefined, name: string | null | undefined, parentCode: string | null | undefined): Promise<ROfListOfRegionVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/lazy-tree?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentCode !== undefined)
            url_ += "parentCode=" + encodeURIComponent("" + parentCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyTree(_response);
        });
    }

    protected processLazyTree(response: AxiosResponse): Promise<ROfListOfRegionVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfRegionVO.fromJS(resultData200) : new ROfListOfRegionVO();
            return result200;
        }
        return Promise.resolve<ROfListOfRegionVO>(<any>null);
    }

    /**
     * 分页
     * @param ancestors (optional) 祖区划编号
     * @param areaCode (optional) 地理大区编号
     * @param areaName (optional) 地理大区名称
     * @param cityCode (optional) 市级区划编号
     * @param cityName (optional) 市级名称
     * @param code (optional) 区划编号
     * @param current (optional) 当前页
     * @param districtCode (optional) 区级区划编号
     * @param districtName (optional) 区级名称
     * @param level (optional) 层级
     * @param name (optional) 区划名称
     * @param parentCode (optional) 父区划编号
     * @param provinceCode (optional) 省级区划编号
     * @param provinceName (optional) 省级名称
     * @param remark (optional) 备注
     * @param size (optional) 每页的数量
     * @param sort (optional) 排序
     * @param townCode (optional) 镇级区划编号
     * @param townName (optional) 镇级名称
     * @param villageCode (optional) 村级区划编号
     * @param villageName (optional) 村级名称
     * @return OK
     */
    list(ancestors: string | null | undefined, areaCode: string | null | undefined, areaName: string | null | undefined, cityCode: string | null | undefined, cityName: string | null | undefined, code: string | null | undefined, current: number | null | undefined, districtCode: string | null | undefined, districtName: string | null | undefined, level: number | null | undefined, name: string | null | undefined, parentCode: string | null | undefined, provinceCode: string | null | undefined, provinceName: string | null | undefined, remark: string | null | undefined, size: number | null | undefined, sort: number | null | undefined, townCode: string | null | undefined, townName: string | null | undefined, villageCode: string | null | undefined, villageName: string | null | undefined): Promise<ROfIPageOfRegion> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/list?";
        if (ancestors !== undefined)
            url_ += "ancestors=" + encodeURIComponent("" + ancestors) + "&"; 
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&"; 
        if (areaName !== undefined)
            url_ += "areaName=" + encodeURIComponent("" + areaName) + "&"; 
        if (cityCode !== undefined)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&"; 
        if (cityName !== undefined)
            url_ += "cityName=" + encodeURIComponent("" + cityName) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&"; 
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parentCode !== undefined)
            url_ += "parentCode=" + encodeURIComponent("" + parentCode) + "&"; 
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&"; 
        if (provinceName !== undefined)
            url_ += "provinceName=" + encodeURIComponent("" + provinceName) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (townCode !== undefined)
            url_ += "townCode=" + encodeURIComponent("" + townCode) + "&"; 
        if (townName !== undefined)
            url_ += "townName=" + encodeURIComponent("" + townName) + "&"; 
        if (villageCode !== undefined)
            url_ += "villageCode=" + encodeURIComponent("" + villageCode) + "&"; 
        if (villageName !== undefined)
            url_ += "villageName=" + encodeURIComponent("" + villageName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfIPageOfRegion> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfRegion.fromJS(resultData200) : new ROfIPageOfRegion();
            return result200;
        }
        return Promise.resolve<ROfIPageOfRegion>(<any>null);
    }

    /**
     * 删除
     * @param id 主键
     * @return OK
     */
    remove(id: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/remove?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增
     * @param region region
     * @return OK
     */
    save(region: Region): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(region);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 下拉数据源
     * @param code (optional) code
     * @return OK
     */
    select(code: string | null | undefined): Promise<ROfListOfRegion> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/select?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSelect(_response);
        });
    }

    protected processSelect(response: AxiosResponse): Promise<ROfListOfRegion> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfRegion.fromJS(resultData200) : new ROfListOfRegion();
            return result200;
        }
        return Promise.resolve<ROfListOfRegion>(<any>null);
    }

    /**
     * 下拉数据源2
     * @param level (optional) level
     * @return OK
     */
    selectByLevel(level: number | null | undefined): Promise<ROfListOfRegion> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/select-by-level?";
        if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSelectByLevel(_response);
        });
    }

    protected processSelectByLevel(response: AxiosResponse): Promise<ROfListOfRegion> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfRegion.fromJS(resultData200) : new ROfListOfRegion();
            return result200;
        }
        return Promise.resolve<ROfListOfRegion>(<any>null);
    }

    /**
     * 新增或修改
     * @param region region
     * @return OK
     */
    submit(region: Region): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(region);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param region region
     * @return OK
     */
    update(region: Region): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/region/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(region);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class ReleasePlanServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取最近的发布计划
     * @return OK
     */
    getReleasePlan(): Promise<ReleasePlanDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/release-plan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetReleasePlan(_response);
        });
    }

    protected processGetReleasePlan(response: AxiosResponse): Promise<ReleasePlanDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ReleasePlanDTO.fromJS(resultData200) : new ReleasePlanDTO();
            return result200;
        }
        return Promise.resolve<ReleasePlanDTO>(<any>null);
    }

    /**
     * 新增版本发布计划
     * @param releasePlanAddDTO releasePlanAddDTO
     * @return OK
     */
    submit(releasePlanAddDTO: ReleasePlanAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/release-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(releasePlanAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    list(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfReleasePlanDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/release-plan/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<IPageOfReleasePlanDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfReleasePlanDTO.fromJS(resultData200) : new IPageOfReleasePlanDTO();
            return result200;
        }
        return Promise.resolve<IPageOfReleasePlanDTO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/release-plan/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 修改版本发布计划
     * @param releasePlanUpdateDTO releasePlanUpdateDTO
     * @return OK
     */
    updateRecord(releasePlanUpdateDTO: ReleasePlanUpdateDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/release-plan/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(releasePlanUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateRecord(_response);
        });
    }

    protected processUpdateRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class RoleServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param id (optional) 主键
     * @param isDeleted (optional) 是否已删除
     * @param isSubAccount (optional) 是否为子账户角色
     * @param parentId (optional) 父主键
     * @param roleAlias (optional) 角色别名
     * @param roleName (optional) 角色名
     * @param sort (optional) 排序
     * @param tenantId (optional) 租户ID
     * @return OK
     */
    detail(id: string | null | undefined, isDeleted: number | null | undefined, isSubAccount: boolean | null | undefined, parentId: string | null | undefined, roleAlias: string | null | undefined, roleName: string | null | undefined, sort: number | null | undefined, tenantId: string | null | undefined): Promise<ROfRoleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/role/detail?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (isSubAccount !== undefined)
            url_ += "isSubAccount=" + encodeURIComponent("" + isSubAccount) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (roleAlias !== undefined)
            url_ += "roleAlias=" + encodeURIComponent("" + roleAlias) + "&"; 
        if (roleName !== undefined)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfRoleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfRoleVO.fromJS(resultData200) : new ROfRoleVO();
            return result200;
        }
        return Promise.resolve<ROfRoleVO>(<any>null);
    }

    /**
     * 权限设置
     * @param grantVO grantVO
     * @return OK
     */
    grant(grantVO: GrantVO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/role/grant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(grantVO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGrant(_response);
        });
    }

    protected processGrant(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 列表
     * @param roleAlias (optional) 角色别名
     * @param roleName (optional) 参数名称
     * @return OK
     */
    list(roleAlias: string | null | undefined, roleName: string | null | undefined): Promise<ROfListOfRoleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/role/list?";
        if (roleAlias !== undefined)
            url_ += "roleAlias=" + encodeURIComponent("" + roleAlias) + "&"; 
        if (roleName !== undefined)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfListOfRoleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfRoleVO.fromJS(resultData200) : new ROfListOfRoleVO();
            return result200;
        }
        return Promise.resolve<ROfListOfRoleVO>(<any>null);
    }

    /**
     * 删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/role/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param role role
     * @return OK
     */
    submit(role: Role): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/role/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 树形结构
     * @param tenantId (optional) tenantId
     * @return OK
     */
    tree(tenantId: string | null | undefined): Promise<ROfListOfRoleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/role/tree?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<ROfListOfRoleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfRoleVO.fromJS(resultData200) : new ROfListOfRoleVO();
            return result200;
        }
        return Promise.resolve<ROfListOfRoleVO>(<any>null);
    }
}

export class MasterlinkRoleServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 列表
     * @param roleAlias (optional) 角色别名
     * @param roleName (optional) 参数名称
     * @return OK
     */
    getRoles(roleAlias: string | null | undefined, roleName: string | null | undefined): Promise<ROfRolesVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles?";
        if (roleAlias !== undefined)
            url_ += "roleAlias=" + encodeURIComponent("" + roleAlias) + "&"; 
        if (roleName !== undefined)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<ROfRolesVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfRolesVO.fromJS(resultData200) : new ROfRolesVO();
            return result200;
        }
        return Promise.resolve<ROfRolesVO>(<any>null);
    }

    /**
     * 新增
     * @param roleBriefDto roleBriefDto
     * @return OK
     */
    create(roleBriefDto: RoleBriefDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleBriefDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 删除
     * @param idsDto 主键集合
     * @return OK
     */
    deleteRoles(idsDto: IdsDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteRoles(_response);
        });
    }

    protected processDeleteRoles(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 获取菜单可用的APP列表
     * @return OK
     * @deprecated
     */
    getTopMenuApps(): Promise<ROfAppsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/apps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTopMenuApps(_response);
        });
    }

    protected processGetTopMenuApps(response: AxiosResponse): Promise<ROfAppsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAppsVO.fromJS(resultData200) : new ROfAppsVO();
            return result200;
        }
        return Promise.resolve<ROfAppsVO>(<any>null);
    }

    /**
     * getIdsOfAvailableElements
     * @return OK
     */
    getIdsOfAvailableElements(): Promise<ROfMenuCodeListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/buttons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIdsOfAvailableElements(_response);
        });
    }

    protected processGetIdsOfAvailableElements(response: AxiosResponse): Promise<ROfMenuCodeListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenuCodeListVO.fromJS(resultData200) : new ROfMenuCodeListVO();
            return result200;
        }
        return Promise.resolve<ROfMenuCodeListVO>(<any>null);
    }

    /**
     * getAvailableDynamicMenus
     * @param menuParentId (optional) menuParentId
     * @return OK
     */
    getAvailableDynamicMenus(menuParentId: string | null | undefined): Promise<ROfMenusTreeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/dynamic-menus?";
        if (menuParentId !== undefined)
            url_ += "menuParentId=" + encodeURIComponent("" + menuParentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAvailableDynamicMenus(_response);
        });
    }

    protected processGetAvailableDynamicMenus(response: AxiosResponse): Promise<ROfMenusTreeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenusTreeVO.fromJS(resultData200) : new ROfMenusTreeVO();
            return result200;
        }
        return Promise.resolve<ROfMenusTreeVO>(<any>null);
    }

    /**
     * getDynamicMenusList
     * @return OK
     * @deprecated
     */
    getDynamicMenusList(): Promise<ROfListOfMasterlinkMenuTreeNode> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/dynamic-menus/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDynamicMenusList(_response);
        });
    }

    protected processGetDynamicMenusList(response: AxiosResponse): Promise<ROfListOfMasterlinkMenuTreeNode> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMasterlinkMenuTreeNode.fromJS(resultData200) : new ROfListOfMasterlinkMenuTreeNode();
            return result200;
        }
        return Promise.resolve<ROfListOfMasterlinkMenuTreeNode>(<any>null);
    }

    /**
     * getAvailableMenus
     * @param appCode (optional) appCode
     * @param edition edition
     * @param kind kind
     * @return OK
     */
    getAvailableMenus(appCode: string | null | undefined, edition: number, kind: number): Promise<ROfMenusTreeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/routes?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (edition === undefined || edition === null)
            throw new Error("The parameter 'edition' must be defined and cannot be null.");
        else
            url_ += "edition=" + encodeURIComponent("" + edition) + "&"; 
        if (kind === undefined || kind === null)
            throw new Error("The parameter 'kind' must be defined and cannot be null.");
        else
            url_ += "kind=" + encodeURIComponent("" + kind) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAvailableMenus(_response);
        });
    }

    protected processGetAvailableMenus(response: AxiosResponse): Promise<ROfMenusTreeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenusTreeVO.fromJS(resultData200) : new ROfMenusTreeVO();
            return result200;
        }
        return Promise.resolve<ROfMenusTreeVO>(<any>null);
    }

    /**
     * getAvailableSettingMenus
     * @return OK
     */
    getAvailableSettingMenus(): Promise<ROfMenusTreeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/setting-menus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAvailableSettingMenus(_response);
        });
    }

    protected processGetAvailableSettingMenus(response: AxiosResponse): Promise<ROfMenusTreeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenusTreeVO.fromJS(resultData200) : new ROfMenusTreeVO();
            return result200;
        }
        return Promise.resolve<ROfMenusTreeVO>(<any>null);
    }

    /**
     * 同步子账号数据权限
     * @param input input
     * @return OK
     */
    syncAccountDataScope(input: SyncAccountDataScopeDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/sync-sub-account-data-scope";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSyncAccountDataScope(_response);
        });
    }

    protected processSyncAccountDataScope(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 详情
     * @param id 主键
     * @return OK
     * @deprecated
     */
    getRole(id: string): Promise<ROfRoleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRole(_response);
        });
    }

    protected processGetRole(response: AxiosResponse): Promise<ROfRoleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfRoleVO.fromJS(resultData200) : new ROfRoleVO();
            return result200;
        }
        return Promise.resolve<ROfRoleVO>(<any>null);
    }

    /**
     * 更新
     * @param id id
     * @param roleBriefDto roleBriefDto
     * @return OK
     */
    update(id: string, roleBriefDto: RoleBriefDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleBriefDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 查询角色下关联的卡片Id
     * @param roleId (optional) 角色Id
     * @return OK
     */
    getCardsInMyRole(roleId: string | null | undefined): Promise<ROfIdsDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/{roleId}/cards";
        if (roleId !== null && roleId !== undefined)
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        else
            url_ = url_.replace("/{roleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCardsInMyRole(_response);
        });
    }

    protected processGetCardsInMyRole(response: AxiosResponse): Promise<ROfIdsDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIdsDTO.fromJS(resultData200) : new ROfIdsDTO();
            return result200;
        }
        return Promise.resolve<ROfIdsDTO>(<any>null);
    }

    /**
     * 角色绑定卡片
     * @param idsDTO (optional) 卡片id集合
     * @param roleId (optional) 角色Id
     * @return OK
     */
    updateCardsInMyRole(idsDTO: IdsDTO | null | undefined, roleId: string | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/{roleId}/cards";
        if (roleId !== null && roleId !== undefined)
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        else
            url_ = url_.replace("/{roleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCardsInMyRole(_response);
        });
    }

    protected processUpdateCardsInMyRole(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 查询角色下菜单列表
     * @param appCode (optional) appCode
     * @param menuEdition (optional) 菜单版本，PC-HMI-Mobile
     * @param roleId (optional) 角色Id
     * @return OK
     */
    getMenusInMyRole(appCode: string | null | undefined, menuEdition: number | null | undefined, roleId: string | null | undefined): Promise<ROfMenusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/{roleId}/menus?";
        if (roleId !== null && roleId !== undefined)
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        else
            url_ = url_.replace("/{roleId}", "");
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (menuEdition !== undefined)
            url_ += "menuEdition=" + encodeURIComponent("" + menuEdition) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMenusInMyRole(_response);
        });
    }

    protected processGetMenusInMyRole(response: AxiosResponse): Promise<ROfMenusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMenusVO.fromJS(resultData200) : new ROfMenusVO();
            return result200;
        }
        return Promise.resolve<ROfMenusVO>(<any>null);
    }

    /**
     * 角色菜单设置
     * @param menuInDto (optional) 菜单设置入参
     * @param roleId (optional) 角色Id
     * @return OK
     */
    updateMenusInMyRole(menuInDto: MasterlinkRoleMenuDto | null | undefined, roleId: string | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/roles/{roleId}/menus";
        if (roleId !== null && roleId !== undefined)
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        else
            url_ = url_.replace("/{roleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(menuInDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateMenusInMyRole(_response);
        });
    }

    protected processUpdateMenusInMyRole(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class TenantSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 卡片设置详情
     * @return OK
     */
    cardDetail(): Promise<TenantSettingVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/card";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCardDetail(_response);
        });
    }

    protected processCardDetail(response: AxiosResponse): Promise<TenantSettingVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantSettingVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantSettingVO[]>(<any>null);
    }

    /**
     * 根据条件查询租户设置
     * @param paramKey (optional) 参数键名
     * @param paramName (optional) 参数名称
     * @param paramValue (optional) 参数键值
     * @param remark (optional) 备注
     * @param tenantId (optional) 租户编号
     * @param userId (optional) 参数名称
     * @return OK
     */
    detailCondition(paramKey: string | null | undefined, paramName: string | null | undefined, paramValue: string | null | undefined, remark: string | null | undefined, tenantId: string | null | undefined, userId: string | null | undefined): Promise<TenantSettingDetailVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/detail/condition?";
        if (paramKey !== undefined)
            url_ += "paramKey=" + encodeURIComponent("" + paramKey) + "&"; 
        if (paramName !== undefined)
            url_ += "paramName=" + encodeURIComponent("" + paramName) + "&"; 
        if (paramValue !== undefined)
            url_ += "paramValue=" + encodeURIComponent("" + paramValue) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetailCondition(_response);
        });
    }

    protected processDetailCondition(response: AxiosResponse): Promise<TenantSettingDetailVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantSettingDetailVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantSettingDetailVO[]>(<any>null);
    }

    /**
     * 根据条件多paramKey查询租户设置
     * @param paramKey (optional) 参数键名(多个则,隔开)
     * @param paramName (optional) 参数名称
     * @param paramValue (optional) 参数键值
     * @param remark (optional) 备注
     * @param tenantId (optional) 租户编号
     * @param userId (optional) 参数名称
     * @return OK
     */
    detailConditions(paramKey: string | null | undefined, paramName: string | null | undefined, paramValue: string | null | undefined, remark: string | null | undefined, tenantId: string | null | undefined, userId: string | null | undefined): Promise<TenantSettingDetailVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/detail/conditions?";
        if (paramKey !== undefined)
            url_ += "paramKey=" + encodeURIComponent("" + paramKey) + "&"; 
        if (paramName !== undefined)
            url_ += "paramName=" + encodeURIComponent("" + paramName) + "&"; 
        if (paramValue !== undefined)
            url_ += "paramValue=" + encodeURIComponent("" + paramValue) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetailConditions(_response);
        });
    }

    protected processDetailConditions(response: AxiosResponse): Promise<TenantSettingDetailVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantSettingDetailVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantSettingDetailVO[]>(<any>null);
    }

    /**
     * 详情
     * @param id id
     * @return OK
     */
    detail(id: string): Promise<TenantSetting> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/detail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<TenantSetting> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TenantSetting.fromJS(resultData200) : new TenantSetting();
            return result200;
        }
        return Promise.resolve<TenantSetting>(<any>null);
    }

    /**
     * 查询租户的自定义设定
     * @param paramKey paramKey
     * @param paramName paramName
     * @param tenantId tenantId
     * @return OK
     */
    getTenantSetting(paramKey: string, paramName: string, tenantId: string): Promise<TenantSettingsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/get-setting?";
        if (paramKey === undefined || paramKey === null)
            throw new Error("The parameter 'paramKey' must be defined and cannot be null.");
        else
            url_ += "paramKey=" + encodeURIComponent("" + paramKey) + "&"; 
        if (paramName === undefined || paramName === null)
            throw new Error("The parameter 'paramName' must be defined and cannot be null.");
        else
            url_ += "paramName=" + encodeURIComponent("" + paramName) + "&"; 
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTenantSetting(_response);
        });
    }

    protected processGetTenantSetting(response: AxiosResponse): Promise<TenantSettingsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TenantSettingsVO.fromJS(resultData200) : new TenantSettingsVO();
            return result200;
        }
        return Promise.resolve<TenantSettingsVO>(<any>null);
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param paramKey (optional) 参数键名
     * @param paramName (optional) 参数名称
     * @param paramValue (optional) 参数键值
     * @param remark (optional) 备注
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户编号
     * @param userId (optional) 参数名称
     * @return OK
     */
    list(current: number | null | undefined, paramKey: string | null | undefined, paramName: string | null | undefined, paramValue: string | null | undefined, remark: string | null | undefined, size: number | null | undefined, tenantId: string | null | undefined, userId: string | null | undefined): Promise<IPageOfTenantSetting> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/list?";
        if (paramKey !== undefined)
            url_ += "paramKey=" + encodeURIComponent("" + paramKey) + "&"; 
        if (paramName !== undefined)
            url_ += "paramName=" + encodeURIComponent("" + paramName) + "&"; 
        if (paramValue !== undefined)
            url_ += "paramValue=" + encodeURIComponent("" + paramValue) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<IPageOfTenantSetting> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfTenantSetting.fromJS(resultData200) : new IPageOfTenantSetting();
            return result200;
        }
        return Promise.resolve<IPageOfTenantSetting>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids ids
     * @return OK
     */
    remove(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 保存租户自定义卡片信息
     * @param tenantCardSettingDTO tenantCardSettingDTO
     * @return OK
     */
    saveCardSetting(tenantCardSettingDTO: TenantCardSettingDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/save-card-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantCardSettingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveCardSetting(_response);
        });
    }

    protected processSaveCardSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 保存租户自定义设定
     * @param tenantCommonSettingDTO tenantCommonSettingDTO
     * @return OK
     */
    saveTenantSetting(tenantCommonSettingDTO: TenantCommonSettingDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/save-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantCommonSettingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveTenantSetting(_response);
        });
    }

    protected processSaveTenantSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新增或修改
     * @param tenantSetting tenantSetting
     * @return OK
     */
    submit(tenantSetting: TenantSetting): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/setting/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantSetting);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class SubAccountServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * list
     * @return OK
     */
    list(): Promise<SubAccountListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sub-accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<SubAccountListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? SubAccountListVO.fromJS(resultData200) : new SubAccountListVO();
            return result200;
        }
        return Promise.resolve<SubAccountListVO>(<any>null);
    }

    /**
     * create
     * @param input input
     * @return OK
     */
    create(input: SubAccountCreateDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sub-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * updateDept
     * @param subAccountUpdateDeptDTO subAccountUpdateDeptDTO
     * @return OK
     */
    updateDept(subAccountUpdateDeptDTO: SubAccountUpdateDeptDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sub-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subAccountUpdateDeptDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateDept(_response);
        });
    }

    protected processUpdateDept(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * delete
     * @param idsDTO idsDTO
     * @return OK
     */
    delete(idsDTO: IdsDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sub-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * detail
     * @param id id
     * @return OK
     */
    detail(id: string): Promise<SubAccountDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/sub-accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<SubAccountDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? SubAccountDetailVO.fromJS(resultData200) : new SubAccountDetailVO();
            return result200;
        }
        return Promise.resolve<SubAccountDetailVO>(<any>null);
    }
}

export class TenantAppServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取当前登录租户的授权app
     * @param edition edition
     * @return OK
     */
    getCurrentTenantGrantAPPList(edition: number): Promise<TenantAppVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-app?";
        if (edition === undefined || edition === null)
            throw new Error("The parameter 'edition' must be defined and cannot be null.");
        else
            url_ += "edition=" + encodeURIComponent("" + edition) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentTenantGrantAPPList(_response);
        });
    }

    protected processGetCurrentTenantGrantAPPList(response: AxiosResponse): Promise<TenantAppVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantAppVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantAppVO[]>(<any>null);
    }

    /**
     * 授权租户指定APP
     * @param appTenant appTenant
     * @return OK
     */
    grantAppForTenant(appTenant: TenantAppVO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-app";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appTenant);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGrantAppForTenant(_response);
        });
    }

    protected processGrantAppForTenant(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新租户授权APP信息
     * @param appTenant appTenant
     * @return OK
     */
    updateGrantAppForTenant(appTenant: TenantApp): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-app";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appTenant);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateGrantAppForTenant(_response);
        });
    }

    protected processUpdateGrantAppForTenant(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量取消授权
     * @param queryDto queryDto
     * @return OK
     */
    removeBatchAppCode(queryDto: TenantAppQueryDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-app";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveBatchAppCode(_response);
        });
    }

    protected processRemoveBatchAppCode(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取当前登录租户的授权app
     * @return OK
     */
    getCurrentTenantGrantApps(): Promise<TenantAppVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-app/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentTenantGrantApps(_response);
        });
    }

    protected processGetCurrentTenantGrantApps(response: AxiosResponse): Promise<TenantAppVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantAppVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantAppVO[]>(<any>null);
    }

    /**
     * 获取当前登录租户的授权app的信息
     * @return OK
     */
    getTenantAppInfo(): Promise<TenantAppInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-app/getTenantAppInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTenantAppInfo(_response);
        });
    }

    protected processGetTenantAppInfo(response: AxiosResponse): Promise<TenantAppInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantAppInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantAppInfoVO[]>(<any>null);
    }

    /**
     * 获取指定租户的授权app
     * @param tenantId tenantId
     * @return OK
     */
    getGrantAPPList(tenantId: string): Promise<TenantAppVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-app/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGrantAPPList(_response);
        });
    }

    protected processGetGrantAPPList(response: AxiosResponse): Promise<TenantAppVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantAppVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantAppVO[]>(<any>null);
    }

    /**
     * 取消授权
     * @param appCode appCode
     * @param tenantId tenantId
     * @return OK
     */
    remove(appCode: string, tenantId: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-app/{tenantId}/{appCode}";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined.");
        url_ = url_.replace("{appCode}", encodeURIComponent("" + appCode)); 
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class TenantBizFieldServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取指定业务的字段列表
     * @param bizCode bizCode
     * @param dataId (optional) dataId
     * @return OK
     */
    getTenantBizField(bizCode: string, dataId: string | null | undefined): Promise<TenantCustomBizFieldBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-biz-setting?";
        if (bizCode === undefined || bizCode === null)
            throw new Error("The parameter 'bizCode' must be defined and cannot be null.");
        else
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (dataId !== undefined)
            url_ += "dataId=" + encodeURIComponent("" + dataId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTenantBizField(_response);
        });
    }

    protected processGetTenantBizField(response: AxiosResponse): Promise<TenantCustomBizFieldBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantCustomBizFieldBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantCustomBizFieldBO[]>(<any>null);
    }

    /**
     * 修改业务字段信息
     * @param tenantCustomBizFieldUpdateDTOList tenantCustomBizFieldUpdateDTOList
     * @return OK
     */
    updateBizSystemField(tenantCustomBizFieldUpdateDTOList: TenantCustomBizFieldUpdateDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-biz-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantCustomBizFieldUpdateDTOList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateBizSystemField(_response);
        });
    }

    protected processUpdateBizSystemField(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 初始化指定业务的单据设置
     * @param tenantBizInitFieldDTO tenantBizInitFieldDTO
     * @return OK
     */
    initTenantCustomBizField(tenantBizInitFieldDTO: TenantBizInitFieldDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-biz-setting/initField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantBizInitFieldDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInitTenantCustomBizField(_response);
        });
    }

    protected processInitTenantCustomBizField(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 重置指定业务的数据类型集合
     * @param bizCode bizCode
     * @param dataId (optional) dataId
     * @param dataName (optional) dataName
     * @return OK
     */
    resetTenantCustomBizField(bizCode: string, dataId: string | null | undefined, dataName: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-biz-setting/resetField?";
        if (bizCode === undefined || bizCode === null)
            throw new Error("The parameter 'bizCode' must be defined and cannot be null.");
        else
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (dataId !== undefined)
            url_ += "dataId=" + encodeURIComponent("" + dataId) + "&"; 
        if (dataName !== undefined)
            url_ += "dataName=" + encodeURIComponent("" + dataName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetTenantCustomBizField(_response);
        });
    }

    protected processResetTenantCustomBizField(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取指定业务的数据类型集合
     * @param bizCode bizCode
     * @return OK
     */
    getTenantBizDataTypeList(bizCode: string): Promise<TenantBizDataTypeDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-biz-setting/{bizCode}/dataTypeList";
        if (bizCode === undefined || bizCode === null)
            throw new Error("The parameter 'bizCode' must be defined.");
        url_ = url_.replace("{bizCode}", encodeURIComponent("" + bizCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTenantBizDataTypeList(_response);
        });
    }

    protected processGetTenantBizDataTypeList(response: AxiosResponse): Promise<TenantBizDataTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantBizDataTypeDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantBizDataTypeDTO[]>(<any>null);
    }
}

export class TenantGatewayServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取租户下所有网关
     * @param keyWords (optional) 搜索关键词
     * @param tenantId (optional) tenantId
     * @return OK
     */
    getGateways(keyWords: string | null | undefined, tenantId: string | null | undefined): Promise<TenantGatewayVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-gateway?";
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGateways(_response);
        });
    }

    protected processGetGateways(response: AxiosResponse): Promise<TenantGatewayVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantGatewayVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantGatewayVO[]>(<any>null);
    }
}

export class TenantInitialFieldTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 逻辑删除
     * @param ids ids
     * @return OK
     */
    deleteInitialFieldType(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field-type/deleteInitialFieldType?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteInitialFieldType(_response);
        });
    }

    protected processDeleteInitialFieldType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑单据分类
     * @param initialFieldTypeDTO initialFieldTypeDTO
     * @return OK
     */
    editInitialFieldType(initialFieldTypeDTO: TenantInitialFieldTypeDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field-type/editInitialFieldType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(initialFieldTypeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditInitialFieldType(_response);
        });
    }

    protected processEditInitialFieldType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 单据分类管理列表
     * @return OK
     */
    getInitialFieldTypelist(): Promise<TenantInitialFieldTypeDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field-type/getInitialFieldTypelist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetInitialFieldTypelist(_response);
        });
    }

    protected processGetInitialFieldTypelist(response: AxiosResponse): Promise<TenantInitialFieldTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantInitialFieldTypeDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantInitialFieldTypeDTO[]>(<any>null);
    }

    /**
     * 新增单据分类
     * @param initialFieldTypeDTO initialFieldTypeDTO
     * @return OK
     */
    saveInitialFieldType(initialFieldTypeDTO: TenantInitialFieldTypeDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field-type/saveInitialFieldType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(initialFieldTypeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveInitialFieldType(_response);
        });
    }

    protected processSaveInitialFieldType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class TenantInitialFieldServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 逻辑删除
     * @param ids ids
     * @return OK
     */
    deleteInitialField(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field/deleteInitialField?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteInitialField(_response);
        });
    }

    protected processDeleteInitialField(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑单据初始字段
     * @param initialFieldDTO initialFieldDTO
     * @return OK
     */
    editInitialField(initialFieldDTO: TenantInitialFieldDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field/editInitialField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(initialFieldDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditInitialField(_response);
        });
    }

    protected processEditInitialField(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑单据初始字段使用状态(启用、禁用)
     * @param id id
     * @param status status(0-禁用;1-启用)
     * @return OK
     */
    editstatus(id: string, status: number): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field/editstatus?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditstatus(_response);
        });
    }

    protected processEditstatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 初始化字段列表
     * @param bizCode bizCode
     * @return OK
     */
    getInitialFieldlist(bizCode: string): Promise<TenantInitialFieldDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field/getInitialFieldlist?";
        if (bizCode === undefined || bizCode === null)
            throw new Error("The parameter 'bizCode' must be defined and cannot be null.");
        else
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetInitialFieldlist(_response);
        });
    }

    protected processGetInitialFieldlist(response: AxiosResponse): Promise<TenantInitialFieldDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantInitialFieldDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantInitialFieldDTO[]>(<any>null);
    }

    /**
     * 新增单据初始字段
     * @param initialFieldDTO initialFieldDTO
     * @return OK
     */
    saveInitialField(initialFieldDTO: TenantInitialFieldDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-initial-field/saveInitialField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(initialFieldDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveInitialField(_response);
        });
    }

    protected processSaveInitialField(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class TenantMenuServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询当前租户所有菜单信息
     * @return OK
     */
    getCurrentTenantMenus(): Promise<TenantAppMenuDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenant-menus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentTenantMenus(_response);
        });
    }

    protected processGetCurrentTenantMenus(response: AxiosResponse): Promise<TenantAppMenuDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantAppMenuDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TenantAppMenuDTO[]>(<any>null);
    }
}

export class MasterlinkTenantServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增租户
     * @param tenant tenant
     * @return OK
     */
    createTenant(tenant: CreateTenantDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenant);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改租户
     * @param tenant tenant
     * @return OK
     */
    updateTenant(tenant: UpdateTenantDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenant);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateTenant(_response);
        });
    }

    protected processUpdateTenant(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 通过tenantId获取租户详情
     * @param tenantId (optional) 租户tenantId
     * @return OK
     */
    queryRole(tenantId: string | null | undefined): Promise<ROfTenantVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants/detail/{tenantId}";
        if (tenantId !== null && tenantId !== undefined)
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId)); 
        else
            url_ = url_.replace("/{tenantId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryRole(_response);
        });
    }

    protected processQueryRole(response: AxiosResponse): Promise<ROfTenantVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfTenantVO.fromJS(resultData200) : new ROfTenantVO();
            return result200;
        }
        return Promise.resolve<ROfTenantVO>(<any>null);
    }

    /**
     * 租户信息分页
     * @param contactNumber (optional) 联系电话
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param tenantCode (optional) 租户编号
     * @param tenantName (optional) 租户名称
     * @return OK
     */
    getTenants(contactNumber: string | null | undefined, current: number | null | undefined, size: number | null | undefined, tenantCode: string | null | undefined, tenantName: string | null | undefined): Promise<ROfIPageOfTenant> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants/page?";
        if (contactNumber !== undefined)
            url_ += "contactNumber=" + encodeURIComponent("" + contactNumber) + "&"; 
        if (tenantCode !== undefined)
            url_ += "tenantCode=" + encodeURIComponent("" + tenantCode) + "&"; 
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: AxiosResponse): Promise<ROfIPageOfTenant> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfTenant.fromJS(resultData200) : new ROfIPageOfTenant();
            return result200;
        }
        return Promise.resolve<ROfIPageOfTenant>(<any>null);
    }

    /**
     * 授权配置
     * @param tenantSettingDTO tenantSettingDTO
     * @return OK
     */
    setting(tenantSettingDTO: TenantSettingDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants/setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantSettingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetting(_response);
        });
    }

    protected processSetting(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 更改租户code
     * @param updateTenantDto updateTenantDto
     * @return OK
     */
    updateTenantCode(updateTenantDto: UpdateTenantDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants/tenantCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTenantDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateTenantCode(_response);
        });
    }

    protected processUpdateTenantCode(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 删除租户
     * @param ids 主键集合
     * @return OK
     */
    deleteTenant(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants/{ids}";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined.");
        url_ = url_.replace("{ids}", encodeURIComponent("" + ids)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteTenant(_response);
        });
    }

    protected processDeleteTenant(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 租户详情
     * @param id (optional) 租户Id
     * @return OK
     */
    getRole(id: string | null | undefined): Promise<ROfTenantVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRole(_response);
        });
    }

    protected processGetRole(response: AxiosResponse): Promise<ROfTenantVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfTenantVO.fromJS(resultData200) : new ROfTenantVO();
            return result200;
        }
        return Promise.resolve<ROfTenantVO>(<any>null);
    }

    /**
     * 租户code是否存在
     * @param tenantCode tenantCode
     * @return OK
     */
    tenantExist(tenantCode: string): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/tenants/{tenantCode}/exist";
        if (tenantCode === undefined || tenantCode === null)
            throw new Error("The parameter 'tenantCode' must be defined.");
        url_ = url_.replace("{tenantCode}", encodeURIComponent("" + tenantCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTenantExist(_response);
        });
    }

    protected processTenantExist(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }
}

export class TopMenuServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param code (optional) 顶部菜单编号
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param name (optional) 顶部菜单名
     * @param sort (optional) 顶部菜单排序
     * @param source (optional) 顶部菜单资源
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    detail(code: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, name: string | null | undefined, sort: number | null | undefined, source: string | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfTopMenu> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/topmenu/detail?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfTopMenu> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfTopMenu.fromJS(resultData200) : new ROfTopMenu();
            return result200;
        }
        return Promise.resolve<ROfTopMenu>(<any>null);
    }

    /**
     * 顶部菜单配置
     * @param menuIds menuId集合
     * @param topMenuIds topMenuId集合
     * @return OK
     */
    grant(menuIds: string, topMenuIds: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/topmenu/grant?";
        if (menuIds === undefined || menuIds === null)
            throw new Error("The parameter 'menuIds' must be defined and cannot be null.");
        else
            url_ += "menuIds=" + encodeURIComponent("" + menuIds) + "&"; 
        if (topMenuIds === undefined || topMenuIds === null)
            throw new Error("The parameter 'topMenuIds' must be defined and cannot be null.");
        else
            url_ += "topMenuIds=" + encodeURIComponent("" + topMenuIds) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGrant(_response);
        });
    }

    protected processGrant(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 分页
     * @param code (optional) 顶部菜单编号
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param name (optional) 顶部菜单名
     * @param size (optional) 每页的数量
     * @param sort (optional) 顶部菜单排序
     * @param source (optional) 顶部菜单资源
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    list(code: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, name: string | null | undefined, size: number | null | undefined, sort: number | null | undefined, source: string | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfTopMenu> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/topmenu/list?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&"; 
        if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfIPageOfTopMenu> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfTopMenu.fromJS(resultData200) : new ROfIPageOfTopMenu();
            return result200;
        }
        return Promise.resolve<ROfIPageOfTopMenu>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/topmenu/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增
     * @param topMenu topMenu
     * @return OK
     */
    save(topMenu: TopMenu): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/topmenu/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topMenu);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param topMenu topMenu
     * @return OK
     */
    submit(topMenu: TopMenu): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/topmenu/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topMenu);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param topMenu topMenu
     * @return OK
     */
    update(topMenu: TopMenu): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-system')+ "/topmenu/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topMenu);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class ApiScope implements IApiScope {
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 接口方法类型 */
    httpMethod!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 菜单主键 */
    menuId!: string | undefined;
    /** 接口权限备注 */
    remark!: string | undefined;
    /** 资源编号 */
    resourceCode!: string | undefined;
    /** 接口权限名称 */
    scopeName!: string | undefined;
    /** 接口权限字段 */
    scopePath!: string | undefined;
    /** 接口权限类型 */
    scopeType!: number | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IApiScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.httpMethod = data["httpMethod"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.menuId = data["menuId"];
            this.remark = data["remark"];
            this.resourceCode = data["resourceCode"];
            this.scopeName = data["scopeName"];
            this.scopePath = data["scopePath"];
            this.scopeType = data["scopeType"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): ApiScope {
        data = typeof data === 'object' ? data : {};
        let result = new ApiScope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["httpMethod"] = this.httpMethod;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["menuId"] = this.menuId;
        data["remark"] = this.remark;
        data["resourceCode"] = this.resourceCode;
        data["scopeName"] = this.scopeName;
        data["scopePath"] = this.scopePath;
        data["scopeType"] = this.scopeType;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IApiScope {
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 接口方法类型 */
    httpMethod: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 菜单主键 */
    menuId: string | undefined;
    /** 接口权限备注 */
    remark: string | undefined;
    /** 资源编号 */
    resourceCode: string | undefined;
    /** 接口权限名称 */
    scopeName: string | undefined;
    /** 接口权限字段 */
    scopePath: string | undefined;
    /** 接口权限类型 */
    scopeType: number | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class ApiScopeVO implements IApiScopeVO {
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 接口方法类型 */
    httpMethod!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 菜单主键 */
    menuId!: string | undefined;
    /** 接口权限备注 */
    remark!: string | undefined;
    /** 资源编号 */
    resourceCode!: string | undefined;
    /** 接口权限名称 */
    scopeName!: string | undefined;
    /** 接口权限字段 */
    scopePath!: string | undefined;
    /** 接口权限类型 */
    scopeType!: number | undefined;
    scopeTypeName!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IApiScopeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.httpMethod = data["httpMethod"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.menuId = data["menuId"];
            this.remark = data["remark"];
            this.resourceCode = data["resourceCode"];
            this.scopeName = data["scopeName"];
            this.scopePath = data["scopePath"];
            this.scopeType = data["scopeType"];
            this.scopeTypeName = data["scopeTypeName"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): ApiScopeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ApiScopeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["httpMethod"] = this.httpMethod;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["menuId"] = this.menuId;
        data["remark"] = this.remark;
        data["resourceCode"] = this.resourceCode;
        data["scopeName"] = this.scopeName;
        data["scopePath"] = this.scopePath;
        data["scopeType"] = this.scopeType;
        data["scopeTypeName"] = this.scopeTypeName;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IApiScopeVO {
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 接口方法类型 */
    httpMethod: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 菜单主键 */
    menuId: string | undefined;
    /** 接口权限备注 */
    remark: string | undefined;
    /** 资源编号 */
    resourceCode: string | undefined;
    /** 接口权限名称 */
    scopeName: string | undefined;
    /** 接口权限字段 */
    scopePath: string | undefined;
    /** 接口权限类型 */
    scopeType: number | undefined;
    scopeTypeName: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** App管理 */
export class App implements IApp {
    /** app受众 */
    audience!: number | undefined;
    /** app图片地址 */
    avatar!: string | undefined;
    /** 业务菜单ids */
    bizMenuId!: string | undefined;
    /** app编号 */
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** app简介 */
    description!: string | undefined;
    /** app名称 */
    displayName!: string | undefined;
    /** app版本 */
    edition!: number | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** app上下架状态 */
    saleStatus!: number | undefined;
    /** app发布状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.audience = data["audience"];
            this.avatar = data["avatar"];
            this.bizMenuId = data["bizMenuId"];
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.description = data["description"];
            this.displayName = data["displayName"];
            this.edition = data["edition"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.saleStatus = data["saleStatus"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): App {
        data = typeof data === 'object' ? data : {};
        let result = new App();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["audience"] = this.audience;
        data["avatar"] = this.avatar;
        data["bizMenuId"] = this.bizMenuId;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["description"] = this.description;
        data["displayName"] = this.displayName;
        data["edition"] = this.edition;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["saleStatus"] = this.saleStatus;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** App管理 */
export interface IApp {
    /** app受众 */
    audience: number | undefined;
    /** app图片地址 */
    avatar: string | undefined;
    /** 业务菜单ids */
    bizMenuId: string | undefined;
    /** app编号 */
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** app简介 */
    description: string | undefined;
    /** app名称 */
    displayName: string | undefined;
    /** app版本 */
    edition: number | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** app上下架状态 */
    saleStatus: number | undefined;
    /** app发布状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** app卡片 */
export class AppCard implements IAppCard {
    /** app编号 */
    appId!: string | undefined;
    /** 卡片图片路径 */
    avatar!: string | undefined;
    /** 组件key */
    componentKey!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 卡片简介 */
    description!: string | undefined;
    /** 卡片名称 */
    displayName!: string | undefined;
    /** 版本 */
    edition!: number | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IAppCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appId = data["appId"];
            this.avatar = data["avatar"];
            this.componentKey = data["componentKey"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.description = data["description"];
            this.displayName = data["displayName"];
            this.edition = data["edition"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): AppCard {
        data = typeof data === 'object' ? data : {};
        let result = new AppCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["avatar"] = this.avatar;
        data["componentKey"] = this.componentKey;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["description"] = this.description;
        data["displayName"] = this.displayName;
        data["edition"] = this.edition;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** app卡片 */
export interface IAppCard {
    /** app编号 */
    appId: string | undefined;
    /** 卡片图片路径 */
    avatar: string | undefined;
    /** 组件key */
    componentKey: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 卡片简介 */
    description: string | undefined;
    /** 卡片名称 */
    displayName: string | undefined;
    /** 版本 */
    edition: number | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** app卡片 */
export class AppCardDTO implements IAppCardDTO {
    /** app编号 */
    appId!: string | undefined;
    /** 卡片图片路径 */
    avatar!: string | undefined;
    code!: string | undefined;
    /** 组件key */
    componentKey!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 卡片简介 */
    description!: string | undefined;
    /** 卡片名称 */
    displayName!: string | undefined;
    /** 版本 */
    edition!: number | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IAppCardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appId = data["appId"];
            this.avatar = data["avatar"];
            this.code = data["code"];
            this.componentKey = data["componentKey"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.description = data["description"];
            this.displayName = data["displayName"];
            this.edition = data["edition"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): AppCardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppCardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["avatar"] = this.avatar;
        data["code"] = this.code;
        data["componentKey"] = this.componentKey;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["description"] = this.description;
        data["displayName"] = this.displayName;
        data["edition"] = this.edition;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** app卡片 */
export interface IAppCardDTO {
    /** app编号 */
    appId: string | undefined;
    /** 卡片图片路径 */
    avatar: string | undefined;
    code: string | undefined;
    /** 组件key */
    componentKey: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 卡片简介 */
    description: string | undefined;
    /** 卡片名称 */
    displayName: string | undefined;
    /** 版本 */
    edition: number | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class AppCardScope implements IAppCardScope {
    /** 卡片Id */
    cardId!: string | undefined;
    /** appCode */
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    deptId!: string | undefined;
    /** 卡片名称 */
    displayName!: string | undefined;
    /** http请求方法 */
    httpMethod!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 资源编号 */
    resourceCode!: string | undefined;
    /** 接口权限名 */
    scopeName!: string | undefined;
    /** 接口权限地址 */
    scopePath!: string | undefined;
    /** 接口权限类型 */
    scopeType!: number | undefined;
    /** 状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IAppCardScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardId = data["cardId"];
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.deptId = data["deptId"];
            this.displayName = data["displayName"];
            this.httpMethod = data["httpMethod"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.resourceCode = data["resourceCode"];
            this.scopeName = data["scopeName"];
            this.scopePath = data["scopePath"];
            this.scopeType = data["scopeType"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): AppCardScope {
        data = typeof data === 'object' ? data : {};
        let result = new AppCardScope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["deptId"] = this.deptId;
        data["displayName"] = this.displayName;
        data["httpMethod"] = this.httpMethod;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["resourceCode"] = this.resourceCode;
        data["scopeName"] = this.scopeName;
        data["scopePath"] = this.scopePath;
        data["scopeType"] = this.scopeType;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IAppCardScope {
    /** 卡片Id */
    cardId: string | undefined;
    /** appCode */
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    deptId: string | undefined;
    /** 卡片名称 */
    displayName: string | undefined;
    /** http请求方法 */
    httpMethod: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 资源编号 */
    resourceCode: string | undefined;
    /** 接口权限名 */
    scopeName: string | undefined;
    /** 接口权限地址 */
    scopePath: string | undefined;
    /** 接口权限类型 */
    scopeType: number | undefined;
    /** 状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class AppCardScopeVO implements IAppCardScopeVO {
    /** appCode */
    code!: string | undefined;
    deptId!: string | undefined;
    /** 卡片名称 */
    displayName!: string | undefined;
    /** http请求方法 */
    httpMethod!: string | undefined;
    /** 编号 */
    id!: string | undefined;
    /** 资源编号 */
    resourceCode!: string | undefined;
    /** 接口权限名 */
    scopeName!: string | undefined;
    /** 接口权限地址 */
    scopePath!: string | undefined;
    /** 接口权限类型 */
    scopeType!: number | undefined;
    /** 状态 */
    status!: number | undefined;

    constructor(data?: IAppCardScopeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.displayName = data["displayName"];
            this.httpMethod = data["httpMethod"];
            this.id = data["id"];
            this.resourceCode = data["resourceCode"];
            this.scopeName = data["scopeName"];
            this.scopePath = data["scopePath"];
            this.scopeType = data["scopeType"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): AppCardScopeVO {
        data = typeof data === 'object' ? data : {};
        let result = new AppCardScopeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["displayName"] = this.displayName;
        data["httpMethod"] = this.httpMethod;
        data["id"] = this.id;
        data["resourceCode"] = this.resourceCode;
        data["scopeName"] = this.scopeName;
        data["scopePath"] = this.scopePath;
        data["scopeType"] = this.scopeType;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAppCardScopeVO {
    /** appCode */
    code: string | undefined;
    deptId: string | undefined;
    /** 卡片名称 */
    displayName: string | undefined;
    /** http请求方法 */
    httpMethod: string | undefined;
    /** 编号 */
    id: string | undefined;
    /** 资源编号 */
    resourceCode: string | undefined;
    /** 接口权限名 */
    scopeName: string | undefined;
    /** 接口权限地址 */
    scopePath: string | undefined;
    /** 接口权限类型 */
    scopeType: number | undefined;
    /** 状态 */
    status: number | undefined;
}

/** app扩展信息 */
export class AppExtend implements IAppExtend {
    /** 应用文案 */
    appCopywriting!: string | undefined;
    /** appId */
    appId!: string | undefined;
    /** 版本发布日志 */
    appReleaseNote!: string | undefined;
    id!: string | undefined;

    constructor(data?: IAppExtend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCopywriting = data["appCopywriting"];
            this.appId = data["appId"];
            this.appReleaseNote = data["appReleaseNote"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AppExtend {
        data = typeof data === 'object' ? data : {};
        let result = new AppExtend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCopywriting"] = this.appCopywriting;
        data["appId"] = this.appId;
        data["appReleaseNote"] = this.appReleaseNote;
        data["id"] = this.id;
        return data; 
    }
}

/** app扩展信息 */
export interface IAppExtend {
    /** 应用文案 */
    appCopywriting: string | undefined;
    /** appId */
    appId: string | undefined;
    /** 版本发布日志 */
    appReleaseNote: string | undefined;
    id: string | undefined;
}

export class AppMenuInputDTO implements IAppMenuInputDTO {
    appId!: string;
    menuIds!: string[] | undefined;

    constructor(data?: IAppMenuInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appId = data["appId"];
            if (data["menuIds"] && data["menuIds"].constructor === Array) {
                this.menuIds = [] as any;
                for (let item of data["menuIds"])
                    this.menuIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppMenuInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppMenuInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        if (this.menuIds && this.menuIds.constructor === Array) {
            data["menuIds"] = [];
            for (let item of this.menuIds)
                data["menuIds"].push(item);
        }
        return data; 
    }
}

export interface IAppMenuInputDTO {
    appId: string;
    menuIds: string[] | undefined;
}

export class AppMenusVO implements IAppMenusVO {
    /** app编号 */
    appCode!: string | undefined;
    /** app编号 */
    appId!: string | undefined;
    /** app名称 */
    displayName!: string | undefined;
    /** app版本 */
    edition!: number | undefined;
    /** app菜单树 */
    menuTree!: MasterlinkMenuTreeNode[] | undefined;

    constructor(data?: IAppMenusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.appId = data["appId"];
            this.displayName = data["displayName"];
            this.edition = data["edition"];
            if (data["menuTree"] && data["menuTree"].constructor === Array) {
                this.menuTree = [] as any;
                for (let item of data["menuTree"])
                    this.menuTree!.push(MasterlinkMenuTreeNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppMenusVO {
        data = typeof data === 'object' ? data : {};
        let result = new AppMenusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["appId"] = this.appId;
        data["displayName"] = this.displayName;
        data["edition"] = this.edition;
        if (this.menuTree && this.menuTree.constructor === Array) {
            data["menuTree"] = [];
            for (let item of this.menuTree)
                data["menuTree"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppMenusVO {
    /** app编号 */
    appCode: string | undefined;
    /** app编号 */
    appId: string | undefined;
    /** app名称 */
    displayName: string | undefined;
    /** app版本 */
    edition: number | undefined;
    /** app菜单树 */
    menuTree: MasterlinkMenuTreeNode[] | undefined;
}

export class AppStatusInputDTO implements IAppStatusInputDTO {
    appIds!: string[] | undefined;
    status!: number | undefined;

    constructor(data?: IAppStatusInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["appIds"] && data["appIds"].constructor === Array) {
                this.appIds = [] as any;
                for (let item of data["appIds"])
                    this.appIds!.push(item);
            }
            this.status = data["status"];
        }
    }

    static fromJS(data: any): AppStatusInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppStatusInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.appIds && this.appIds.constructor === Array) {
            data["appIds"] = [];
            for (let item of this.appIds)
                data["appIds"].push(item);
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IAppStatusInputDTO {
    appIds: string[] | undefined;
    status: number | undefined;
}

export class AppsVO implements IAppsVO {
    appList!: MyAppDto[] | undefined;

    constructor(data?: IAppsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["appList"] && data["appList"].constructor === Array) {
                this.appList = [] as any;
                for (let item of data["appList"])
                    this.appList!.push(MyAppDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppsVO {
        data = typeof data === 'object' ? data : {};
        let result = new AppsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.appList && this.appList.constructor === Array) {
            data["appList"] = [];
            for (let item of this.appList)
                data["appList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppsVO {
    appList: MyAppDto[] | undefined;
}

export class AuthClient implements IAuthClient {
    /** 令牌过期秒数 */
    accessTokenValidity!: number | undefined;
    /** 附加说明 */
    additionalInformation!: string | undefined;
    /** 权限 */
    authorities!: string | undefined;
    /** 授权类型 */
    authorizedGrantTypes!: string | undefined;
    /** 自动授权 */
    autoapprove!: string | undefined;
    /** 客户端id */
    clientId!: string | undefined;
    /** 客户端密钥 */
    clientSecret!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 刷新令牌过期秒数 */
    refreshTokenValidity!: number | undefined;
    /** 资源集合 */
    resourceIds!: string | undefined;
    /** 授权范围 */
    scope!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;
    /** 回调地址 */
    webServerRedirectUri!: string | undefined;

    constructor(data?: IAuthClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessTokenValidity = data["accessTokenValidity"];
            this.additionalInformation = data["additionalInformation"];
            this.authorities = data["authorities"];
            this.authorizedGrantTypes = data["authorizedGrantTypes"];
            this.autoapprove = data["autoapprove"];
            this.clientId = data["clientId"];
            this.clientSecret = data["clientSecret"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.refreshTokenValidity = data["refreshTokenValidity"];
            this.resourceIds = data["resourceIds"];
            this.scope = data["scope"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
            this.webServerRedirectUri = data["webServerRedirectUri"];
        }
    }

    static fromJS(data: any): AuthClient {
        data = typeof data === 'object' ? data : {};
        let result = new AuthClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessTokenValidity"] = this.accessTokenValidity;
        data["additionalInformation"] = this.additionalInformation;
        data["authorities"] = this.authorities;
        data["authorizedGrantTypes"] = this.authorizedGrantTypes;
        data["autoapprove"] = this.autoapprove;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["refreshTokenValidity"] = this.refreshTokenValidity;
        data["resourceIds"] = this.resourceIds;
        data["scope"] = this.scope;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        data["webServerRedirectUri"] = this.webServerRedirectUri;
        return data; 
    }
}

export interface IAuthClient {
    /** 令牌过期秒数 */
    accessTokenValidity: number | undefined;
    /** 附加说明 */
    additionalInformation: string | undefined;
    /** 权限 */
    authorities: string | undefined;
    /** 授权类型 */
    authorizedGrantTypes: string | undefined;
    /** 自动授权 */
    autoapprove: string | undefined;
    /** 客户端id */
    clientId: string | undefined;
    /** 客户端密钥 */
    clientSecret: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 刷新令牌过期秒数 */
    refreshTokenValidity: number | undefined;
    /** 资源集合 */
    resourceIds: string | undefined;
    /** 授权范围 */
    scope: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
    /** 回调地址 */
    webServerRedirectUri: string | undefined;
}

export class AuthorityDomainDto implements IAuthorityDomainDto {
    /** 名称 */
    deptName!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 1：启用，0：禁用 */
    isEnable!: number | undefined;
    /** 父级Id */
    parentId!: string | undefined;
    /** 描述 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;

    constructor(data?: IAuthorityDomainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deptName = data["deptName"];
            this.id = data["id"];
            this.isEnable = data["isEnable"];
            this.parentId = data["parentId"];
            this.remark = data["remark"];
            this.sort = data["sort"];
        }
    }

    static fromJS(data: any): AuthorityDomainDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityDomainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deptName"] = this.deptName;
        data["id"] = this.id;
        data["isEnable"] = this.isEnable;
        data["parentId"] = this.parentId;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        return data; 
    }
}

export interface IAuthorityDomainDto {
    /** 名称 */
    deptName: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 1：启用，0：禁用 */
    isEnable: number | undefined;
    /** 父级Id */
    parentId: string | undefined;
    /** 描述 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
}

export class AuthorityDomainTreeDto implements IAuthorityDomainTreeDto {
    attribute!: any | undefined;
    children!: AuthorityDomainTreeDto[] | undefined;
    data!: AuthorityDomainDto | undefined;
    id!: string | undefined;
    key!: string | undefined;
    parentId!: string | undefined;
    title!: string | undefined;
    value!: string | undefined;

    constructor(data?: IAuthorityDomainTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attribute = data["attribute"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(AuthorityDomainTreeDto.fromJS(item));
            }
            this.data = data["data"] ? AuthorityDomainDto.fromJS(data["data"]) : <any>undefined;
            this.id = data["id"];
            this.key = data["key"];
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): AuthorityDomainTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityDomainTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["value"] = this.value;
        return data; 
    }
}

export interface IAuthorityDomainTreeDto {
    attribute: any | undefined;
    children: AuthorityDomainTreeDto[] | undefined;
    data: AuthorityDomainDto | undefined;
    id: string | undefined;
    key: string | undefined;
    parentId: string | undefined;
    title: string | undefined;
    value: string | undefined;
}

export class CheckedTreeVO implements ICheckedTreeVO {
    apiScope!: string[] | undefined;
    dataScope!: string[] | undefined;
    menu!: string[] | undefined;

    constructor(data?: ICheckedTreeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["apiScope"] && data["apiScope"].constructor === Array) {
                this.apiScope = [] as any;
                for (let item of data["apiScope"])
                    this.apiScope!.push(item);
            }
            if (data["dataScope"] && data["dataScope"].constructor === Array) {
                this.dataScope = [] as any;
                for (let item of data["dataScope"])
                    this.dataScope!.push(item);
            }
            if (data["menu"] && data["menu"].constructor === Array) {
                this.menu = [] as any;
                for (let item of data["menu"])
                    this.menu!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckedTreeVO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckedTreeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.apiScope && this.apiScope.constructor === Array) {
            data["apiScope"] = [];
            for (let item of this.apiScope)
                data["apiScope"].push(item);
        }
        if (this.dataScope && this.dataScope.constructor === Array) {
            data["dataScope"] = [];
            for (let item of this.dataScope)
                data["dataScope"].push(item);
        }
        if (this.menu && this.menu.constructor === Array) {
            data["menu"] = [];
            for (let item of this.menu)
                data["menu"].push(item);
        }
        return data; 
    }
}

export interface ICheckedTreeVO {
    apiScope: string[] | undefined;
    dataScope: string[] | undefined;
    menu: string[] | undefined;
}

export class CreateTenantDTO implements ICreateTenantDTO {
    /** 联系地址 */
    address!: string | undefined;
    appCodeList!: string[] | undefined;
    /** 租户身份 */
    classes!: number | undefined;
    /** 联系电话 */
    contactNumber!: string | undefined;
    /** 域名地址 */
    domain!: string | undefined;
    /** 联系人 */
    linkman!: string | undefined;
    /** 租户编号 */
    tenantCode!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 租户名称 */
    tenantName!: string | undefined;

    constructor(data?: ICreateTenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            if (data["appCodeList"] && data["appCodeList"].constructor === Array) {
                this.appCodeList = [] as any;
                for (let item of data["appCodeList"])
                    this.appCodeList!.push(item);
            }
            this.classes = data["classes"];
            this.contactNumber = data["contactNumber"];
            this.domain = data["domain"];
            this.linkman = data["linkman"];
            this.tenantCode = data["tenantCode"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): CreateTenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        if (this.appCodeList && this.appCodeList.constructor === Array) {
            data["appCodeList"] = [];
            for (let item of this.appCodeList)
                data["appCodeList"].push(item);
        }
        data["classes"] = this.classes;
        data["contactNumber"] = this.contactNumber;
        data["domain"] = this.domain;
        data["linkman"] = this.linkman;
        data["tenantCode"] = this.tenantCode;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface ICreateTenantDTO {
    /** 联系地址 */
    address: string | undefined;
    appCodeList: string[] | undefined;
    /** 租户身份 */
    classes: number | undefined;
    /** 联系电话 */
    contactNumber: string | undefined;
    /** 域名地址 */
    domain: string | undefined;
    /** 联系人 */
    linkman: string | undefined;
    /** 租户编号 */
    tenantCode: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 租户名称 */
    tenantName: string | undefined;
}

export class DataScope implements IDataScope {
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 菜单主键 */
    menuId!: string | undefined;
    /** 数据权限备注 */
    remark!: string | undefined;
    /** 资源编号 */
    resourceCode!: string | undefined;
    /** 数据权限类名 */
    scopeClass!: string | undefined;
    /** 数据权限字段 */
    scopeColumn!: string | undefined;
    /** 数据权限可见字段 */
    scopeField!: string | undefined;
    /** 数据权限名称 */
    scopeName!: string | undefined;
    /** 数据权限类型 */
    scopeType!: number | undefined;
    /** 数据权限值域 */
    scopeValue!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IDataScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.menuId = data["menuId"];
            this.remark = data["remark"];
            this.resourceCode = data["resourceCode"];
            this.scopeClass = data["scopeClass"];
            this.scopeColumn = data["scopeColumn"];
            this.scopeField = data["scopeField"];
            this.scopeName = data["scopeName"];
            this.scopeType = data["scopeType"];
            this.scopeValue = data["scopeValue"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): DataScope {
        data = typeof data === 'object' ? data : {};
        let result = new DataScope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["menuId"] = this.menuId;
        data["remark"] = this.remark;
        data["resourceCode"] = this.resourceCode;
        data["scopeClass"] = this.scopeClass;
        data["scopeColumn"] = this.scopeColumn;
        data["scopeField"] = this.scopeField;
        data["scopeName"] = this.scopeName;
        data["scopeType"] = this.scopeType;
        data["scopeValue"] = this.scopeValue;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IDataScope {
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 菜单主键 */
    menuId: string | undefined;
    /** 数据权限备注 */
    remark: string | undefined;
    /** 资源编号 */
    resourceCode: string | undefined;
    /** 数据权限类名 */
    scopeClass: string | undefined;
    /** 数据权限字段 */
    scopeColumn: string | undefined;
    /** 数据权限可见字段 */
    scopeField: string | undefined;
    /** 数据权限名称 */
    scopeName: string | undefined;
    /** 数据权限类型 */
    scopeType: number | undefined;
    /** 数据权限值域 */
    scopeValue: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class DataScopeVO implements IDataScopeVO {
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 菜单主键 */
    menuId!: string | undefined;
    /** 数据权限备注 */
    remark!: string | undefined;
    /** 资源编号 */
    resourceCode!: string | undefined;
    /** 数据权限类名 */
    scopeClass!: string | undefined;
    /** 数据权限字段 */
    scopeColumn!: string | undefined;
    /** 数据权限可见字段 */
    scopeField!: string | undefined;
    /** 数据权限名称 */
    scopeName!: string | undefined;
    /** 数据权限类型 */
    scopeType!: number | undefined;
    scopeTypeName!: string | undefined;
    /** 数据权限值域 */
    scopeValue!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IDataScopeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.menuId = data["menuId"];
            this.remark = data["remark"];
            this.resourceCode = data["resourceCode"];
            this.scopeClass = data["scopeClass"];
            this.scopeColumn = data["scopeColumn"];
            this.scopeField = data["scopeField"];
            this.scopeName = data["scopeName"];
            this.scopeType = data["scopeType"];
            this.scopeTypeName = data["scopeTypeName"];
            this.scopeValue = data["scopeValue"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): DataScopeVO {
        data = typeof data === 'object' ? data : {};
        let result = new DataScopeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["menuId"] = this.menuId;
        data["remark"] = this.remark;
        data["resourceCode"] = this.resourceCode;
        data["scopeClass"] = this.scopeClass;
        data["scopeColumn"] = this.scopeColumn;
        data["scopeField"] = this.scopeField;
        data["scopeName"] = this.scopeName;
        data["scopeType"] = this.scopeType;
        data["scopeTypeName"] = this.scopeTypeName;
        data["scopeValue"] = this.scopeValue;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IDataScopeVO {
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 菜单主键 */
    menuId: string | undefined;
    /** 数据权限备注 */
    remark: string | undefined;
    /** 资源编号 */
    resourceCode: string | undefined;
    /** 数据权限类名 */
    scopeClass: string | undefined;
    /** 数据权限字段 */
    scopeColumn: string | undefined;
    /** 数据权限可见字段 */
    scopeField: string | undefined;
    /** 数据权限名称 */
    scopeName: string | undefined;
    /** 数据权限类型 */
    scopeType: number | undefined;
    scopeTypeName: string | undefined;
    /** 数据权限值域 */
    scopeValue: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class Dept implements IDept {
    /** 祖级机构主键 */
    ancestors!: string | undefined;
    /** 机构类型 */
    deptCategory!: number | undefined;
    /** 机构名 */
    deptName!: string | undefined;
    /** 机构全称 */
    fullName!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否已启用 */
    isEnable!: number | undefined;
    /** 父主键 */
    parentId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IDept) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ancestors = data["ancestors"];
            this.deptCategory = data["deptCategory"];
            this.deptName = data["deptName"];
            this.fullName = data["fullName"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isEnable = data["isEnable"];
            this.parentId = data["parentId"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): Dept {
        data = typeof data === 'object' ? data : {};
        let result = new Dept();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ancestors"] = this.ancestors;
        data["deptCategory"] = this.deptCategory;
        data["deptName"] = this.deptName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isEnable"] = this.isEnable;
        data["parentId"] = this.parentId;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IDept {
    /** 祖级机构主键 */
    ancestors: string | undefined;
    /** 机构类型 */
    deptCategory: number | undefined;
    /** 机构名 */
    deptName: string | undefined;
    /** 机构全称 */
    fullName: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否已启用 */
    isEnable: number | undefined;
    /** 父主键 */
    parentId: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class DeptVO implements IDeptVO {
    /** 祖级机构主键 */
    ancestors!: string | undefined;
    children!: DeptVO[] | undefined;
    /** 机构类型 */
    deptCategory!: number | undefined;
    deptCategoryName!: string | undefined;
    /** 机构名 */
    deptName!: string | undefined;
    /** 机构全称 */
    fullName!: string | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否已启用 */
    isEnable!: number | undefined;
    parentId!: string | undefined;
    parentName!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IDeptVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ancestors = data["ancestors"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(DeptVO.fromJS(item));
            }
            this.deptCategory = data["deptCategory"];
            this.deptCategoryName = data["deptCategoryName"];
            this.deptName = data["deptName"];
            this.fullName = data["fullName"];
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isEnable = data["isEnable"];
            this.parentId = data["parentId"];
            this.parentName = data["parentName"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): DeptVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeptVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ancestors"] = this.ancestors;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["deptCategory"] = this.deptCategory;
        data["deptCategoryName"] = this.deptCategoryName;
        data["deptName"] = this.deptName;
        data["fullName"] = this.fullName;
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isEnable"] = this.isEnable;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IDeptVO {
    /** 祖级机构主键 */
    ancestors: string | undefined;
    children: DeptVO[] | undefined;
    /** 机构类型 */
    deptCategory: number | undefined;
    deptCategoryName: string | undefined;
    /** 机构名 */
    deptName: string | undefined;
    /** 机构全称 */
    fullName: string | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否已启用 */
    isEnable: number | undefined;
    parentId: string | undefined;
    parentName: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class Dict implements IDict {
    /** 字典码 */
    code!: string | undefined;
    /** 字典值 */
    dictKey!: string | undefined;
    /** 字典名称 */
    dictValue!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否已封存 */
    isSealed!: number | undefined;
    /** 父主键 */
    parentId!: string | undefined;
    /** 字典备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;

    constructor(data?: IDict) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.dictKey = data["dictKey"];
            this.dictValue = data["dictValue"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isSealed = data["isSealed"];
            this.parentId = data["parentId"];
            this.remark = data["remark"];
            this.sort = data["sort"];
        }
    }

    static fromJS(data: any): Dict {
        data = typeof data === 'object' ? data : {};
        let result = new Dict();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dictKey"] = this.dictKey;
        data["dictValue"] = this.dictValue;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isSealed"] = this.isSealed;
        data["parentId"] = this.parentId;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        return data; 
    }
}

export interface IDict {
    /** 字典码 */
    code: string | undefined;
    /** 字典值 */
    dictKey: string | undefined;
    /** 字典名称 */
    dictValue: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否已封存 */
    isSealed: number | undefined;
    /** 父主键 */
    parentId: string | undefined;
    /** 字典备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
}

export class DictBiz implements IDictBiz {
    /** 字典码 */
    code!: string | undefined;
    /** 字典值 */
    dictKey!: string | undefined;
    /** 字典名称 */
    dictValue!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否已封存 */
    isSealed!: number | undefined;
    /** 父主键 */
    parentId!: string | undefined;
    /** 字典备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IDictBiz) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.dictKey = data["dictKey"];
            this.dictValue = data["dictValue"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isSealed = data["isSealed"];
            this.parentId = data["parentId"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): DictBiz {
        data = typeof data === 'object' ? data : {};
        let result = new DictBiz();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dictKey"] = this.dictKey;
        data["dictValue"] = this.dictValue;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isSealed"] = this.isSealed;
        data["parentId"] = this.parentId;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IDictBiz {
    /** 字典码 */
    code: string | undefined;
    /** 字典值 */
    dictKey: string | undefined;
    /** 字典名称 */
    dictValue: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否已封存 */
    isSealed: number | undefined;
    /** 父主键 */
    parentId: string | undefined;
    /** 字典备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class DictBizCreateDTO implements IDictBizCreateDTO {
    /** 字典码 */
    code!: string | undefined;
    /** 字典值,code */
    dictKey!: string | undefined;
    /** 字典名称,设备名称 */
    dictValue!: string | undefined;
    /** 备注,客户Id */
    remark!: string | undefined;
    tenantId!: string | undefined;

    constructor(data?: IDictBizCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.dictKey = data["dictKey"];
            this.dictValue = data["dictValue"];
            this.remark = data["remark"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): DictBizCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DictBizCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["dictKey"] = this.dictKey;
        data["dictValue"] = this.dictValue;
        data["remark"] = this.remark;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IDictBizCreateDTO {
    /** 字典码 */
    code: string | undefined;
    /** 字典值,code */
    dictKey: string | undefined;
    /** 字典名称,设备名称 */
    dictValue: string | undefined;
    /** 备注,客户Id */
    remark: string | undefined;
    tenantId: string | undefined;
}

export class DictBizVO implements IDictBizVO {
    children!: DictBizVO[] | undefined;
    /** 字典码 */
    code!: string | undefined;
    /** 字典值 */
    dictKey!: string | undefined;
    /** 字典名称 */
    dictValue!: string | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否已封存 */
    isSealed!: number | undefined;
    parentId!: string | undefined;
    parentName!: string | undefined;
    /** 字典备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IDictBizVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(DictBizVO.fromJS(item));
            }
            this.code = data["code"];
            this.dictKey = data["dictKey"];
            this.dictValue = data["dictValue"];
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isSealed = data["isSealed"];
            this.parentId = data["parentId"];
            this.parentName = data["parentName"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): DictBizVO {
        data = typeof data === 'object' ? data : {};
        let result = new DictBizVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["dictKey"] = this.dictKey;
        data["dictValue"] = this.dictValue;
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isSealed"] = this.isSealed;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IDictBizVO {
    children: DictBizVO[] | undefined;
    /** 字典码 */
    code: string | undefined;
    /** 字典值 */
    dictKey: string | undefined;
    /** 字典名称 */
    dictValue: string | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否已封存 */
    isSealed: number | undefined;
    parentId: string | undefined;
    parentName: string | undefined;
    /** 字典备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class DictVO implements IDictVO {
    children!: DictVO[] | undefined;
    /** 字典码 */
    code!: string | undefined;
    /** 字典值 */
    dictKey!: string | undefined;
    /** 字典名称 */
    dictValue!: string | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否已封存 */
    isSealed!: number | undefined;
    parentId!: string | undefined;
    parentName!: string | undefined;
    /** 字典备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;

    constructor(data?: IDictVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(DictVO.fromJS(item));
            }
            this.code = data["code"];
            this.dictKey = data["dictKey"];
            this.dictValue = data["dictValue"];
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isSealed = data["isSealed"];
            this.parentId = data["parentId"];
            this.parentName = data["parentName"];
            this.remark = data["remark"];
            this.sort = data["sort"];
        }
    }

    static fromJS(data: any): DictVO {
        data = typeof data === 'object' ? data : {};
        let result = new DictVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["dictKey"] = this.dictKey;
        data["dictValue"] = this.dictValue;
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isSealed"] = this.isSealed;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        return data; 
    }
}

export interface IDictVO {
    children: DictVO[] | undefined;
    /** 字典码 */
    code: string | undefined;
    /** 字典值 */
    dictKey: string | undefined;
    /** 字典名称 */
    dictValue: string | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否已封存 */
    isSealed: number | undefined;
    parentId: string | undefined;
    parentName: string | undefined;
    /** 字典备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
}

export class FieldSettingDTO implements IFieldSettingDTO {
    /** 业务code */
    bizType!: string | undefined;
    /** 字段编号 */
    code!: string | undefined;
    /** 是否显式0-不显示 1-显式 */
    isDisplay!: number | undefined;
    /** 字段名称 */
    name!: string | undefined;

    constructor(data?: IFieldSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            this.code = data["code"];
            this.isDisplay = data["isDisplay"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): FieldSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FieldSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        data["code"] = this.code;
        data["isDisplay"] = this.isDisplay;
        data["name"] = this.name;
        return data; 
    }
}

export interface IFieldSettingDTO {
    /** 业务code */
    bizType: string | undefined;
    /** 字段编号 */
    code: string | undefined;
    /** 是否显式0-不显示 1-显式 */
    isDisplay: number | undefined;
    /** 字段名称 */
    name: string | undefined;
}

export class FieldSettingVO implements IFieldSettingVO {
    /** 业务code */
    bizType!: string | undefined;
    /** 字段编号 */
    code!: string | undefined;
    /** 是否显式0-不显示 1-显式 */
    isDisplay!: number | undefined;
    /** 新字段名称 */
    name!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IFieldSettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            this.code = data["code"];
            this.isDisplay = data["isDisplay"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): FieldSettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new FieldSettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        data["code"] = this.code;
        data["isDisplay"] = this.isDisplay;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IFieldSettingVO {
    /** 业务code */
    bizType: string | undefined;
    /** 字段编号 */
    code: string | undefined;
    /** 是否显式0-不显示 1-显式 */
    isDisplay: number | undefined;
    /** 新字段名称 */
    name: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class GalleryChangeDTO implements IGalleryChangeDTO {
    galleryId!: string | undefined;
    ids!: string | undefined;

    constructor(data?: IGalleryChangeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.galleryId = data["galleryId"];
            this.ids = data["ids"];
        }
    }

    static fromJS(data: any): GalleryChangeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryChangeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["galleryId"] = this.galleryId;
        data["ids"] = this.ids;
        return data; 
    }
}

export interface IGalleryChangeDTO {
    galleryId: string | undefined;
    ids: string | undefined;
}

export class GalleryFileInfoDTO implements IGalleryFileInfoDTO {
    /** 文件mini类型 */
    contentType!: string;
    /** 文件名称 */
    fileName!: string;
    /** 文件key */
    objectKey!: string;

    constructor(data?: IGalleryFileInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.objectKey = data["objectKey"];
        }
    }

    static fromJS(data: any): GalleryFileInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryFileInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["objectKey"] = this.objectKey;
        return data; 
    }
}

export interface IGalleryFileInfoDTO {
    /** 文件mini类型 */
    contentType: string;
    /** 文件名称 */
    fileName: string;
    /** 文件key */
    objectKey: string;
}

/** GalleryFile */
export class GalleryFileRenameDTO implements IGalleryFileRenameDTO {
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** 图库id */
    galleryId!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 文件key */
    objectKey!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IGalleryFileRenameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.fileName = data["fileName"];
            this.galleryId = data["galleryId"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.objectKey = data["objectKey"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): GalleryFileRenameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryFileRenameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["fileName"] = this.fileName;
        data["galleryId"] = this.galleryId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["objectKey"] = this.objectKey;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** GalleryFile */
export interface IGalleryFileRenameDTO {
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 图库id */
    galleryId: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 文件key */
    objectKey: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class GalleryFileUploadDTO implements IGalleryFileUploadDTO {
    file!: GalleryFileInfoDTO[] | undefined;
    galleryId!: string | undefined;

    constructor(data?: IGalleryFileUploadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["file"] && data["file"].constructor === Array) {
                this.file = [] as any;
                for (let item of data["file"])
                    this.file!.push(GalleryFileInfoDTO.fromJS(item));
            }
            this.galleryId = data["galleryId"];
        }
    }

    static fromJS(data: any): GalleryFileUploadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryFileUploadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.file && this.file.constructor === Array) {
            data["file"] = [];
            for (let item of this.file)
                data["file"].push(item.toJSON());
        }
        data["galleryId"] = this.galleryId;
        return data; 
    }
}

export interface IGalleryFileUploadDTO {
    file: GalleryFileInfoDTO[] | undefined;
    galleryId: string | undefined;
}

/** GalleryFileVO */
export class GalleryFileVO implements IGalleryFileVO {
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** 图库id */
    galleryId!: string | undefined;
    /** 文件id */
    id!: string | undefined;
    /** 文件key */
    objectKey!: string | undefined;

    constructor(data?: IGalleryFileVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.galleryId = data["galleryId"];
            this.id = data["id"];
            this.objectKey = data["objectKey"];
        }
    }

    static fromJS(data: any): GalleryFileVO {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryFileVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["galleryId"] = this.galleryId;
        data["id"] = this.id;
        data["objectKey"] = this.objectKey;
        return data; 
    }
}

/** GalleryFileVO */
export interface IGalleryFileVO {
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 图库id */
    galleryId: string | undefined;
    /** 文件id */
    id: string | undefined;
    /** 文件key */
    objectKey: string | undefined;
}

export class GallerySaveDTO implements IGallerySaveDTO {
    /** 图库名称 */
    galleryName!: string | undefined;
    /** 主键 */
    id!: string | undefined;

    constructor(data?: IGallerySaveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.galleryName = data["galleryName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GallerySaveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GallerySaveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["galleryName"] = this.galleryName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGallerySaveDTO {
    /** 图库名称 */
    galleryName: string | undefined;
    /** 主键 */
    id: string | undefined;
}

/** GalleryVO */
export class GalleryVO implements IGalleryVO {
    /** 图库名称 */
    galleryName!: string | undefined;
    /** 主键id */
    id!: string | undefined;

    constructor(data?: IGalleryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.galleryName = data["galleryName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GalleryVO {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["galleryName"] = this.galleryName;
        data["id"] = this.id;
        return data; 
    }
}

/** GalleryVO */
export interface IGalleryVO {
    /** 图库名称 */
    galleryName: string | undefined;
    /** 主键id */
    id: string | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GrantTreeVO implements IGrantTreeVO {
    apiScope!: MenuVO[] | undefined;
    dataScope!: MenuVO[] | undefined;
    menu!: MenuVO[] | undefined;

    constructor(data?: IGrantTreeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["apiScope"] && data["apiScope"].constructor === Array) {
                this.apiScope = [] as any;
                for (let item of data["apiScope"])
                    this.apiScope!.push(MenuVO.fromJS(item));
            }
            if (data["dataScope"] && data["dataScope"].constructor === Array) {
                this.dataScope = [] as any;
                for (let item of data["dataScope"])
                    this.dataScope!.push(MenuVO.fromJS(item));
            }
            if (data["menu"] && data["menu"].constructor === Array) {
                this.menu = [] as any;
                for (let item of data["menu"])
                    this.menu!.push(MenuVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrantTreeVO {
        data = typeof data === 'object' ? data : {};
        let result = new GrantTreeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.apiScope && this.apiScope.constructor === Array) {
            data["apiScope"] = [];
            for (let item of this.apiScope)
                data["apiScope"].push(item.toJSON());
        }
        if (this.dataScope && this.dataScope.constructor === Array) {
            data["dataScope"] = [];
            for (let item of this.dataScope)
                data["dataScope"].push(item.toJSON());
        }
        if (this.menu && this.menu.constructor === Array) {
            data["menu"] = [];
            for (let item of this.menu)
                data["menu"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGrantTreeVO {
    apiScope: MenuVO[] | undefined;
    dataScope: MenuVO[] | undefined;
    menu: MenuVO[] | undefined;
}

export class GrantVO implements IGrantVO {
    /** apiScopeIds集合 */
    apiScopeIds!: string[] | undefined;
    /** dataScopeIds集合 */
    dataScopeIds!: string[] | undefined;
    /** menuIds集合 */
    menuIds!: string[] | undefined;
    /** roleIds集合 */
    roleIds!: string[] | undefined;

    constructor(data?: IGrantVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["apiScopeIds"] && data["apiScopeIds"].constructor === Array) {
                this.apiScopeIds = [] as any;
                for (let item of data["apiScopeIds"])
                    this.apiScopeIds!.push(item);
            }
            if (data["dataScopeIds"] && data["dataScopeIds"].constructor === Array) {
                this.dataScopeIds = [] as any;
                for (let item of data["dataScopeIds"])
                    this.dataScopeIds!.push(item);
            }
            if (data["menuIds"] && data["menuIds"].constructor === Array) {
                this.menuIds = [] as any;
                for (let item of data["menuIds"])
                    this.menuIds!.push(item);
            }
            if (data["roleIds"] && data["roleIds"].constructor === Array) {
                this.roleIds = [] as any;
                for (let item of data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GrantVO {
        data = typeof data === 'object' ? data : {};
        let result = new GrantVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.apiScopeIds && this.apiScopeIds.constructor === Array) {
            data["apiScopeIds"] = [];
            for (let item of this.apiScopeIds)
                data["apiScopeIds"].push(item);
        }
        if (this.dataScopeIds && this.dataScopeIds.constructor === Array) {
            data["dataScopeIds"] = [];
            for (let item of this.dataScopeIds)
                data["dataScopeIds"].push(item);
        }
        if (this.menuIds && this.menuIds.constructor === Array) {
            data["menuIds"] = [];
            for (let item of this.menuIds)
                data["menuIds"].push(item);
        }
        if (this.roleIds && this.roleIds.constructor === Array) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data; 
    }
}

export interface IGrantVO {
    /** apiScopeIds集合 */
    apiScopeIds: string[] | undefined;
    /** dataScopeIds集合 */
    dataScopeIds: string[] | undefined;
    /** menuIds集合 */
    menuIds: string[] | undefined;
    /** roleIds集合 */
    roleIds: string[] | undefined;
}

export class IPageOfApiScopeVO implements IIPageOfApiScopeVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ApiScopeVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfApiScopeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ApiScopeVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfApiScopeVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfApiScopeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfApiScopeVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ApiScopeVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfApp implements IIPageOfApp {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: App[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(App.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfApp {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfApp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfApp {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: App[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfAppCard implements IIPageOfAppCard {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AppCard[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAppCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AppCard.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAppCard {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAppCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAppCard {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AppCard[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfAuthClient implements IIPageOfAuthClient {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AuthClient[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAuthClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AuthClient.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAuthClient {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAuthClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAuthClient {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AuthClient[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfDataScopeVO implements IIPageOfDataScopeVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: DataScopeVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfDataScopeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(DataScopeVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfDataScopeVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfDataScopeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfDataScopeVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: DataScopeVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfDictBizVO implements IIPageOfDictBizVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: DictBizVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfDictBizVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(DictBizVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfDictBizVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfDictBizVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfDictBizVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: DictBizVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfDictVO implements IIPageOfDictVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: DictVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfDictVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(DictVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfDictVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfDictVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfDictVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: DictVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfGalleryFileVO implements IIPageOfGalleryFileVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: GalleryFileVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfGalleryFileVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(GalleryFileVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfGalleryFileVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfGalleryFileVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfGalleryFileVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: GalleryFileVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfInterfaceConfigVO implements IIPageOfInterfaceConfigVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: InterfaceConfigVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfInterfaceConfigVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(InterfaceConfigVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfInterfaceConfigVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfInterfaceConfigVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfInterfaceConfigVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: InterfaceConfigVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfParam implements IIPageOfParam {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: Param[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(Param.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfParam {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfParam {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: Param[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfPostVO implements IIPageOfPostVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: PostVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfPostVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(PostVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfPostVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfPostVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfPostVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: PostVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfPublishRecordDTO implements IIPageOfPublishRecordDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: PublishRecordDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfPublishRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(PublishRecordDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfPublishRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfPublishRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfPublishRecordDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: PublishRecordDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfRegion implements IIPageOfRegion {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: Region[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(Region.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfRegion {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfRegion {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: Region[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfReleasePlanDTO implements IIPageOfReleasePlanDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ReleasePlanDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfReleasePlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ReleasePlanDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfReleasePlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfReleasePlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfReleasePlanDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ReleasePlanDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfTenant implements IIPageOfTenant {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: Tenant[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(Tenant.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfTenant {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfTenant {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: Tenant[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfTenantSetting implements IIPageOfTenantSetting {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: TenantSetting[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfTenantSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(TenantSetting.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfTenantSetting {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfTenantSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfTenantSetting {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: TenantSetting[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfTopMenu implements IIPageOfTopMenu {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: TopMenu[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfTopMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(TopMenu.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfTopMenu {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfTopMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfTopMenu {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: TopMenu[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IdsDTO implements IIdsDTO {
    idList!: string[] | undefined;

    constructor(data?: IIdsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [] as any;
                for (let item of data["idList"])
                    this.idList!.push(item);
            }
        }
    }

    static fromJS(data: any): IdsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IdsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        return data; 
    }
}

export interface IIdsDTO {
    idList: string[] | undefined;
}

export class ImcDTO implements IImcDTO {
    /** 加密的消息体 */
    data!: string | undefined;
    /** 事件类型 */
    eventType!: string | undefined;
    /** 随机数 */
    nonce!: string | undefined;
    /** 消息签名 */
    signature!: string | undefined;
    /** 时间戳 */
    timestamp!: string | undefined;

    constructor(data?: IImcDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.data = data["data"];
            this.eventType = data["eventType"];
            this.nonce = data["nonce"];
            this.signature = data["signature"];
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): ImcDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImcDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["eventType"] = this.eventType;
        data["nonce"] = this.nonce;
        data["signature"] = this.signature;
        data["timestamp"] = this.timestamp;
        return data; 
    }
}

export interface IImcDTO {
    /** 加密的消息体 */
    data: string | undefined;
    /** 事件类型 */
    eventType: string | undefined;
    /** 随机数 */
    nonce: string | undefined;
    /** 消息签名 */
    signature: string | undefined;
    /** 时间戳 */
    timestamp: string | undefined;
}

export class InterfaceConfigDTO implements IInterfaceConfigDTO {
    /** 字段 */
    interfaceConfigFieldDTOList!: InterfaceConfigFieldDTO[] | undefined;
    /** 所属图表 */
    owningChart!: string;
    /** url地址 */
    url!: string;
    /** url名字 */
    urlName!: string;
    /** url类型 0 - POST; 1 - PUT; 2 - GET */
    urlType!: number;

    constructor(data?: IInterfaceConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["interfaceConfigFieldDTOList"] && data["interfaceConfigFieldDTOList"].constructor === Array) {
                this.interfaceConfigFieldDTOList = [] as any;
                for (let item of data["interfaceConfigFieldDTOList"])
                    this.interfaceConfigFieldDTOList!.push(InterfaceConfigFieldDTO.fromJS(item));
            }
            this.owningChart = data["owningChart"];
            this.url = data["url"];
            this.urlName = data["urlName"];
            this.urlType = data["urlType"];
        }
    }

    static fromJS(data: any): InterfaceConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.interfaceConfigFieldDTOList && this.interfaceConfigFieldDTOList.constructor === Array) {
            data["interfaceConfigFieldDTOList"] = [];
            for (let item of this.interfaceConfigFieldDTOList)
                data["interfaceConfigFieldDTOList"].push(item.toJSON());
        }
        data["owningChart"] = this.owningChart;
        data["url"] = this.url;
        data["urlName"] = this.urlName;
        data["urlType"] = this.urlType;
        return data; 
    }
}

export interface IInterfaceConfigDTO {
    /** 字段 */
    interfaceConfigFieldDTOList: InterfaceConfigFieldDTO[] | undefined;
    /** 所属图表 */
    owningChart: string;
    /** url地址 */
    url: string;
    /** url名字 */
    urlName: string;
    /** url类型 0 - POST; 1 - PUT; 2 - GET */
    urlType: number;
}

export class InterfaceConfigFieldDTO implements IInterfaceConfigFieldDTO {
    /** 接口配置id */
    configId!: string;
    /** 数据源 */
    dataSource!: string;
    /** 数据类型：0-文本；1-数值；2-选项；3-日期 */
    dataType!: number;
    /** 是否必填： 0 - 不必填; 1 - 必填 */
    isRequired!: number;
    /** 是否单选 */
    isSingleChoice!: number;
    /** 字段名称 */
    name!: string;

    constructor(data?: IInterfaceConfigFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.configId = data["configId"];
            this.dataSource = data["dataSource"];
            this.dataType = data["dataType"];
            this.isRequired = data["isRequired"];
            this.isSingleChoice = data["isSingleChoice"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): InterfaceConfigFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceConfigFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configId"] = this.configId;
        data["dataSource"] = this.dataSource;
        data["dataType"] = this.dataType;
        data["isRequired"] = this.isRequired;
        data["isSingleChoice"] = this.isSingleChoice;
        data["name"] = this.name;
        return data; 
    }
}

export interface IInterfaceConfigFieldDTO {
    /** 接口配置id */
    configId: string;
    /** 数据源 */
    dataSource: string;
    /** 数据类型：0-文本；1-数值；2-选项；3-日期 */
    dataType: number;
    /** 是否必填： 0 - 不必填; 1 - 必填 */
    isRequired: number;
    /** 是否单选 */
    isSingleChoice: number;
    /** 字段名称 */
    name: string;
}

export class InterfaceConfigFieldUpdateDTO implements IInterfaceConfigFieldUpdateDTO {
    /** 接口配置id */
    configId!: string;
    /** 数据源 */
    dataSource!: string;
    /** 数据类型：0-文本；1-数值；2-选项；3-日期 */
    dataType!: number;
    id!: string | undefined;
    /** 是否必填： 0 - 不必填; 1 - 必填 */
    isRequired!: number;
    /** 是否单选 */
    isSingleChoice!: number;
    /** 字段名称 */
    name!: string;

    constructor(data?: IInterfaceConfigFieldUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.configId = data["configId"];
            this.dataSource = data["dataSource"];
            this.dataType = data["dataType"];
            this.id = data["id"];
            this.isRequired = data["isRequired"];
            this.isSingleChoice = data["isSingleChoice"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): InterfaceConfigFieldUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceConfigFieldUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configId"] = this.configId;
        data["dataSource"] = this.dataSource;
        data["dataType"] = this.dataType;
        data["id"] = this.id;
        data["isRequired"] = this.isRequired;
        data["isSingleChoice"] = this.isSingleChoice;
        data["name"] = this.name;
        return data; 
    }
}

export interface IInterfaceConfigFieldUpdateDTO {
    /** 接口配置id */
    configId: string;
    /** 数据源 */
    dataSource: string;
    /** 数据类型：0-文本；1-数值；2-选项；3-日期 */
    dataType: number;
    id: string | undefined;
    /** 是否必填： 0 - 不必填; 1 - 必填 */
    isRequired: number;
    /** 是否单选 */
    isSingleChoice: number;
    /** 字段名称 */
    name: string;
}

export class InterfaceConfigFieldVO implements IInterfaceConfigFieldVO {
    /** 接口配置id */
    configId!: string | undefined;
    /** 数据源 */
    dataSource!: string | undefined;
    /** 数据类型：0-文本；1-数值；2-选项；3-日期 */
    dataType!: number | undefined;
    /** id */
    id!: string | undefined;
    /** 是否必填： 0 - 不必填; 1 - 必填 */
    isRequired!: number | undefined;
    /** 是否单选 */
    isSingleChoice!: number | undefined;
    /** 字段名称 */
    name!: string | undefined;

    constructor(data?: IInterfaceConfigFieldVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.configId = data["configId"];
            this.dataSource = data["dataSource"];
            this.dataType = data["dataType"];
            this.id = data["id"];
            this.isRequired = data["isRequired"];
            this.isSingleChoice = data["isSingleChoice"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): InterfaceConfigFieldVO {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceConfigFieldVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configId"] = this.configId;
        data["dataSource"] = this.dataSource;
        data["dataType"] = this.dataType;
        data["id"] = this.id;
        data["isRequired"] = this.isRequired;
        data["isSingleChoice"] = this.isSingleChoice;
        data["name"] = this.name;
        return data; 
    }
}

export interface IInterfaceConfigFieldVO {
    /** 接口配置id */
    configId: string | undefined;
    /** 数据源 */
    dataSource: string | undefined;
    /** 数据类型：0-文本；1-数值；2-选项；3-日期 */
    dataType: number | undefined;
    /** id */
    id: string | undefined;
    /** 是否必填： 0 - 不必填; 1 - 必填 */
    isRequired: number | undefined;
    /** 是否单选 */
    isSingleChoice: number | undefined;
    /** 字段名称 */
    name: string | undefined;
}

export class InterfaceConfigInfoVO implements IInterfaceConfigInfoVO {
    /** 主键id */
    id!: string | undefined;
    /** 字段 */
    interfaceConfigFieldVOList!: InterfaceConfigFieldVO[] | undefined;
    /** 所属图表 */
    owningChart!: string | undefined;
    /** url地址 */
    url!: string | undefined;
    /** url名字 */
    urlName!: string | undefined;
    /** url类型 */
    urlType!: number | undefined;

    constructor(data?: IInterfaceConfigInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["interfaceConfigFieldVOList"] && data["interfaceConfigFieldVOList"].constructor === Array) {
                this.interfaceConfigFieldVOList = [] as any;
                for (let item of data["interfaceConfigFieldVOList"])
                    this.interfaceConfigFieldVOList!.push(InterfaceConfigFieldVO.fromJS(item));
            }
            this.owningChart = data["owningChart"];
            this.url = data["url"];
            this.urlName = data["urlName"];
            this.urlType = data["urlType"];
        }
    }

    static fromJS(data: any): InterfaceConfigInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceConfigInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.interfaceConfigFieldVOList && this.interfaceConfigFieldVOList.constructor === Array) {
            data["interfaceConfigFieldVOList"] = [];
            for (let item of this.interfaceConfigFieldVOList)
                data["interfaceConfigFieldVOList"].push(item.toJSON());
        }
        data["owningChart"] = this.owningChart;
        data["url"] = this.url;
        data["urlName"] = this.urlName;
        data["urlType"] = this.urlType;
        return data; 
    }
}

export interface IInterfaceConfigInfoVO {
    /** 主键id */
    id: string | undefined;
    /** 字段 */
    interfaceConfigFieldVOList: InterfaceConfigFieldVO[] | undefined;
    /** 所属图表 */
    owningChart: string | undefined;
    /** url地址 */
    url: string | undefined;
    /** url名字 */
    urlName: string | undefined;
    /** url类型 */
    urlType: number | undefined;
}

export class InterfaceConfigUpdateDTO implements IInterfaceConfigUpdateDTO {
    /** id */
    id!: string;
    /** 字段 */
    interfaceConfigFieldDTOList!: InterfaceConfigFieldDTO[] | undefined;
    /** 所属图表 */
    owningChart!: string;
    /** url地址 */
    url!: string;
    /** url名字 */
    urlName!: string;
    /** url类型 0 - POST; 1 - PUT; 2 - GET */
    urlType!: number;

    constructor(data?: IInterfaceConfigUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["interfaceConfigFieldDTOList"] && data["interfaceConfigFieldDTOList"].constructor === Array) {
                this.interfaceConfigFieldDTOList = [] as any;
                for (let item of data["interfaceConfigFieldDTOList"])
                    this.interfaceConfigFieldDTOList!.push(InterfaceConfigFieldDTO.fromJS(item));
            }
            this.owningChart = data["owningChart"];
            this.url = data["url"];
            this.urlName = data["urlName"];
            this.urlType = data["urlType"];
        }
    }

    static fromJS(data: any): InterfaceConfigUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceConfigUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.interfaceConfigFieldDTOList && this.interfaceConfigFieldDTOList.constructor === Array) {
            data["interfaceConfigFieldDTOList"] = [];
            for (let item of this.interfaceConfigFieldDTOList)
                data["interfaceConfigFieldDTOList"].push(item.toJSON());
        }
        data["owningChart"] = this.owningChart;
        data["url"] = this.url;
        data["urlName"] = this.urlName;
        data["urlType"] = this.urlType;
        return data; 
    }
}

export interface IInterfaceConfigUpdateDTO {
    /** id */
    id: string;
    /** 字段 */
    interfaceConfigFieldDTOList: InterfaceConfigFieldDTO[] | undefined;
    /** 所属图表 */
    owningChart: string;
    /** url地址 */
    url: string;
    /** url名字 */
    urlName: string;
    /** url类型 0 - POST; 1 - PUT; 2 - GET */
    urlType: number;
}

export class InterfaceConfigVO implements IInterfaceConfigVO {
    /** 主键id */
    id!: string | undefined;
    /** 所属图表 */
    owningChart!: string | undefined;
    /** url地址 */
    url!: string | undefined;
    /** url名字 */
    urlName!: string | undefined;
    /** url类型 */
    urlType!: number | undefined;

    constructor(data?: IInterfaceConfigVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.owningChart = data["owningChart"];
            this.url = data["url"];
            this.urlName = data["urlName"];
            this.urlType = data["urlType"];
        }
    }

    static fromJS(data: any): InterfaceConfigVO {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceConfigVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owningChart"] = this.owningChart;
        data["url"] = this.url;
        data["urlName"] = this.urlName;
        data["urlType"] = this.urlType;
        return data; 
    }
}

export interface IInterfaceConfigVO {
    /** 主键id */
    id: string | undefined;
    /** 所属图表 */
    owningChart: string | undefined;
    /** url地址 */
    url: string | undefined;
    /** url名字 */
    urlName: string | undefined;
    /** url类型 */
    urlType: number | undefined;
}

export class Kv implements IKv {

    [key: string]: any; 

    constructor(data?: IKv) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }

    static fromJS(data: any): Kv {
        data = typeof data === 'object' ? data : {};
        let result = new Kv();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data; 
    }
}

export interface IKv {

    [key: string]: any; 
}

export class Locale implements ILocale {
    country!: string | undefined;
    displayCountry!: string | undefined;
    displayLanguage!: string | undefined;
    displayName!: string | undefined;
    displayScript!: string | undefined;
    displayVariant!: string | undefined;
    extensionKeys!: any[] | undefined;
    iso3Country!: string | undefined;
    iso3Language!: string | undefined;
    language!: string | undefined;
    script!: string | undefined;
    unicodeLocaleAttributes!: string[] | undefined;
    unicodeLocaleKeys!: string[] | undefined;
    variant!: string | undefined;

    constructor(data?: ILocale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.displayCountry = data["displayCountry"];
            this.displayLanguage = data["displayLanguage"];
            this.displayName = data["displayName"];
            this.displayScript = data["displayScript"];
            this.displayVariant = data["displayVariant"];
            if (data["extensionKeys"] && data["extensionKeys"].constructor === Array) {
                this.extensionKeys = [] as any;
                for (let item of data["extensionKeys"])
                    this.extensionKeys!.push(item);
            }
            this.iso3Country = data["iso3Country"];
            this.iso3Language = data["iso3Language"];
            this.language = data["language"];
            this.script = data["script"];
            if (data["unicodeLocaleAttributes"] && data["unicodeLocaleAttributes"].constructor === Array) {
                this.unicodeLocaleAttributes = [] as any;
                for (let item of data["unicodeLocaleAttributes"])
                    this.unicodeLocaleAttributes!.push(item);
            }
            if (data["unicodeLocaleKeys"] && data["unicodeLocaleKeys"].constructor === Array) {
                this.unicodeLocaleKeys = [] as any;
                for (let item of data["unicodeLocaleKeys"])
                    this.unicodeLocaleKeys!.push(item);
            }
            this.variant = data["variant"];
        }
    }

    static fromJS(data: any): Locale {
        data = typeof data === 'object' ? data : {};
        let result = new Locale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["displayCountry"] = this.displayCountry;
        data["displayLanguage"] = this.displayLanguage;
        data["displayName"] = this.displayName;
        data["displayScript"] = this.displayScript;
        data["displayVariant"] = this.displayVariant;
        if (this.extensionKeys && this.extensionKeys.constructor === Array) {
            data["extensionKeys"] = [];
            for (let item of this.extensionKeys)
                data["extensionKeys"].push(item);
        }
        data["iso3Country"] = this.iso3Country;
        data["iso3Language"] = this.iso3Language;
        data["language"] = this.language;
        data["script"] = this.script;
        if (this.unicodeLocaleAttributes && this.unicodeLocaleAttributes.constructor === Array) {
            data["unicodeLocaleAttributes"] = [];
            for (let item of this.unicodeLocaleAttributes)
                data["unicodeLocaleAttributes"].push(item);
        }
        if (this.unicodeLocaleKeys && this.unicodeLocaleKeys.constructor === Array) {
            data["unicodeLocaleKeys"] = [];
            for (let item of this.unicodeLocaleKeys)
                data["unicodeLocaleKeys"].push(item);
        }
        data["variant"] = this.variant;
        return data; 
    }
}

export interface ILocale {
    country: string | undefined;
    displayCountry: string | undefined;
    displayLanguage: string | undefined;
    displayName: string | undefined;
    displayScript: string | undefined;
    displayVariant: string | undefined;
    extensionKeys: any[] | undefined;
    iso3Country: string | undefined;
    iso3Language: string | undefined;
    language: string | undefined;
    script: string | undefined;
    unicodeLocaleAttributes: string[] | undefined;
    unicodeLocaleKeys: string[] | undefined;
    variant: string | undefined;
}

export class MTreeNode implements IMTreeNode {
    children!: MTreeNode[] | undefined;
    data!: any | undefined;
    id!: string | undefined;
    key!: string | undefined;
    originalData!: Menu | undefined;
    parentId!: string | undefined;
    title!: string | undefined;
    value!: string | undefined;

    constructor(data?: IMTreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(MTreeNode.fromJS(item));
            }
            this.data = data["data"];
            this.id = data["id"];
            this.key = data["key"];
            this.originalData = data["originalData"] ? Menu.fromJS(data["originalData"]) : <any>undefined;
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): MTreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new MTreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["data"] = this.data;
        data["id"] = this.id;
        data["key"] = this.key;
        data["originalData"] = this.originalData ? this.originalData.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["value"] = this.value;
        return data; 
    }
}

export interface IMTreeNode {
    children: MTreeNode[] | undefined;
    data: any | undefined;
    id: string | undefined;
    key: string | undefined;
    originalData: Menu | undefined;
    parentId: string | undefined;
    title: string | undefined;
    value: string | undefined;
}

export class MasterlinkMenuCustomization implements IMasterlinkMenuCustomization {
    id!: string | undefined;
    menuId!: string | undefined;
    sort!: number | undefined;
    source!: string | undefined;
    tenantId!: string | undefined;

    constructor(data?: IMasterlinkMenuCustomization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuId = data["menuId"];
            this.sort = data["sort"];
            this.source = data["source"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): MasterlinkMenuCustomization {
        data = typeof data === 'object' ? data : {};
        let result = new MasterlinkMenuCustomization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuId"] = this.menuId;
        data["sort"] = this.sort;
        data["source"] = this.source;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IMasterlinkMenuCustomization {
    id: string | undefined;
    menuId: string | undefined;
    sort: number | undefined;
    source: string | undefined;
    tenantId: string | undefined;
}

export class MasterlinkMenuTreeNode implements IMasterlinkMenuTreeNode {
    attribute!: any | undefined;
    children!: MasterlinkMenuTreeNode[] | undefined;
    data!: MenuVO | undefined;
    id!: string | undefined;
    key!: string | undefined;
    parentId!: string | undefined;
    title!: string | undefined;
    value!: string | undefined;

    constructor(data?: IMasterlinkMenuTreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attribute = data["attribute"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(MasterlinkMenuTreeNode.fromJS(item));
            }
            this.data = data["data"] ? MenuVO.fromJS(data["data"]) : <any>undefined;
            this.id = data["id"];
            this.key = data["key"];
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): MasterlinkMenuTreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new MasterlinkMenuTreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["value"] = this.value;
        return data; 
    }
}

export interface IMasterlinkMenuTreeNode {
    attribute: any | undefined;
    children: MasterlinkMenuTreeNode[] | undefined;
    data: MenuVO | undefined;
    id: string | undefined;
    key: string | undefined;
    parentId: string | undefined;
    title: string | undefined;
    value: string | undefined;
}

export class MasterlinkRoleMenuDto implements IMasterlinkRoleMenuDto {
    /** App编号 */
    appCode!: string | undefined;
    /** 角色菜单集合 */
    itemDtoList!: RoleMenuItemDto[] | undefined;
    menuEdition!: number | undefined;
    menuKind!: number | undefined;

    constructor(data?: IMasterlinkRoleMenuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            if (data["itemDtoList"] && data["itemDtoList"].constructor === Array) {
                this.itemDtoList = [] as any;
                for (let item of data["itemDtoList"])
                    this.itemDtoList!.push(RoleMenuItemDto.fromJS(item));
            }
            this.menuEdition = data["menuEdition"];
            this.menuKind = data["menuKind"];
        }
    }

    static fromJS(data: any): MasterlinkRoleMenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterlinkRoleMenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        if (this.itemDtoList && this.itemDtoList.constructor === Array) {
            data["itemDtoList"] = [];
            for (let item of this.itemDtoList)
                data["itemDtoList"].push(item.toJSON());
        }
        data["menuEdition"] = this.menuEdition;
        data["menuKind"] = this.menuKind;
        return data; 
    }
}

export interface IMasterlinkRoleMenuDto {
    /** App编号 */
    appCode: string | undefined;
    /** 角色菜单集合 */
    itemDtoList: RoleMenuItemDto[] | undefined;
    menuEdition: number | undefined;
    menuKind: number | undefined;
}

export class Menu implements IMenu {
    /** 操作按钮类型 */
    action!: number | undefined;
    /** 菜单别名 */
    alias!: string | undefined;
    /** 租户类型 */
    audience!: number | undefined;
    /** 菜单类型 */
    category!: number | undefined;
    /** 菜单编号 */
    code!: string | undefined;
    /** 版本：PC 1，移动 2，HMI 3 */
    edition!: number | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否打开新页面 */
    isOpen!: number | undefined;
    /** 菜单类型：常规1，动态2，设定4 */
    kind!: number | undefined;
    /** 菜单名称 */
    name!: string | undefined;
    /** 菜单父主键 */
    parentId!: string | undefined;
    /** 请求地址 */
    path!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 菜单资源 */
    source!: string | undefined;

    constructor(data?: IMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"];
            this.alias = data["alias"];
            this.audience = data["audience"];
            this.category = data["category"];
            this.code = data["code"];
            this.edition = data["edition"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isOpen = data["isOpen"];
            this.kind = data["kind"];
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.path = data["path"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.source = data["source"];
        }
    }

    static fromJS(data: any): Menu {
        data = typeof data === 'object' ? data : {};
        let result = new Menu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["alias"] = this.alias;
        data["audience"] = this.audience;
        data["category"] = this.category;
        data["code"] = this.code;
        data["edition"] = this.edition;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isOpen"] = this.isOpen;
        data["kind"] = this.kind;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["path"] = this.path;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["source"] = this.source;
        return data; 
    }
}

export interface IMenu {
    /** 操作按钮类型 */
    action: number | undefined;
    /** 菜单别名 */
    alias: string | undefined;
    /** 租户类型 */
    audience: number | undefined;
    /** 菜单类型 */
    category: number | undefined;
    /** 菜单编号 */
    code: string | undefined;
    /** 版本：PC 1，移动 2，HMI 3 */
    edition: number | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否打开新页面 */
    isOpen: number | undefined;
    /** 菜单类型：常规1，动态2，设定4 */
    kind: number | undefined;
    /** 菜单名称 */
    name: string | undefined;
    /** 菜单父主键 */
    parentId: string | undefined;
    /** 请求地址 */
    path: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 菜单资源 */
    source: string | undefined;
}

export class MenuApisVO implements IMenuApisVO {
    /** 菜单api集合 */
    itemDtoList!: MenuScopeApiItemDto[] | undefined;

    constructor(data?: IMenuApisVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["itemDtoList"] && data["itemDtoList"].constructor === Array) {
                this.itemDtoList = [] as any;
                for (let item of data["itemDtoList"])
                    this.itemDtoList!.push(MenuScopeApiItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuApisVO {
        data = typeof data === 'object' ? data : {};
        let result = new MenuApisVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.itemDtoList && this.itemDtoList.constructor === Array) {
            data["itemDtoList"] = [];
            for (let item of this.itemDtoList)
                data["itemDtoList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuApisVO {
    /** 菜单api集合 */
    itemDtoList: MenuScopeApiItemDto[] | undefined;
}

export class MenuCodeListVO implements IMenuCodeListVO {
    codeList!: string[] | undefined;

    constructor(data?: IMenuCodeListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["codeList"] && data["codeList"].constructor === Array) {
                this.codeList = [] as any;
                for (let item of data["codeList"])
                    this.codeList!.push(item);
            }
        }
    }

    static fromJS(data: any): MenuCodeListVO {
        data = typeof data === 'object' ? data : {};
        let result = new MenuCodeListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.codeList && this.codeList.constructor === Array) {
            data["codeList"] = [];
            for (let item of this.codeList)
                data["codeList"].push(item);
        }
        return data; 
    }
}

export interface IMenuCodeListVO {
    codeList: string[] | undefined;
}

export class MenuCustomizationDTO implements IMenuCustomizationDTO {
    /** 菜单编号 */
    code!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 菜单描述 */
    menuDescription!: string | undefined;
    /** 菜单排序 */
    menuSort!: number | undefined;
    /** 菜单图标 */
    menuSource!: string | undefined;

    constructor(data?: IMenuCustomizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.menuDescription = data["menuDescription"];
            this.menuSort = data["menuSort"];
            this.menuSource = data["menuSource"];
        }
    }

    static fromJS(data: any): MenuCustomizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MenuCustomizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["menuDescription"] = this.menuDescription;
        data["menuSort"] = this.menuSort;
        data["menuSource"] = this.menuSource;
        return data; 
    }
}

export interface IMenuCustomizationDTO {
    /** 菜单编号 */
    code: string | undefined;
    /** id */
    id: string | undefined;
    /** 菜单描述 */
    menuDescription: string | undefined;
    /** 菜单排序 */
    menuSort: number | undefined;
    /** 菜单图标 */
    menuSource: string | undefined;
}

export class MenuCustomizationSettingDTO implements IMenuCustomizationSettingDTO {
    id!: string | undefined;
    /** 菜单ID */
    menuId!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 菜单图标 */
    source!: string | undefined;

    constructor(data?: IMenuCustomizationSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuId = data["menuId"];
            this.sort = data["sort"];
            this.source = data["source"];
        }
    }

    static fromJS(data: any): MenuCustomizationSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MenuCustomizationSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuId"] = this.menuId;
        data["sort"] = this.sort;
        data["source"] = this.source;
        return data; 
    }
}

export interface IMenuCustomizationSettingDTO {
    id: string | undefined;
    /** 菜单ID */
    menuId: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 菜单图标 */
    source: string | undefined;
}

export class MenuScopeApiItemDto implements IMenuScopeApiItemDto {
    /** 权限方法 */
    httpMethod!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 菜单id */
    menuId!: string | undefined;
    /** 接口权限备注 */
    remark!: string | undefined;
    /** 资源编号 */
    resourceCode!: string | undefined;
    /** 接口权限名 */
    scopeName!: string | undefined;
    /** 接口权限地址 */
    scopePath!: string | undefined;
    /** 接口权限类型 */
    scopeType!: number | undefined;

    constructor(data?: IMenuScopeApiItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.httpMethod = data["httpMethod"];
            this.id = data["id"];
            this.menuId = data["menuId"];
            this.remark = data["remark"];
            this.resourceCode = data["resourceCode"];
            this.scopeName = data["scopeName"];
            this.scopePath = data["scopePath"];
            this.scopeType = data["scopeType"];
        }
    }

    static fromJS(data: any): MenuScopeApiItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuScopeApiItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["httpMethod"] = this.httpMethod;
        data["id"] = this.id;
        data["menuId"] = this.menuId;
        data["remark"] = this.remark;
        data["resourceCode"] = this.resourceCode;
        data["scopeName"] = this.scopeName;
        data["scopePath"] = this.scopePath;
        data["scopeType"] = this.scopeType;
        return data; 
    }
}

export interface IMenuScopeApiItemDto {
    /** 权限方法 */
    httpMethod: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 菜单id */
    menuId: string | undefined;
    /** 接口权限备注 */
    remark: string | undefined;
    /** 资源编号 */
    resourceCode: string | undefined;
    /** 接口权限名 */
    scopeName: string | undefined;
    /** 接口权限地址 */
    scopePath: string | undefined;
    /** 接口权限类型 */
    scopeType: number | undefined;
}

export class MenuVO implements IMenuVO {
    /** 操作按钮类型 */
    action!: number | undefined;
    actionName!: string | undefined;
    /** 菜单别名 */
    alias!: string | undefined;
    /** 租户类型 */
    audience!: number | undefined;
    /** 菜单类型 */
    category!: number | undefined;
    categoryName!: string | undefined;
    children!: MenuVO[] | undefined;
    /** 菜单编号 */
    code!: string | undefined;
    /** 版本：PC 1，移动 2，HMI 3 */
    edition!: number | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否打开新页面 */
    isOpen!: number | undefined;
    isOpenName!: string | undefined;
    /** 菜单类型：常规1，动态2，设定4 */
    kind!: number | undefined;
    /** 菜单名称 */
    name!: string | undefined;
    parentId!: string | undefined;
    parentName!: string | undefined;
    /** 请求地址 */
    path!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 菜单资源 */
    source!: string | undefined;

    constructor(data?: IMenuVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"];
            this.actionName = data["actionName"];
            this.alias = data["alias"];
            this.audience = data["audience"];
            this.category = data["category"];
            this.categoryName = data["categoryName"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(MenuVO.fromJS(item));
            }
            this.code = data["code"];
            this.edition = data["edition"];
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isOpen = data["isOpen"];
            this.isOpenName = data["isOpenName"];
            this.kind = data["kind"];
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.parentName = data["parentName"];
            this.path = data["path"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.source = data["source"];
        }
    }

    static fromJS(data: any): MenuVO {
        data = typeof data === 'object' ? data : {};
        let result = new MenuVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["actionName"] = this.actionName;
        data["alias"] = this.alias;
        data["audience"] = this.audience;
        data["category"] = this.category;
        data["categoryName"] = this.categoryName;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["edition"] = this.edition;
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isOpen"] = this.isOpen;
        data["isOpenName"] = this.isOpenName;
        data["kind"] = this.kind;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["path"] = this.path;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["source"] = this.source;
        return data; 
    }
}

export interface IMenuVO {
    /** 操作按钮类型 */
    action: number | undefined;
    actionName: string | undefined;
    /** 菜单别名 */
    alias: string | undefined;
    /** 租户类型 */
    audience: number | undefined;
    /** 菜单类型 */
    category: number | undefined;
    categoryName: string | undefined;
    children: MenuVO[] | undefined;
    /** 菜单编号 */
    code: string | undefined;
    /** 版本：PC 1，移动 2，HMI 3 */
    edition: number | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否打开新页面 */
    isOpen: number | undefined;
    isOpenName: string | undefined;
    /** 菜单类型：常规1，动态2，设定4 */
    kind: number | undefined;
    /** 菜单名称 */
    name: string | undefined;
    parentId: string | undefined;
    parentName: string | undefined;
    /** 请求地址 */
    path: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 菜单资源 */
    source: string | undefined;
}

export class MenusTreeVO implements IMenusTreeVO {
    treeNodeList!: MTreeNode[] | undefined;
    treeNodes!: MasterlinkMenuTreeNode[] | undefined;

    constructor(data?: IMenusTreeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["treeNodeList"] && data["treeNodeList"].constructor === Array) {
                this.treeNodeList = [] as any;
                for (let item of data["treeNodeList"])
                    this.treeNodeList!.push(MTreeNode.fromJS(item));
            }
            if (data["treeNodes"] && data["treeNodes"].constructor === Array) {
                this.treeNodes = [] as any;
                for (let item of data["treeNodes"])
                    this.treeNodes!.push(MasterlinkMenuTreeNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenusTreeVO {
        data = typeof data === 'object' ? data : {};
        let result = new MenusTreeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.treeNodeList && this.treeNodeList.constructor === Array) {
            data["treeNodeList"] = [];
            for (let item of this.treeNodeList)
                data["treeNodeList"].push(item.toJSON());
        }
        if (this.treeNodes && this.treeNodes.constructor === Array) {
            data["treeNodes"] = [];
            for (let item of this.treeNodes)
                data["treeNodes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenusTreeVO {
    treeNodeList: MTreeNode[] | undefined;
    treeNodes: MasterlinkMenuTreeNode[] | undefined;
}

export class MenusVO implements IMenusVO {
    roleMenu!: MasterlinkRoleMenuDto | undefined;

    constructor(data?: IMenusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleMenu = data["roleMenu"] ? MasterlinkRoleMenuDto.fromJS(data["roleMenu"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MenusVO {
        data = typeof data === 'object' ? data : {};
        let result = new MenusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleMenu"] = this.roleMenu ? this.roleMenu.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMenusVO {
    roleMenu: MasterlinkRoleMenuDto | undefined;
}

export class MenusWithElementsVO implements IMenusWithElementsVO {
    menuTreeNodeList!: MasterlinkMenuTreeNode[] | undefined;

    constructor(data?: IMenusWithElementsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["menuTreeNodeList"] && data["menuTreeNodeList"].constructor === Array) {
                this.menuTreeNodeList = [] as any;
                for (let item of data["menuTreeNodeList"])
                    this.menuTreeNodeList!.push(MasterlinkMenuTreeNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenusWithElementsVO {
        data = typeof data === 'object' ? data : {};
        let result = new MenusWithElementsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.menuTreeNodeList && this.menuTreeNodeList.constructor === Array) {
            data["menuTreeNodeList"] = [];
            for (let item of this.menuTreeNodeList)
                data["menuTreeNodeList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenusWithElementsVO {
    menuTreeNodeList: MasterlinkMenuTreeNode[] | undefined;
}

export class MyAppDto implements IMyAppDto {
    appCode!: string | undefined;
    avatar!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: IMyAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.avatar = data["avatar"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): MyAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["avatar"] = this.avatar;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IMyAppDto {
    appCode: string | undefined;
    avatar: string | undefined;
    displayName: string | undefined;
}

export class NameValueOfstring implements INameValueOfstring {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfstring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfstring {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfstring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfstring {
    name: string | undefined;
    value: string | undefined;
}

/** Organization */
export class Organization implements IOrganization {
    ancestors!: string | undefined;
    category!: number | undefined;
    fullName!: string | undefined;
    id!: string | undefined;
    isDeleted!: number | undefined;
    name!: string | undefined;
    parentId!: string | undefined;
    remark!: string | undefined;
    sort!: number | undefined;
    tenantId!: string | undefined;

    constructor(data?: IOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ancestors = data["ancestors"];
            this.category = data["category"];
            this.fullName = data["fullName"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ancestors"] = this.ancestors;
        data["category"] = this.category;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

/** Organization */
export interface IOrganization {
    ancestors: string | undefined;
    category: number | undefined;
    fullName: string | undefined;
    id: string | undefined;
    isDeleted: number | undefined;
    name: string | undefined;
    parentId: string | undefined;
    remark: string | undefined;
    sort: number | undefined;
    tenantId: string | undefined;
}

export class OrganizationUserVO implements IOrganizationUserVO {
    children!: OrganizationUserVO[] | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    key!: string | undefined;
    parentId!: string | undefined;
    title!: string | undefined;
    user!: boolean | undefined;
    value!: string | undefined;

    constructor(data?: IOrganizationUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(OrganizationUserVO.fromJS(item));
            }
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.key = data["key"];
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.user = data["user"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): OrganizationUserVO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["user"] = this.user;
        data["value"] = this.value;
        return data; 
    }
}

export interface IOrganizationUserVO {
    children: OrganizationUserVO[] | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    key: string | undefined;
    parentId: string | undefined;
    title: string | undefined;
    user: boolean | undefined;
    value: string | undefined;
}

/** Organization */
export class OrganizationVO implements IOrganizationVO {
    ancestors!: string | undefined;
    category!: number | undefined;
    categoryName!: string | undefined;
    children!: OrganizationVO[] | undefined;
    fullName!: string | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    isDeleted!: number | undefined;
    name!: string | undefined;
    parentId!: string | undefined;
    parentName!: string | undefined;
    remark!: string | undefined;
    sort!: number | undefined;
    tenantId!: string | undefined;

    constructor(data?: IOrganizationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ancestors = data["ancestors"];
            this.category = data["category"];
            this.categoryName = data["categoryName"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(OrganizationVO.fromJS(item));
            }
            this.fullName = data["fullName"];
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.parentName = data["parentName"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): OrganizationVO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ancestors"] = this.ancestors;
        data["category"] = this.category;
        data["categoryName"] = this.categoryName;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["fullName"] = this.fullName;
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

/** Organization */
export interface IOrganizationVO {
    ancestors: string | undefined;
    category: number | undefined;
    categoryName: string | undefined;
    children: OrganizationVO[] | undefined;
    fullName: string | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    isDeleted: number | undefined;
    name: string | undefined;
    parentId: string | undefined;
    parentName: string | undefined;
    remark: string | undefined;
    sort: number | undefined;
    tenantId: string | undefined;
}

export class Param implements IParam {
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 参数键 */
    paramKey!: string | undefined;
    /** 参数名 */
    paramName!: string | undefined;
    /** 参数值 */
    paramValue!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.paramKey = data["paramKey"];
            this.paramName = data["paramName"];
            this.paramValue = data["paramValue"];
            this.remark = data["remark"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): Param {
        data = typeof data === 'object' ? data : {};
        let result = new Param();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["paramKey"] = this.paramKey;
        data["paramName"] = this.paramName;
        data["paramValue"] = this.paramValue;
        data["remark"] = this.remark;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IParam {
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 参数键 */
    paramKey: string | undefined;
    /** 参数名 */
    paramName: string | undefined;
    /** 参数值 */
    paramValue: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class Post implements IPost {
    /** 类型 */
    category!: number | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 岗位编号 */
    postCode!: string | undefined;
    /** 岗位名称 */
    postName!: string | undefined;
    /** 岗位描述 */
    remark!: string | undefined;
    /** 岗位排序 */
    sort!: number | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.postCode = data["postCode"];
            this.postName = data["postName"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): Post {
        data = typeof data === 'object' ? data : {};
        let result = new Post();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["postCode"] = this.postCode;
        data["postName"] = this.postName;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IPost {
    /** 类型 */
    category: number | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 岗位编号 */
    postCode: string | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 岗位描述 */
    remark: string | undefined;
    /** 岗位排序 */
    sort: number | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class PostVO implements IPostVO {
    /** 类型 */
    category!: number | undefined;
    categoryName!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 岗位编号 */
    postCode!: string | undefined;
    /** 岗位名称 */
    postName!: string | undefined;
    /** 岗位描述 */
    remark!: string | undefined;
    /** 岗位排序 */
    sort!: number | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IPostVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.categoryName = data["categoryName"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.postCode = data["postCode"];
            this.postName = data["postName"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): PostVO {
        data = typeof data === 'object' ? data : {};
        let result = new PostVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryName"] = this.categoryName;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["postCode"] = this.postCode;
        data["postName"] = this.postName;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IPostVO {
    /** 类型 */
    category: number | undefined;
    categoryName: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 岗位编号 */
    postCode: string | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 岗位描述 */
    remark: string | undefined;
    /** 岗位排序 */
    sort: number | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class PublishRecordAddDTO implements IPublishRecordAddDTO {
    /** 发布内容 */
    content!: string | undefined;
    /** 发布时间 */
    publishDate!: Date | undefined;
    /** 发布版本 */
    version!: string | undefined;

    constructor(data?: IPublishRecordAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.content = data["content"];
            this.publishDate = data["publishDate"] ? new Date(data["publishDate"].toString()) : <any>undefined;
            this.version = data["version"];
        }
    }

    static fromJS(data: any): PublishRecordAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublishRecordAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["publishDate"] = this.publishDate ? formatDate(this.publishDate) : <any>undefined;
        data["version"] = this.version;
        return data; 
    }
}

export interface IPublishRecordAddDTO {
    /** 发布内容 */
    content: string | undefined;
    /** 发布时间 */
    publishDate: Date | undefined;
    /** 发布版本 */
    version: string | undefined;
}

export class PublishRecordDTO implements IPublishRecordDTO {
    /** 发布内容 */
    content!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 发布时间 */
    publishDate!: Date | undefined;
    /** 发布状态(0:未发布,1:已发布) */
    publishStatus!: number | undefined;
    /** 发布版本 */
    version!: string | undefined;

    constructor(data?: IPublishRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.content = data["content"];
            this.id = data["id"];
            this.publishDate = data["publishDate"] ? new Date(data["publishDate"].toString()) : <any>undefined;
            this.publishStatus = data["publishStatus"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): PublishRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublishRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["id"] = this.id;
        data["publishDate"] = this.publishDate ? formatDate(this.publishDate) : <any>undefined;
        data["publishStatus"] = this.publishStatus;
        data["version"] = this.version;
        return data; 
    }
}

export interface IPublishRecordDTO {
    /** 发布内容 */
    content: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 发布时间 */
    publishDate: Date | undefined;
    /** 发布状态(0:未发布,1:已发布) */
    publishStatus: number | undefined;
    /** 发布版本 */
    version: string | undefined;
}

/** 返回信息 */
export class R implements IR {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): R {
        data = typeof data === 'object' ? data : {};
        let result = new R();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IR {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfApiScope implements IROfApiScope {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: ApiScope | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfApiScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? ApiScope.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfApiScope {
        data = typeof data === 'object' ? data : {};
        let result = new ROfApiScope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfApiScope {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: ApiScope | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfAppsVO implements IROfAppsVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: AppsVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfAppsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? AppsVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfAppsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfAppsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfAppsVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: AppsVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfAuthClient implements IROfAuthClient {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: AuthClient | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfAuthClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? AuthClient.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfAuthClient {
        data = typeof data === 'object' ? data : {};
        let result = new ROfAuthClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfAuthClient {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: AuthClient | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfCheckedTreeVO implements IROfCheckedTreeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: CheckedTreeVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfCheckedTreeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? CheckedTreeVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfCheckedTreeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfCheckedTreeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfCheckedTreeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: CheckedTreeVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfDataScope implements IROfDataScope {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DataScope | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfDataScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? DataScope.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfDataScope {
        data = typeof data === 'object' ? data : {};
        let result = new ROfDataScope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfDataScope {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DataScope | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfDeptVO implements IROfDeptVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DeptVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfDeptVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? DeptVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfDeptVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfDeptVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfDeptVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DeptVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfDictBizVO implements IROfDictBizVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DictBizVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfDictBizVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? DictBizVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfDictBizVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfDictBizVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfDictBizVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DictBizVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfDictVO implements IROfDictVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DictVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfDictVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? DictVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfDictVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfDictVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfDictVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DictVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfGrantTreeVO implements IROfGrantTreeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: GrantTreeVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfGrantTreeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? GrantTreeVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfGrantTreeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfGrantTreeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfGrantTreeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: GrantTreeVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfApiScopeVO implements IROfIPageOfApiScopeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfApiScopeVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfApiScopeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfApiScopeVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfApiScopeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfApiScopeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfApiScopeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfApiScopeVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfAuthClient implements IROfIPageOfAuthClient {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfAuthClient | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfAuthClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfAuthClient.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfAuthClient {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfAuthClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfAuthClient {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfAuthClient | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfDataScopeVO implements IROfIPageOfDataScopeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfDataScopeVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfDataScopeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfDataScopeVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfDataScopeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfDataScopeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfDataScopeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfDataScopeVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfDictBizVO implements IROfIPageOfDictBizVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfDictBizVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfDictBizVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfDictBizVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfDictBizVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfDictBizVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfDictBizVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfDictBizVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfDictVO implements IROfIPageOfDictVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfDictVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfDictVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfDictVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfDictVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfDictVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfDictVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfDictVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfGalleryFileVO implements IROfIPageOfGalleryFileVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfGalleryFileVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfGalleryFileVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfGalleryFileVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfGalleryFileVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfGalleryFileVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfGalleryFileVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfGalleryFileVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfInterfaceConfigVO implements IROfIPageOfInterfaceConfigVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfInterfaceConfigVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfInterfaceConfigVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfInterfaceConfigVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfInterfaceConfigVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfInterfaceConfigVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfInterfaceConfigVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfInterfaceConfigVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfParam implements IROfIPageOfParam {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfParam | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfParam.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfParam {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfParam {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfParam | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfPostVO implements IROfIPageOfPostVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfPostVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfPostVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfPostVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfPostVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfPostVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfPostVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfPostVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfRegion implements IROfIPageOfRegion {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfRegion | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfRegion.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfRegion {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfRegion {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfRegion | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfTenant implements IROfIPageOfTenant {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfTenant | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfTenant.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfTenant {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfTenant | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfTopMenu implements IROfIPageOfTopMenu {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfTopMenu | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfTopMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfTopMenu.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfTopMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfTopMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfTopMenu {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfTopMenu | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIdsDTO implements IROfIdsDTO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IdsDTO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIdsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IdsDTO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIdsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIdsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIdsDTO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IdsDTO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfAuthorityDomainTreeDto implements IROfListOfAuthorityDomainTreeDto {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: AuthorityDomainTreeDto[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfAuthorityDomainTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(AuthorityDomainTreeDto.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfAuthorityDomainTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfAuthorityDomainTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfAuthorityDomainTreeDto {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: AuthorityDomainTreeDto[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfDeptVO implements IROfListOfDeptVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DeptVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfDeptVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(DeptVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfDeptVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfDeptVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfDeptVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DeptVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfDict implements IROfListOfDict {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: Dict[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfDict) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(Dict.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfDict {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfDict();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfDict {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: Dict[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfDictBiz implements IROfListOfDictBiz {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DictBiz[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfDictBiz) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(DictBiz.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfDictBiz {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfDictBiz();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfDictBiz {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DictBiz[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfDictBizVO implements IROfListOfDictBizVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DictBizVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfDictBizVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(DictBizVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfDictBizVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfDictBizVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfDictBizVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DictBizVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfDictVO implements IROfListOfDictVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DictVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfDictVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(DictVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfDictVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfDictVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfDictVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DictVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfGalleryVO implements IROfListOfGalleryVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: GalleryVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfGalleryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(GalleryVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfGalleryVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfGalleryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfGalleryVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: GalleryVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfKv implements IROfListOfKv {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: Kv[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfKv) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(Kv.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfKv {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfKv();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfKv {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: Kv[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfMTreeNode implements IROfListOfMTreeNode {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MTreeNode[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfMTreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(MTreeNode.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfMTreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfMTreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfMTreeNode {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MTreeNode[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfMasterlinkMenuTreeNode implements IROfListOfMasterlinkMenuTreeNode {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MasterlinkMenuTreeNode[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfMasterlinkMenuTreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(MasterlinkMenuTreeNode.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfMasterlinkMenuTreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfMasterlinkMenuTreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfMasterlinkMenuTreeNode {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MasterlinkMenuTreeNode[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfMenuVO implements IROfListOfMenuVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MenuVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfMenuVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(MenuVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfMenuVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfMenuVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfMenuVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MenuVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfOrganizationUserVO implements IROfListOfOrganizationUserVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: OrganizationUserVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfOrganizationUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(OrganizationUserVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfOrganizationUserVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfOrganizationUserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfOrganizationUserVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: OrganizationUserVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfOrganizationVO implements IROfListOfOrganizationVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: OrganizationVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfOrganizationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(OrganizationVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfOrganizationVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfOrganizationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfOrganizationVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: OrganizationVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfPost implements IROfListOfPost {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: Post[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(Post.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfPost {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfPost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfPost {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: Post[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfRegion implements IROfListOfRegion {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: Region[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(Region.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfRegion {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfRegion {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: Region[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfRegionVO implements IROfListOfRegionVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: RegionVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfRegionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(RegionVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfRegionVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfRegionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfRegionVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: RegionVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfRoleVO implements IROfListOfRoleVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: RoleVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfRoleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(RoleVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfRoleVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfRoleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfRoleVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: RoleVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfTopMenu implements IROfListOfTopMenu {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: TopMenu[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfTopMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(TopMenu.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfTopMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfTopMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfTopMenu {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: TopMenu[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfTreeNode implements IROfListOfTreeNode {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: TreeNode[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfTreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(TreeNode.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfTreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfTreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfTreeNode {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: TreeNode[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfUserVO implements IROfListOfUserVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: UserVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(UserVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfUserVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfUserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfUserVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: UserVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMenuApisVO implements IROfMenuApisVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MenuApisVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMenuApisVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MenuApisVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMenuApisVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMenuApisVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMenuApisVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MenuApisVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMenuCodeListVO implements IROfMenuCodeListVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MenuCodeListVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMenuCodeListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MenuCodeListVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMenuCodeListVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMenuCodeListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMenuCodeListVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MenuCodeListVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMenuCustomizationDTO implements IROfMenuCustomizationDTO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MenuCustomizationDTO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMenuCustomizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MenuCustomizationDTO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMenuCustomizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMenuCustomizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMenuCustomizationDTO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MenuCustomizationDTO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMenuVO implements IROfMenuVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MenuVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMenuVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MenuVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMenuVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMenuVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMenuVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MenuVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMenusTreeVO implements IROfMenusTreeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MenusTreeVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMenusTreeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MenusTreeVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMenusTreeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMenusTreeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMenusTreeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MenusTreeVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMenusVO implements IROfMenusVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MenusVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMenusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MenusVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMenusVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMenusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMenusVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MenusVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMenusWithElementsVO implements IROfMenusWithElementsVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MenusWithElementsVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMenusWithElementsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MenusWithElementsVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMenusWithElementsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMenusWithElementsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMenusWithElementsVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MenusWithElementsVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfOrganizationVO implements IROfOrganizationVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: OrganizationVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfOrganizationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? OrganizationVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfOrganizationVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfOrganizationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfOrganizationVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: OrganizationVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfParam implements IROfParam {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: Param | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? Param.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfParam {
        data = typeof data === 'object' ? data : {};
        let result = new ROfParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfParam {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: Param | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfPostVO implements IROfPostVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: PostVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfPostVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? PostVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfPostVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfPostVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfPostVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: PostVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfRegionVO implements IROfRegionVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: RegionVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfRegionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? RegionVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfRegionVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfRegionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfRegionVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: RegionVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfRoleVO implements IROfRoleVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: RoleVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfRoleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? RoleVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfRoleVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfRoleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfRoleVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: RoleVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfRolesVO implements IROfRolesVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: RolesVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfRolesVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? RolesVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfRolesVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfRolesVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfRolesVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: RolesVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfTenantVO implements IROfTenantVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: TenantVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfTenantVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? TenantVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfTenantVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfTenantVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfTenantVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: TenantVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfTopMenu implements IROfTopMenu {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: TopMenu | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfTopMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? TopMenu.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfTopMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ROfTopMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfTopMenu {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: TopMenu | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROflong implements IROflong {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: string | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROflong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROflong {
        data = typeof data === 'object' ? data : {};
        let result = new ROflong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROflong {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: string | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfstring implements IROfstring {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: string | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfstring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfstring {
        data = typeof data === 'object' ? data : {};
        let result = new ROfstring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfstring {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: string | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class Region implements IRegion {
    /** 祖区划编号 */
    ancestors!: string | undefined;
    /** 地理大区编号 */
    areaCode!: string | undefined;
    /** 地理大区名称 */
    areaName!: string | undefined;
    /** 市级区划编号 */
    cityCode!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 区划编号 */
    code!: string | undefined;
    /** 区级区划编号 */
    districtCode!: string | undefined;
    /** 区级名称 */
    districtName!: string | undefined;
    /** 层级 */
    level!: number | undefined;
    /** 区划名称 */
    name!: string | undefined;
    /** 父区划编号 */
    parentCode!: string | undefined;
    /** 省级区划编号 */
    provinceCode!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 镇级区划编号 */
    townCode!: string | undefined;
    /** 镇级名称 */
    townName!: string | undefined;
    /** 村级区划编号 */
    villageCode!: string | undefined;
    /** 村级名称 */
    villageName!: string | undefined;

    constructor(data?: IRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ancestors = data["ancestors"];
            this.areaCode = data["areaCode"];
            this.areaName = data["areaName"];
            this.cityCode = data["cityCode"];
            this.cityName = data["cityName"];
            this.code = data["code"];
            this.districtCode = data["districtCode"];
            this.districtName = data["districtName"];
            this.level = data["level"];
            this.name = data["name"];
            this.parentCode = data["parentCode"];
            this.provinceCode = data["provinceCode"];
            this.provinceName = data["provinceName"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.townCode = data["townCode"];
            this.townName = data["townName"];
            this.villageCode = data["villageCode"];
            this.villageName = data["villageName"];
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ancestors"] = this.ancestors;
        data["areaCode"] = this.areaCode;
        data["areaName"] = this.areaName;
        data["cityCode"] = this.cityCode;
        data["cityName"] = this.cityName;
        data["code"] = this.code;
        data["districtCode"] = this.districtCode;
        data["districtName"] = this.districtName;
        data["level"] = this.level;
        data["name"] = this.name;
        data["parentCode"] = this.parentCode;
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["townCode"] = this.townCode;
        data["townName"] = this.townName;
        data["villageCode"] = this.villageCode;
        data["villageName"] = this.villageName;
        return data; 
    }
}

export interface IRegion {
    /** 祖区划编号 */
    ancestors: string | undefined;
    /** 地理大区编号 */
    areaCode: string | undefined;
    /** 地理大区名称 */
    areaName: string | undefined;
    /** 市级区划编号 */
    cityCode: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 区划编号 */
    code: string | undefined;
    /** 区级区划编号 */
    districtCode: string | undefined;
    /** 区级名称 */
    districtName: string | undefined;
    /** 层级 */
    level: number | undefined;
    /** 区划名称 */
    name: string | undefined;
    /** 父区划编号 */
    parentCode: string | undefined;
    /** 省级区划编号 */
    provinceCode: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 镇级区划编号 */
    townCode: string | undefined;
    /** 镇级名称 */
    townName: string | undefined;
    /** 村级区划编号 */
    villageCode: string | undefined;
    /** 村级名称 */
    villageName: string | undefined;
}

export class RegionVO implements IRegionVO {
    /** 祖区划编号 */
    ancestors!: string | undefined;
    /** 地理大区编号 */
    areaCode!: string | undefined;
    /** 地理大区名称 */
    areaName!: string | undefined;
    children!: RegionVO[] | undefined;
    /** 市级区划编号 */
    cityCode!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 区划编号 */
    code!: string | undefined;
    /** 区级区划编号 */
    districtCode!: string | undefined;
    /** 区级名称 */
    districtName!: string | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    /** 层级 */
    level!: number | undefined;
    /** 区划名称 */
    name!: string | undefined;
    /** 父区划编号 */
    parentCode!: string | undefined;
    parentId!: string | undefined;
    parentName!: string | undefined;
    /** 省级区划编号 */
    provinceCode!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 镇级区划编号 */
    townCode!: string | undefined;
    /** 镇级名称 */
    townName!: string | undefined;
    /** 村级区划编号 */
    villageCode!: string | undefined;
    /** 村级名称 */
    villageName!: string | undefined;

    constructor(data?: IRegionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ancestors = data["ancestors"];
            this.areaCode = data["areaCode"];
            this.areaName = data["areaName"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(RegionVO.fromJS(item));
            }
            this.cityCode = data["cityCode"];
            this.cityName = data["cityName"];
            this.code = data["code"];
            this.districtCode = data["districtCode"];
            this.districtName = data["districtName"];
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.level = data["level"];
            this.name = data["name"];
            this.parentCode = data["parentCode"];
            this.parentId = data["parentId"];
            this.parentName = data["parentName"];
            this.provinceCode = data["provinceCode"];
            this.provinceName = data["provinceName"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.townCode = data["townCode"];
            this.townName = data["townName"];
            this.villageCode = data["villageCode"];
            this.villageName = data["villageName"];
        }
    }

    static fromJS(data: any): RegionVO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ancestors"] = this.ancestors;
        data["areaCode"] = this.areaCode;
        data["areaName"] = this.areaName;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["cityCode"] = this.cityCode;
        data["cityName"] = this.cityName;
        data["code"] = this.code;
        data["districtCode"] = this.districtCode;
        data["districtName"] = this.districtName;
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["level"] = this.level;
        data["name"] = this.name;
        data["parentCode"] = this.parentCode;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["townCode"] = this.townCode;
        data["townName"] = this.townName;
        data["villageCode"] = this.villageCode;
        data["villageName"] = this.villageName;
        return data; 
    }
}

export interface IRegionVO {
    /** 祖区划编号 */
    ancestors: string | undefined;
    /** 地理大区编号 */
    areaCode: string | undefined;
    /** 地理大区名称 */
    areaName: string | undefined;
    children: RegionVO[] | undefined;
    /** 市级区划编号 */
    cityCode: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 区划编号 */
    code: string | undefined;
    /** 区级区划编号 */
    districtCode: string | undefined;
    /** 区级名称 */
    districtName: string | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    /** 层级 */
    level: number | undefined;
    /** 区划名称 */
    name: string | undefined;
    /** 父区划编号 */
    parentCode: string | undefined;
    parentId: string | undefined;
    parentName: string | undefined;
    /** 省级区划编号 */
    provinceCode: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 镇级区划编号 */
    townCode: string | undefined;
    /** 镇级名称 */
    townName: string | undefined;
    /** 村级区划编号 */
    villageCode: string | undefined;
    /** 村级名称 */
    villageName: string | undefined;
}

export class ReleasePlanAddDTO implements IReleasePlanAddDTO {
    /** 计划发布结束时间 */
    planEndTime!: Date | undefined;
    /** 计划发布开始时间 */
    planStartTime!: Date | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 发布版本号 */
    version!: string | undefined;

    constructor(data?: IReleasePlanAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.remark = data["remark"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ReleasePlanAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReleasePlanAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["remark"] = this.remark;
        data["version"] = this.version;
        return data; 
    }
}

export interface IReleasePlanAddDTO {
    /** 计划发布结束时间 */
    planEndTime: Date | undefined;
    /** 计划发布开始时间 */
    planStartTime: Date | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 发布版本号 */
    version: string | undefined;
}

export class ReleasePlanDTO implements IReleasePlanDTO {
    /** ID */
    id!: string | undefined;
    /** 计划发布结束时间 */
    planEndTime!: Date | undefined;
    /** 计划发布开始时间 */
    planStartTime!: Date | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 发布版本号 */
    version!: string | undefined;

    constructor(data?: IReleasePlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.remark = data["remark"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ReleasePlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReleasePlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["remark"] = this.remark;
        data["version"] = this.version;
        return data; 
    }
}

export interface IReleasePlanDTO {
    /** ID */
    id: string | undefined;
    /** 计划发布结束时间 */
    planEndTime: Date | undefined;
    /** 计划发布开始时间 */
    planStartTime: Date | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 发布版本号 */
    version: string | undefined;
}

export class ReleasePlanUpdateDTO implements IReleasePlanUpdateDTO {
    /** ID */
    id!: string | undefined;
    /** 计划发布结束时间 */
    planEndTime!: Date | undefined;
    /** 计划发布开始时间 */
    planStartTime!: Date | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 发布版本号 */
    version!: string | undefined;

    constructor(data?: IReleasePlanUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.remark = data["remark"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ReleasePlanUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReleasePlanUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["remark"] = this.remark;
        data["version"] = this.version;
        return data; 
    }
}

export interface IReleasePlanUpdateDTO {
    /** ID */
    id: string | undefined;
    /** 计划发布结束时间 */
    planEndTime: Date | undefined;
    /** 计划发布开始时间 */
    planStartTime: Date | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 发布版本号 */
    version: string | undefined;
}

export class Role implements IRole {
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否为子账户角色 */
    isSubAccount!: boolean | undefined;
    /** 父主键 */
    parentId!: string | undefined;
    /** 角色别名 */
    roleAlias!: string | undefined;
    /** 角色名 */
    roleName!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isSubAccount = data["isSubAccount"];
            this.parentId = data["parentId"];
            this.roleAlias = data["roleAlias"];
            this.roleName = data["roleName"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isSubAccount"] = this.isSubAccount;
        data["parentId"] = this.parentId;
        data["roleAlias"] = this.roleAlias;
        data["roleName"] = this.roleName;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IRole {
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否为子账户角色 */
    isSubAccount: boolean | undefined;
    /** 父主键 */
    parentId: string | undefined;
    /** 角色别名 */
    roleAlias: string | undefined;
    /** 角色名 */
    roleName: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class RoleBriefDTO implements IRoleBriefDTO {
    displayName!: string | undefined;

    constructor(data?: IRoleBriefDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): RoleBriefDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleBriefDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IRoleBriefDTO {
    displayName: string | undefined;
}

export class RoleMenuItemDto implements IRoleMenuItemDto {
    /** appCode */
    appCode!: string | undefined;
    /** 菜单种类 */
    menuEdition!: number | undefined;
    /** 菜单id */
    menuId!: string | undefined;

    constructor(data?: IRoleMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.menuEdition = data["menuEdition"];
            this.menuId = data["menuId"];
        }
    }

    static fromJS(data: any): RoleMenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleMenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["menuEdition"] = this.menuEdition;
        data["menuId"] = this.menuId;
        return data; 
    }
}

export interface IRoleMenuItemDto {
    /** appCode */
    appCode: string | undefined;
    /** 菜单种类 */
    menuEdition: number | undefined;
    /** 菜单id */
    menuId: string | undefined;
}

export class RoleVO implements IRoleVO {
    children!: RoleVO[] | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否为子账户角色 */
    isSubAccount!: boolean | undefined;
    parentId!: string | undefined;
    parentName!: string | undefined;
    /** 角色别名 */
    roleAlias!: string | undefined;
    /** 角色名 */
    roleName!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IRoleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(RoleVO.fromJS(item));
            }
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isSubAccount = data["isSubAccount"];
            this.parentId = data["parentId"];
            this.parentName = data["parentName"];
            this.roleAlias = data["roleAlias"];
            this.roleName = data["roleName"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): RoleVO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isSubAccount"] = this.isSubAccount;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["roleAlias"] = this.roleAlias;
        data["roleName"] = this.roleName;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IRoleVO {
    children: RoleVO[] | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否为子账户角色 */
    isSubAccount: boolean | undefined;
    parentId: string | undefined;
    parentName: string | undefined;
    /** 角色别名 */
    roleAlias: string | undefined;
    /** 角色名 */
    roleName: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class RolesVO implements IRolesVO {
    roleVOList!: RoleVO[] | undefined;

    constructor(data?: IRolesVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["roleVOList"] && data["roleVOList"].constructor === Array) {
                this.roleVOList = [] as any;
                for (let item of data["roleVOList"])
                    this.roleVOList!.push(RoleVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolesVO {
        data = typeof data === 'object' ? data : {};
        let result = new RolesVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.roleVOList && this.roleVOList.constructor === Array) {
            data["roleVOList"] = [];
            for (let item of this.roleVOList)
                data["roleVOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRolesVO {
    roleVOList: RoleVO[] | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export class SubAccountCreateDTO implements ISubAccountCreateDTO {
    grantDeptIdList!: number[] | undefined;
    grantMenuList!: SubAccountMenuDTO[] | undefined;
    remark!: string | undefined;

    constructor(data?: ISubAccountCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["grantDeptIdList"] && data["grantDeptIdList"].constructor === Array) {
                this.grantDeptIdList = [] as any;
                for (let item of data["grantDeptIdList"])
                    this.grantDeptIdList!.push(item);
            }
            if (data["grantMenuList"] && data["grantMenuList"].constructor === Array) {
                this.grantMenuList = [] as any;
                for (let item of data["grantMenuList"])
                    this.grantMenuList!.push(SubAccountMenuDTO.fromJS(item));
            }
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): SubAccountCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.grantDeptIdList && this.grantDeptIdList.constructor === Array) {
            data["grantDeptIdList"] = [];
            for (let item of this.grantDeptIdList)
                data["grantDeptIdList"].push(item);
        }
        if (this.grantMenuList && this.grantMenuList.constructor === Array) {
            data["grantMenuList"] = [];
            for (let item of this.grantMenuList)
                data["grantMenuList"].push(item.toJSON());
        }
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ISubAccountCreateDTO {
    grantDeptIdList: number[] | undefined;
    grantMenuList: SubAccountMenuDTO[] | undefined;
    remark: string | undefined;
}

export class SubAccountDetailVO implements ISubAccountDetailVO {
    subAccountVO!: SubAccountVO | undefined;

    constructor(data?: ISubAccountDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subAccountVO = data["subAccountVO"] ? SubAccountVO.fromJS(data["subAccountVO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubAccountDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subAccountVO"] = this.subAccountVO ? this.subAccountVO.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISubAccountDetailVO {
    subAccountVO: SubAccountVO | undefined;
}

export class SubAccountListVO implements ISubAccountListVO {
    list!: SubAccountVO[] | undefined;

    constructor(data?: ISubAccountListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(SubAccountVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubAccountListVO {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISubAccountListVO {
    list: SubAccountVO[] | undefined;
}

export class SubAccountMenuDTO implements ISubAccountMenuDTO {
    appCode!: string | undefined;
    menuEdition!: number | undefined;
    menuId!: string | undefined;

    constructor(data?: ISubAccountMenuDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.menuEdition = data["menuEdition"];
            this.menuId = data["menuId"];
        }
    }

    static fromJS(data: any): SubAccountMenuDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountMenuDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["menuEdition"] = this.menuEdition;
        data["menuId"] = this.menuId;
        return data; 
    }
}

export interface ISubAccountMenuDTO {
    appCode: string | undefined;
    menuEdition: number | undefined;
    menuId: string | undefined;
}

export class SubAccountUpdateDeptDTO implements ISubAccountUpdateDeptDTO {
    grantDeptIdList!: number[] | undefined;
    id!: string | undefined;

    constructor(data?: ISubAccountUpdateDeptDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["grantDeptIdList"] && data["grantDeptIdList"].constructor === Array) {
                this.grantDeptIdList = [] as any;
                for (let item of data["grantDeptIdList"])
                    this.grantDeptIdList!.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubAccountUpdateDeptDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountUpdateDeptDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.grantDeptIdList && this.grantDeptIdList.constructor === Array) {
            data["grantDeptIdList"] = [];
            for (let item of this.grantDeptIdList)
                data["grantDeptIdList"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubAccountUpdateDeptDTO {
    grantDeptIdList: number[] | undefined;
    id: string | undefined;
}

export class SubAccountVO implements ISubAccountVO {
    deptId!: string | undefined;
    id!: string | undefined;
    primaryAccountId!: string | undefined;
    remark!: string | undefined;
    roleId!: string | undefined;
    secretKey!: string | undefined;

    constructor(data?: ISubAccountVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deptId = data["deptId"];
            this.id = data["id"];
            this.primaryAccountId = data["primaryAccountId"];
            this.remark = data["remark"];
            this.roleId = data["roleId"];
            this.secretKey = data["secretKey"];
        }
    }

    static fromJS(data: any): SubAccountVO {
        data = typeof data === 'object' ? data : {};
        let result = new SubAccountVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deptId"] = this.deptId;
        data["id"] = this.id;
        data["primaryAccountId"] = this.primaryAccountId;
        data["remark"] = this.remark;
        data["roleId"] = this.roleId;
        data["secretKey"] = this.secretKey;
        return data; 
    }
}

export interface ISubAccountVO {
    deptId: string | undefined;
    id: string | undefined;
    primaryAccountId: string | undefined;
    remark: string | undefined;
    roleId: string | undefined;
    secretKey: string | undefined;
}

export class SyncAccountDataScopeDTO implements ISyncAccountDataScopeDTO {
    subAccountRoleId!: string | undefined;

    constructor(data?: ISyncAccountDataScopeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subAccountRoleId = data["subAccountRoleId"];
        }
    }

    static fromJS(data: any): SyncAccountDataScopeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SyncAccountDataScopeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subAccountRoleId"] = this.subAccountRoleId;
        return data; 
    }
}

export interface ISyncAccountDataScopeDTO {
    subAccountRoleId: string | undefined;
}

export class Tenant implements ITenant {
    /** 账号额度 */
    accountNumber!: number | undefined;
    /** 联系地址 */
    address!: string | undefined;
    /** 系统背景 */
    backgroundUrl!: string | undefined;
    /** 租户身份 */
    classes!: number | undefined;
    /** 联系电话 */
    contactNumber!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 域名地址 */
    domain!: string | undefined;
    /** 过期时间 */
    expireTime!: Date | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 授权码 */
    licenseKey!: string | undefined;
    /** 联系人 */
    linkman!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户编号 */
    tenantCode!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 租户名称 */
    tenantName!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.address = data["address"];
            this.backgroundUrl = data["backgroundUrl"];
            this.classes = data["classes"];
            this.contactNumber = data["contactNumber"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.domain = data["domain"];
            this.expireTime = data["expireTime"] ? new Date(data["expireTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.licenseKey = data["licenseKey"];
            this.linkman = data["linkman"];
            this.status = data["status"];
            this.tenantCode = data["tenantCode"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["address"] = this.address;
        data["backgroundUrl"] = this.backgroundUrl;
        data["classes"] = this.classes;
        data["contactNumber"] = this.contactNumber;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["domain"] = this.domain;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["licenseKey"] = this.licenseKey;
        data["linkman"] = this.linkman;
        data["status"] = this.status;
        data["tenantCode"] = this.tenantCode;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface ITenant {
    /** 账号额度 */
    accountNumber: number | undefined;
    /** 联系地址 */
    address: string | undefined;
    /** 系统背景 */
    backgroundUrl: string | undefined;
    /** 租户身份 */
    classes: number | undefined;
    /** 联系电话 */
    contactNumber: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 域名地址 */
    domain: string | undefined;
    /** 过期时间 */
    expireTime: Date | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 授权码 */
    licenseKey: string | undefined;
    /** 联系人 */
    linkman: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户编号 */
    tenantCode: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 租户名称 */
    tenantName: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** 租户APP管理 */
export class TenantApp implements ITenantApp {
    /** APP图标 */
    appAvatar!: string | undefined;
    /** appCode */
    appCode!: string | undefined;
    /** APP名称 */
    appDisplayName!: string | undefined;
    /** 业务菜单ids */
    bizMenuId!: string | undefined;
    deleted!: boolean | undefined;
    /** 过期时间 */
    expireTime!: Date | undefined;
    /** 是否过期 */
    expired!: boolean | undefined;
    /** 编号 */
    id!: string | undefined;
    sort!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: ITenantApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appAvatar = data["appAvatar"];
            this.appCode = data["appCode"];
            this.appDisplayName = data["appDisplayName"];
            this.bizMenuId = data["bizMenuId"];
            this.deleted = data["deleted"];
            this.expireTime = data["expireTime"] ? new Date(data["expireTime"].toString()) : <any>undefined;
            this.expired = data["expired"];
            this.id = data["id"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): TenantApp {
        data = typeof data === 'object' ? data : {};
        let result = new TenantApp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appAvatar"] = this.appAvatar;
        data["appCode"] = this.appCode;
        data["appDisplayName"] = this.appDisplayName;
        data["bizMenuId"] = this.bizMenuId;
        data["deleted"] = this.deleted;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : <any>undefined;
        data["expired"] = this.expired;
        data["id"] = this.id;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

/** 租户APP管理 */
export interface ITenantApp {
    /** APP图标 */
    appAvatar: string | undefined;
    /** appCode */
    appCode: string | undefined;
    /** APP名称 */
    appDisplayName: string | undefined;
    /** 业务菜单ids */
    bizMenuId: string | undefined;
    deleted: boolean | undefined;
    /** 过期时间 */
    expireTime: Date | undefined;
    /** 是否过期 */
    expired: boolean | undefined;
    /** 编号 */
    id: string | undefined;
    sort: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class TenantAppInfoVO implements ITenantAppInfoVO {
    /** appCode */
    appCode!: string | undefined;
    /** APP名称 */
    appDisplayName!: string | undefined;
    /** appId */
    appId!: string | undefined;

    constructor(data?: ITenantAppInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.appDisplayName = data["appDisplayName"];
            this.appId = data["appId"];
        }
    }

    static fromJS(data: any): TenantAppInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAppInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["appDisplayName"] = this.appDisplayName;
        data["appId"] = this.appId;
        return data; 
    }
}

export interface ITenantAppInfoVO {
    /** appCode */
    appCode: string | undefined;
    /** APP名称 */
    appDisplayName: string | undefined;
    /** appId */
    appId: string | undefined;
}

export class TenantAppMenuDTO implements ITenantAppMenuDTO {
    /** 操作按钮类型 */
    action!: number | undefined;
    /** 菜单别名 */
    alias!: string | undefined;
    /** 所属APP */
    appCode!: string | undefined;
    /** 菜单类型 */
    category!: number | undefined;
    /** 菜单编号 */
    code!: string | undefined;
    edition!: number | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 是否打开新页面 */
    isOpen!: number | undefined;
    /** 菜单名称 */
    name!: string | undefined;
    /** 菜单父主键 */
    parentId!: string | undefined;
    /** 请求地址 */
    path!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 菜单资源 */
    source!: string | undefined;

    constructor(data?: ITenantAppMenuDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"];
            this.alias = data["alias"];
            this.appCode = data["appCode"];
            this.category = data["category"];
            this.code = data["code"];
            this.edition = data["edition"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isOpen = data["isOpen"];
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.path = data["path"];
            this.remark = data["remark"];
            this.sort = data["sort"];
            this.source = data["source"];
        }
    }

    static fromJS(data: any): TenantAppMenuDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAppMenuDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["alias"] = this.alias;
        data["appCode"] = this.appCode;
        data["category"] = this.category;
        data["code"] = this.code;
        data["edition"] = this.edition;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isOpen"] = this.isOpen;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["path"] = this.path;
        data["remark"] = this.remark;
        data["sort"] = this.sort;
        data["source"] = this.source;
        return data; 
    }
}

export interface ITenantAppMenuDTO {
    /** 操作按钮类型 */
    action: number | undefined;
    /** 菜单别名 */
    alias: string | undefined;
    /** 所属APP */
    appCode: string | undefined;
    /** 菜单类型 */
    category: number | undefined;
    /** 菜单编号 */
    code: string | undefined;
    edition: number | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 是否打开新页面 */
    isOpen: number | undefined;
    /** 菜单名称 */
    name: string | undefined;
    /** 菜单父主键 */
    parentId: string | undefined;
    /** 请求地址 */
    path: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 菜单资源 */
    source: string | undefined;
}

export class TenantAppQueryDTO implements ITenantAppQueryDTO {
    appCodeList!: string[] | undefined;
    tenantId!: string;

    constructor(data?: ITenantAppQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["appCodeList"] && data["appCodeList"].constructor === Array) {
                this.appCodeList = [] as any;
                for (let item of data["appCodeList"])
                    this.appCodeList!.push(item);
            }
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): TenantAppQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAppQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.appCodeList && this.appCodeList.constructor === Array) {
            data["appCodeList"] = [];
            for (let item of this.appCodeList)
                data["appCodeList"].push(item);
        }
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ITenantAppQueryDTO {
    appCodeList: string[] | undefined;
    tenantId: string;
}

/** TenantAppVO对象 */
export class TenantAppVO implements ITenantAppVO {
    /** APP图标 */
    appAvatar!: string | undefined;
    /** appCode */
    appCode!: string | undefined;
    /** APP名称 */
    appDisplayName!: string | undefined;
    /** 业务菜单ids */
    bizMenuId!: string | undefined;
    deleted!: boolean | undefined;
    /** 过期时间 */
    expireTime!: Date | undefined;
    /** 是否过期 */
    expired!: boolean | undefined;
    /** 编号 */
    id!: string | undefined;
    /** 顺序 */
    sort!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: ITenantAppVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appAvatar = data["appAvatar"];
            this.appCode = data["appCode"];
            this.appDisplayName = data["appDisplayName"];
            this.bizMenuId = data["bizMenuId"];
            this.deleted = data["deleted"];
            this.expireTime = data["expireTime"] ? new Date(data["expireTime"].toString()) : <any>undefined;
            this.expired = data["expired"];
            this.id = data["id"];
            this.sort = data["sort"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): TenantAppVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAppVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appAvatar"] = this.appAvatar;
        data["appCode"] = this.appCode;
        data["appDisplayName"] = this.appDisplayName;
        data["bizMenuId"] = this.bizMenuId;
        data["deleted"] = this.deleted;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : <any>undefined;
        data["expired"] = this.expired;
        data["id"] = this.id;
        data["sort"] = this.sort;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

/** TenantAppVO对象 */
export interface ITenantAppVO {
    /** APP图标 */
    appAvatar: string | undefined;
    /** appCode */
    appCode: string | undefined;
    /** APP名称 */
    appDisplayName: string | undefined;
    /** 业务菜单ids */
    bizMenuId: string | undefined;
    deleted: boolean | undefined;
    /** 过期时间 */
    expireTime: Date | undefined;
    /** 是否过期 */
    expired: boolean | undefined;
    /** 编号 */
    id: string | undefined;
    /** 顺序 */
    sort: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class TenantBizDataTypeDTO implements ITenantBizDataTypeDTO {
    /** 业务数据类型id */
    bizDataId!: string;
    /** 业务数据类型名称 */
    bizDataName!: string;

    constructor(data?: ITenantBizDataTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizDataId = data["bizDataId"];
            this.bizDataName = data["bizDataName"];
        }
    }

    static fromJS(data: any): TenantBizDataTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBizDataTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizDataId"] = this.bizDataId;
        data["bizDataName"] = this.bizDataName;
        return data; 
    }
}

export interface ITenantBizDataTypeDTO {
    /** 业务数据类型id */
    bizDataId: string;
    /** 业务数据类型名称 */
    bizDataName: string;
}

export class TenantBizInitFieldDTO implements ITenantBizInitFieldDTO {
    /** 业务code */
    bizCode!: string;
    /** 业务数据类型字典： key: 类型ID value:类型名称 */
    dataIdList!: { [key: string] : string; } | undefined;

    constructor(data?: ITenantBizInitFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizCode = data["bizCode"];
            if (data["dataIdList"]) {
                this.dataIdList = {} as any;
                for (let key in data["dataIdList"]) {
                    if (data["dataIdList"].hasOwnProperty(key))
                        this.dataIdList![key] = data["dataIdList"][key];
                }
            }
        }
    }

    static fromJS(data: any): TenantBizInitFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBizInitFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizCode"] = this.bizCode;
        if (this.dataIdList) {
            data["dataIdList"] = {};
            for (let key in this.dataIdList) {
                if (this.dataIdList.hasOwnProperty(key))
                    data["dataIdList"][key] = this.dataIdList[key];
            }
        }
        return data; 
    }
}

export interface ITenantBizInitFieldDTO {
    /** 业务code */
    bizCode: string;
    /** 业务数据类型字典： key: 类型ID value:类型名称 */
    dataIdList: { [key: string] : string; } | undefined;
}

export class TenantCardSetting implements ITenantCardSetting {
    /** 卡片图片 */
    avatar!: string | undefined;
    /** 卡片位置坐标 */
    cardLocal!: string | undefined;
    /** 卡片标题 */
    cardName!: string | undefined;
    /** 卡片参数 */
    cardValue!: string | undefined;
    /** 组件key */
    componentKey!: string | undefined;
    /** 所属卡片 */
    id!: string | undefined;
    /** 状态值：0、无效,1、有效 */
    status!: number | undefined;

    constructor(data?: ITenantCardSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.cardLocal = data["cardLocal"];
            this.cardName = data["cardName"];
            this.cardValue = data["cardValue"];
            this.componentKey = data["componentKey"];
            this.id = data["id"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): TenantCardSetting {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCardSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["cardLocal"] = this.cardLocal;
        data["cardName"] = this.cardName;
        data["cardValue"] = this.cardValue;
        data["componentKey"] = this.componentKey;
        data["id"] = this.id;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITenantCardSetting {
    /** 卡片图片 */
    avatar: string | undefined;
    /** 卡片位置坐标 */
    cardLocal: string | undefined;
    /** 卡片标题 */
    cardName: string | undefined;
    /** 卡片参数 */
    cardValue: string | undefined;
    /** 组件key */
    componentKey: string | undefined;
    /** 所属卡片 */
    id: string | undefined;
    /** 状态值：0、无效,1、有效 */
    status: number | undefined;
}

export class TenantCardSettingDTO implements ITenantCardSettingDTO {
    /** 用户自定义卡片配置 */
    tenantCardSetting!: TenantCardSetting[] | undefined;

    constructor(data?: ITenantCardSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantCardSetting"] && data["tenantCardSetting"].constructor === Array) {
                this.tenantCardSetting = [] as any;
                for (let item of data["tenantCardSetting"])
                    this.tenantCardSetting!.push(TenantCardSetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantCardSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCardSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantCardSetting && this.tenantCardSetting.constructor === Array) {
            data["tenantCardSetting"] = [];
            for (let item of this.tenantCardSetting)
                data["tenantCardSetting"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantCardSettingDTO {
    /** 用户自定义卡片配置 */
    tenantCardSetting: TenantCardSetting[] | undefined;
}

export class TenantCommonSettingDTO implements ITenantCommonSettingDTO {
    /** 参数键 */
    paramKey!: string | undefined;
    /** 参数名 */
    paramName!: string | undefined;
    /** 参数值 */
    paramValue!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 租户id */
    tenantId!: string | undefined;

    constructor(data?: ITenantCommonSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paramKey = data["paramKey"];
            this.paramName = data["paramName"];
            this.paramValue = data["paramValue"];
            this.remark = data["remark"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): TenantCommonSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCommonSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paramKey"] = this.paramKey;
        data["paramName"] = this.paramName;
        data["paramValue"] = this.paramValue;
        data["remark"] = this.remark;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ITenantCommonSettingDTO {
    /** 参数键 */
    paramKey: string | undefined;
    /** 参数名 */
    paramName: string | undefined;
    /** 参数值 */
    paramValue: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 租户id */
    tenantId: string | undefined;
}

export class TenantCustomBizFieldBO implements ITenantCustomBizFieldBO {
    /** 业务编号 产品 计划等 */
    bizCode!: string | undefined;
    /** 字段编号 */
    code!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 默认是否显示：0-不显示，1-显示 */
    isDisplay!: number | undefined;
    /** 默认是否必填：0-不必填，1-必填 */
    isRequired!: number | undefined;
    /** 是否系统字段：0-不是，1-是 */
    isSystem!: number | undefined;
    /** 默认排序 */
    sort!: number | undefined;
    /** 默认提示信息 */
    tip!: string | undefined;
    /** 字段名称 */
    title!: string | undefined;
    /** 字段类型 */
    type!: number | undefined;

    constructor(data?: ITenantCustomBizFieldBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizCode = data["bizCode"];
            this.code = data["code"];
            this.id = data["id"];
            this.isDisplay = data["isDisplay"];
            this.isRequired = data["isRequired"];
            this.isSystem = data["isSystem"];
            this.sort = data["sort"];
            this.tip = data["tip"];
            this.title = data["title"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): TenantCustomBizFieldBO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCustomBizFieldBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizCode"] = this.bizCode;
        data["code"] = this.code;
        data["id"] = this.id;
        data["isDisplay"] = this.isDisplay;
        data["isRequired"] = this.isRequired;
        data["isSystem"] = this.isSystem;
        data["sort"] = this.sort;
        data["tip"] = this.tip;
        data["title"] = this.title;
        data["type"] = this.type;
        return data; 
    }
}

export interface ITenantCustomBizFieldBO {
    /** 业务编号 产品 计划等 */
    bizCode: string | undefined;
    /** 字段编号 */
    code: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 默认是否显示：0-不显示，1-显示 */
    isDisplay: number | undefined;
    /** 默认是否必填：0-不必填，1-必填 */
    isRequired: number | undefined;
    /** 是否系统字段：0-不是，1-是 */
    isSystem: number | undefined;
    /** 默认排序 */
    sort: number | undefined;
    /** 默认提示信息 */
    tip: string | undefined;
    /** 字段名称 */
    title: string | undefined;
    /** 字段类型 */
    type: number | undefined;
}

export class TenantCustomBizFieldUpdateDTO implements ITenantCustomBizFieldUpdateDTO {
    /** 自定义字段ID */
    id!: string;
    /** 默认是否显示：0-不显示，1-显示 */
    isDisplay!: number;
    /**  默认是否必填：0-不必填，1-必填 */
    isRequired!: number;
    /** 是否系统字段：0-不是，1-是 */
    isSystem!: number;
    /** 默认排序 */
    sort!: number;
    /** 默认提示信息 */
    tip!: string | undefined;
    /** 字段名称 */
    title!: string;
    /** 字段类型 */
    type!: number;

    constructor(data?: ITenantCustomBizFieldUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isDisplay = data["isDisplay"];
            this.isRequired = data["isRequired"];
            this.isSystem = data["isSystem"];
            this.sort = data["sort"];
            this.tip = data["tip"];
            this.title = data["title"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): TenantCustomBizFieldUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCustomBizFieldUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDisplay"] = this.isDisplay;
        data["isRequired"] = this.isRequired;
        data["isSystem"] = this.isSystem;
        data["sort"] = this.sort;
        data["tip"] = this.tip;
        data["title"] = this.title;
        data["type"] = this.type;
        return data; 
    }
}

export interface ITenantCustomBizFieldUpdateDTO {
    /** 自定义字段ID */
    id: string;
    /** 默认是否显示：0-不显示，1-显示 */
    isDisplay: number;
    /**  默认是否必填：0-不必填，1-必填 */
    isRequired: number;
    /** 是否系统字段：0-不是，1-是 */
    isSystem: number;
    /** 默认排序 */
    sort: number;
    /** 默认提示信息 */
    tip: string | undefined;
    /** 字段名称 */
    title: string;
    /** 字段类型 */
    type: number;
}

/** 租户扩展个性化 */
export class TenantExtend implements ITenantExtend {
    /** banner */
    bannerLogo!: string | undefined;
    /** 编号 */
    id!: string | undefined;
    /** 登录页背景图 */
    loginImage!: string | undefined;
    /** 登录页Logo */
    loginLogo!: string | undefined;
    /** 标语 */
    loginSlogan!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 主题Code */
    themeCode!: string | undefined;
    /** 迁移日期 */
    transferDate!: Date | undefined;

    constructor(data?: ITenantExtend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bannerLogo = data["bannerLogo"];
            this.id = data["id"];
            this.loginImage = data["loginImage"];
            this.loginLogo = data["loginLogo"];
            this.loginSlogan = data["loginSlogan"];
            this.tenantId = data["tenantId"];
            this.themeCode = data["themeCode"];
            this.transferDate = data["transferDate"] ? new Date(data["transferDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantExtend {
        data = typeof data === 'object' ? data : {};
        let result = new TenantExtend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bannerLogo"] = this.bannerLogo;
        data["id"] = this.id;
        data["loginImage"] = this.loginImage;
        data["loginLogo"] = this.loginLogo;
        data["loginSlogan"] = this.loginSlogan;
        data["tenantId"] = this.tenantId;
        data["themeCode"] = this.themeCode;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        return data; 
    }
}

/** 租户扩展个性化 */
export interface ITenantExtend {
    /** banner */
    bannerLogo: string | undefined;
    /** 编号 */
    id: string | undefined;
    /** 登录页背景图 */
    loginImage: string | undefined;
    /** 登录页Logo */
    loginLogo: string | undefined;
    /** 标语 */
    loginSlogan: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 主题Code */
    themeCode: string | undefined;
    /** 迁移日期 */
    transferDate: Date | undefined;
}

/** TenantExtendVO对象 */
export class TenantExtendVO implements ITenantExtendVO {
    /** banner */
    bannerLogo!: string | undefined;
    /** 是否是默认配置 */
    defaultSetting!: boolean | undefined;
    /** 编号 */
    id!: string | undefined;
    /** 登录页背景图 */
    loginImage!: string | undefined;
    /** 登录页Logo */
    loginLogo!: string | undefined;
    /** 标语 */
    loginSlogan!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 主题Code */
    themeCode!: string | undefined;
    /** 迁移日期 */
    transferDate!: Date | undefined;

    constructor(data?: ITenantExtendVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bannerLogo = data["bannerLogo"];
            this.defaultSetting = data["defaultSetting"];
            this.id = data["id"];
            this.loginImage = data["loginImage"];
            this.loginLogo = data["loginLogo"];
            this.loginSlogan = data["loginSlogan"];
            this.tenantId = data["tenantId"];
            this.themeCode = data["themeCode"];
            this.transferDate = data["transferDate"] ? new Date(data["transferDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantExtendVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantExtendVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bannerLogo"] = this.bannerLogo;
        data["defaultSetting"] = this.defaultSetting;
        data["id"] = this.id;
        data["loginImage"] = this.loginImage;
        data["loginLogo"] = this.loginLogo;
        data["loginSlogan"] = this.loginSlogan;
        data["tenantId"] = this.tenantId;
        data["themeCode"] = this.themeCode;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        return data; 
    }
}

/** TenantExtendVO对象 */
export interface ITenantExtendVO {
    /** banner */
    bannerLogo: string | undefined;
    /** 是否是默认配置 */
    defaultSetting: boolean | undefined;
    /** 编号 */
    id: string | undefined;
    /** 登录页背景图 */
    loginImage: string | undefined;
    /** 登录页Logo */
    loginLogo: string | undefined;
    /** 标语 */
    loginSlogan: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 主题Code */
    themeCode: string | undefined;
    /** 迁移日期 */
    transferDate: Date | undefined;
}

/** TenantGatewayVO对象 */
export class TenantGatewayVO implements ITenantGatewayVO {
    /** 编号 */
    code!: string | undefined;
    /** 网关ID */
    gatewayId!: string | undefined;
    /** ID */
    id!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: ITenantGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.gatewayId = data["gatewayId"];
            this.id = data["id"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): TenantGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["gatewayId"] = this.gatewayId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

/** TenantGatewayVO对象 */
export interface ITenantGatewayVO {
    /** 编号 */
    code: string | undefined;
    /** 网关ID */
    gatewayId: string | undefined;
    /** ID */
    id: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class TenantInitialFieldDTO implements ITenantInitialFieldDTO {
    /** 业务编号 */
    bizCode!: string;
    /** 字段编号 */
    code!: string;
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 默认是否显示 */
    isDisplay!: number;
    /** 默认是否必填 */
    isRequired!: number;
    /** 是否系统字段 */
    isSystem!: number;
    /** 默认提示信息 */
    sort!: string | undefined;
    /** 是否已删除 */
    status!: number | undefined;
    /** 默认提示信息 */
    tip!: string;
    /** 字段名称 */
    title!: string;
    /** 字段类型 */
    type!: number;

    constructor(data?: ITenantInitialFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizCode = data["bizCode"];
            this.code = data["code"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isDisplay = data["isDisplay"];
            this.isRequired = data["isRequired"];
            this.isSystem = data["isSystem"];
            this.sort = data["sort"];
            this.status = data["status"];
            this.tip = data["tip"];
            this.title = data["title"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): TenantInitialFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInitialFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizCode"] = this.bizCode;
        data["code"] = this.code;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isDisplay"] = this.isDisplay;
        data["isRequired"] = this.isRequired;
        data["isSystem"] = this.isSystem;
        data["sort"] = this.sort;
        data["status"] = this.status;
        data["tip"] = this.tip;
        data["title"] = this.title;
        data["type"] = this.type;
        return data; 
    }
}

export interface ITenantInitialFieldDTO {
    /** 业务编号 */
    bizCode: string;
    /** 字段编号 */
    code: string;
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 默认是否显示 */
    isDisplay: number;
    /** 默认是否必填 */
    isRequired: number;
    /** 是否系统字段 */
    isSystem: number;
    /** 默认提示信息 */
    sort: string | undefined;
    /** 是否已删除 */
    status: number | undefined;
    /** 默认提示信息 */
    tip: string;
    /** 字段名称 */
    title: string;
    /** 字段类型 */
    type: number;
}

export class TenantInitialFieldTypeDTO implements ITenantInitialFieldTypeDTO {
    /** 业务编号 产品 计划等 */
    bizCode!: string;
    /** 主键 */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 字段名称 */
    title!: string;
    /** 业务类型 */
    type!: number;

    constructor(data?: ITenantInitialFieldTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizCode = data["bizCode"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.remark = data["remark"];
            this.title = data["title"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): TenantInitialFieldTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInitialFieldTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizCode"] = this.bizCode;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["remark"] = this.remark;
        data["title"] = this.title;
        data["type"] = this.type;
        return data; 
    }
}

export interface ITenantInitialFieldTypeDTO {
    /** 业务编号 产品 计划等 */
    bizCode: string;
    /** 主键 */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 字段名称 */
    title: string;
    /** 业务类型 */
    type: number;
}

/** 租户用户级设置 */
export class TenantSetting implements ITenantSetting {
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 参数键 */
    paramKey!: string | undefined;
    /** 参数名 */
    paramName!: string | undefined;
    /** 参数值 */
    paramValue!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户编号 */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;
    /** 用户ID */
    userId!: string | undefined;

    constructor(data?: ITenantSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.paramKey = data["paramKey"];
            this.paramName = data["paramName"];
            this.paramValue = data["paramValue"];
            this.remark = data["remark"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): TenantSetting {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["paramKey"] = this.paramKey;
        data["paramName"] = this.paramName;
        data["paramValue"] = this.paramValue;
        data["remark"] = this.remark;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        data["userId"] = this.userId;
        return data; 
    }
}

/** 租户用户级设置 */
export interface ITenantSetting {
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 参数键 */
    paramKey: string | undefined;
    /** 参数名 */
    paramName: string | undefined;
    /** 参数值 */
    paramValue: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户编号 */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
    /** 用户ID */
    userId: string | undefined;
}

export class TenantSettingDTO implements ITenantSettingDTO {
    /** 账号额度 */
    accountNumber!: number | undefined;
    /** 过期时间 */
    expireTime!: Date | undefined;
    /** 主键集合 */
    ids!: string;

    constructor(data?: ITenantSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.expireTime = data["expireTime"] ? new Date(data["expireTime"].toString()) : <any>undefined;
            this.ids = data["ids"];
        }
    }

    static fromJS(data: any): TenantSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : <any>undefined;
        data["ids"] = this.ids;
        return data; 
    }
}

export interface ITenantSettingDTO {
    /** 账号额度 */
    accountNumber: number | undefined;
    /** 过期时间 */
    expireTime: Date | undefined;
    /** 主键集合 */
    ids: string;
}

/** 租户用户级设置 */
export class TenantSettingDetailVO implements ITenantSettingDetailVO {
    /** 主键Id */
    id!: string | undefined;
    /** 参数键 */
    paramKey!: string | undefined;
    /** 参数名 */
    paramName!: string | undefined;
    /** 参数值 */
    paramValue!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 租户编号 */
    tenantId!: string | undefined;

    constructor(data?: ITenantSettingDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.paramKey = data["paramKey"];
            this.paramName = data["paramName"];
            this.paramValue = data["paramValue"];
            this.remark = data["remark"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): TenantSettingDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paramKey"] = this.paramKey;
        data["paramName"] = this.paramName;
        data["paramValue"] = this.paramValue;
        data["remark"] = this.remark;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

/** 租户用户级设置 */
export interface ITenantSettingDetailVO {
    /** 主键Id */
    id: string | undefined;
    /** 参数键 */
    paramKey: string | undefined;
    /** 参数名 */
    paramName: string | undefined;
    /** 参数值 */
    paramValue: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 租户编号 */
    tenantId: string | undefined;
}

/** TenantSettingVO对象 */
export class TenantSettingVO implements ITenantSettingVO {
    /** 卡片图片地址 */
    avatar!: string | undefined;
    /** 卡片坐标位置 */
    cardLocal!: string | undefined;
    /** 卡片标题 */
    cardName!: string | undefined;
    /** 卡片参数 */
    cardValue!: string | undefined;
    /** 组件key */
    componentKey!: string | undefined;
    /** 所属卡片 */
    id!: string | undefined;
    /** 状态值：0、无效,1、有效 */
    status!: number | undefined;

    constructor(data?: ITenantSettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.cardLocal = data["cardLocal"];
            this.cardName = data["cardName"];
            this.cardValue = data["cardValue"];
            this.componentKey = data["componentKey"];
            this.id = data["id"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): TenantSettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["cardLocal"] = this.cardLocal;
        data["cardName"] = this.cardName;
        data["cardValue"] = this.cardValue;
        data["componentKey"] = this.componentKey;
        data["id"] = this.id;
        data["status"] = this.status;
        return data; 
    }
}

/** TenantSettingVO对象 */
export interface ITenantSettingVO {
    /** 卡片图片地址 */
    avatar: string | undefined;
    /** 卡片坐标位置 */
    cardLocal: string | undefined;
    /** 卡片标题 */
    cardName: string | undefined;
    /** 卡片参数 */
    cardValue: string | undefined;
    /** 组件key */
    componentKey: string | undefined;
    /** 所属卡片 */
    id: string | undefined;
    /** 状态值：0、无效,1、有效 */
    status: number | undefined;
}

export class TenantSettingsVO implements ITenantSettingsVO {
    /** 参数键 */
    paramKey!: string | undefined;
    /** 参数名 */
    paramName!: string | undefined;
    /** 参数值 */
    paramValue!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 租户id */
    tenantId!: string | undefined;

    constructor(data?: ITenantSettingsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paramKey = data["paramKey"];
            this.paramName = data["paramName"];
            this.paramValue = data["paramValue"];
            this.remark = data["remark"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): TenantSettingsVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paramKey"] = this.paramKey;
        data["paramName"] = this.paramName;
        data["paramValue"] = this.paramValue;
        data["remark"] = this.remark;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ITenantSettingsVO {
    /** 参数键 */
    paramKey: string | undefined;
    /** 参数名 */
    paramName: string | undefined;
    /** 参数值 */
    paramValue: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 租户id */
    tenantId: string | undefined;
}

export class TenantVO implements ITenantVO {
    /** 账号额度 */
    accountNumber!: number | undefined;
    /** 联系地址 */
    address!: string | undefined;
    /** 系统背景 */
    backgroundUrl!: string | undefined;
    /** 租户身份 */
    classes!: number | undefined;
    /** 联系电话 */
    contactNumber!: string | undefined;
    /** 域名地址 */
    domain!: string | undefined;
    /** 过期时间 */
    expireTime!: Date | undefined;
    /** 联系人 */
    linkman!: string | undefined;
    /** 租户编号 */
    tenantCode!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 租户名称 */
    tenantName!: string | undefined;

    constructor(data?: ITenantVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.address = data["address"];
            this.backgroundUrl = data["backgroundUrl"];
            this.classes = data["classes"];
            this.contactNumber = data["contactNumber"];
            this.domain = data["domain"];
            this.expireTime = data["expireTime"] ? new Date(data["expireTime"].toString()) : <any>undefined;
            this.linkman = data["linkman"];
            this.tenantCode = data["tenantCode"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): TenantVO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["address"] = this.address;
        data["backgroundUrl"] = this.backgroundUrl;
        data["classes"] = this.classes;
        data["contactNumber"] = this.contactNumber;
        data["domain"] = this.domain;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : <any>undefined;
        data["linkman"] = this.linkman;
        data["tenantCode"] = this.tenantCode;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface ITenantVO {
    /** 账号额度 */
    accountNumber: number | undefined;
    /** 联系地址 */
    address: string | undefined;
    /** 系统背景 */
    backgroundUrl: string | undefined;
    /** 租户身份 */
    classes: number | undefined;
    /** 联系电话 */
    contactNumber: string | undefined;
    /** 域名地址 */
    domain: string | undefined;
    /** 过期时间 */
    expireTime: Date | undefined;
    /** 联系人 */
    linkman: string | undefined;
    /** 租户编号 */
    tenantCode: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 租户名称 */
    tenantName: string | undefined;
}

export class TopMenu implements ITopMenu {
    /** 顶部菜单编号 */
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 顶部菜单名 */
    name!: string | undefined;
    /** 顶部菜单排序 */
    sort!: number | undefined;
    /** 顶部菜单资源 */
    source!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: ITopMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.sort = data["sort"];
            this.source = data["source"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): TopMenu {
        data = typeof data === 'object' ? data : {};
        let result = new TopMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["sort"] = this.sort;
        data["source"] = this.source;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface ITopMenu {
    /** 顶部菜单编号 */
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 顶部菜单名 */
    name: string | undefined;
    /** 顶部菜单排序 */
    sort: number | undefined;
    /** 顶部菜单资源 */
    source: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class TreeNode implements ITreeNode {
    children!: TreeNode[] | undefined;
    hasChildren!: boolean | undefined;
    id!: string | undefined;
    key!: string | undefined;
    parentId!: string | undefined;
    title!: string | undefined;
    value!: string | undefined;

    constructor(data?: ITreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(TreeNode.fromJS(item));
            }
            this.hasChildren = data["hasChildren"];
            this.id = data["id"];
            this.key = data["key"];
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["hasChildren"] = this.hasChildren;
        data["id"] = this.id;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITreeNode {
    children: TreeNode[] | undefined;
    hasChildren: boolean | undefined;
    id: string | undefined;
    key: string | undefined;
    parentId: string | undefined;
    title: string | undefined;
    value: string | undefined;
}

export class UpdateTenantDTO implements IUpdateTenantDTO {
    /** 联系地址 */
    address!: string | undefined;
    /** 租户身份 */
    classes!: number | undefined;
    /** 联系电话 */
    contactNumber!: string | undefined;
    id!: string | undefined;
    /** 联系人 */
    linkman!: string | undefined;
    /** 租户编号 */
    tenantCode!: string | undefined;
    /** 租户Id */
    tenantId!: string | undefined;
    /** 租户名称 */
    tenantName!: string | undefined;

    constructor(data?: IUpdateTenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.classes = data["classes"];
            this.contactNumber = data["contactNumber"];
            this.id = data["id"];
            this.linkman = data["linkman"];
            this.tenantCode = data["tenantCode"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): UpdateTenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["classes"] = this.classes;
        data["contactNumber"] = this.contactNumber;
        data["id"] = this.id;
        data["linkman"] = this.linkman;
        data["tenantCode"] = this.tenantCode;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface IUpdateTenantDTO {
    /** 联系地址 */
    address: string | undefined;
    /** 租户身份 */
    classes: number | undefined;
    /** 联系电话 */
    contactNumber: string | undefined;
    id: string | undefined;
    /** 联系人 */
    linkman: string | undefined;
    /** 租户编号 */
    tenantCode: string | undefined;
    /** 租户Id */
    tenantId: string | undefined;
    /** 租户名称 */
    tenantName: string | undefined;
}

export class UserPublishRecordDTO implements IUserPublishRecordDTO {
    /** 发布内容 */
    content!: string | undefined;
    /** 是否首次查看(0：否，1：是) */
    firstReview!: number | undefined;
    /** 发布时间 */
    publishDate!: Date | undefined;
    /** 发布版本 */
    version!: string | undefined;

    constructor(data?: IUserPublishRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.content = data["content"];
            this.firstReview = data["firstReview"];
            this.publishDate = data["publishDate"] ? new Date(data["publishDate"].toString()) : <any>undefined;
            this.version = data["version"];
        }
    }

    static fromJS(data: any): UserPublishRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserPublishRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["firstReview"] = this.firstReview;
        data["publishDate"] = this.publishDate ? formatDate(this.publishDate) : <any>undefined;
        data["version"] = this.version;
        return data; 
    }
}

export interface IUserPublishRecordDTO {
    /** 发布内容 */
    content: string | undefined;
    /** 是否首次查看(0：否，1：是) */
    firstReview: number | undefined;
    /** 发布时间 */
    publishDate: Date | undefined;
    /** 发布版本 */
    version: string | undefined;
}

export class UserVO implements IUserVO {
    account!: string | undefined;
    avatar!: string | undefined;
    birthday!: Date | undefined;
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    deptId!: string | undefined;
    deptName!: string | undefined;
    email!: string | undefined;
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    name!: string | undefined;
    organizationId!: string | undefined;
    password!: string | undefined;
    phone!: string | undefined;
    postId!: string | undefined;
    postName!: string | undefined;
    realName!: string | undefined;
    roleId!: string | undefined;
    roleName!: string | undefined;
    sex!: number | undefined;
    sexName!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    tenantName!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"];
            this.avatar = data["avatar"];
            this.birthday = data["birthday"] ? new Date(data["birthday"].toString()) : <any>undefined;
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.deptId = data["deptId"];
            this.deptName = data["deptName"];
            this.email = data["email"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.organizationId = data["organizationId"];
            this.password = data["password"];
            this.phone = data["phone"];
            this.postId = data["postId"];
            this.postName = data["postName"];
            this.realName = data["realName"];
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.sex = data["sex"];
            this.sexName = data["sexName"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): UserVO {
        data = typeof data === 'object' ? data : {};
        let result = new UserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["avatar"] = this.avatar;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["deptId"] = this.deptId;
        data["deptName"] = this.deptName;
        data["email"] = this.email;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["password"] = this.password;
        data["phone"] = this.phone;
        data["postId"] = this.postId;
        data["postName"] = this.postName;
        data["realName"] = this.realName;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["sex"] = this.sex;
        data["sexName"] = this.sexName;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IUserVO {
    account: string | undefined;
    avatar: string | undefined;
    birthday: Date | undefined;
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    deptId: string | undefined;
    deptName: string | undefined;
    email: string | undefined;
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    name: string | undefined;
    organizationId: string | undefined;
    password: string | undefined;
    phone: string | undefined;
    postId: string | undefined;
    postName: string | undefined;
    realName: string | undefined;
    roleId: string | undefined;
    roleName: string | undefined;
    sex: number | undefined;
    sexName: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    tenantName: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}